var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __reflectGet = Reflect.get;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __superGet = (cls, obj, key) => __reflectGet(__getProtoOf(cls), key, obj);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/endpoints/base.ts
import { addMinutes } from "date-fns";
import format from "date-fns/format";

// src/utils/log.ts
var lastToken = "";
function logHttpie(endpointUrl, request, logHeadersOriginal) {
  const logHeaders = __spreadValues({}, logHeadersOriginal);
  if (logHeaders["Authorization"]) {
    if (lastToken !== logHeaders["Authorization"]) {
      lastToken = logHeaders["Authorization"];
      console.log(`LAST_AUTH_TOKEN='${lastToken}'`);
    }
    logHeaders["Authorization"] = "$LAST_AUTH_TOKEN";
  }
  console.log(
    `
# Run inside api-client: ${request.method} ${endpointUrl}
http ${request.method} ${endpointUrl} ${Object.entries(logHeaders).map(([key, val]) => `"${key}:${val}"`).join(" ")} ${typeof request.body !== "undefined" ? Object.entries(JSON.parse(request.body)).map(
      ([key, val]) => typeof val === "string" ? `${key}="${val}"` : `${key}:='${JSON.stringify(val)}'`
    ).join(" ") : ""}
`
  );
}

// src/endpoints/response/ApiClientError.ts
var ApiClientError = class _ApiClientError extends Error {
  constructor(m) {
    super(m);
    Object.setPrototypeOf(this, _ApiClientError.prototype);
    this.constructor = _ApiClientError;
    this.message = m;
  }
  getHumanError() {
    if (this.response) {
      if (this.response.result && this.response.result.errors) {
        return Object.keys(this.response.result.errors).map((k) => {
          var _a, _b;
          return (_b = (_a = this.response.result) == null ? void 0 : _a.errors) == null ? void 0 : _b[k];
        }).join("\n");
      } else if (this.response.originalBody) {
        return this.response.originalBody;
      }
    }
    return `Unknown error`;
  }
};

// src/endpoints/response/response_with_status.ts
var ResponseWithStatus = class _ResponseWithStatus {
  constructor(status, result, originalBody = "") {
    this.authError = status === 401 || status === 403;
    this.error = this.authError || status >= 400;
    this.ok = !this.error;
    this.result = result;
    this.status = status;
    this.originalBody = originalBody;
  }
  static Create(status, body) {
    let result = null;
    let originalBody = null;
    try {
      result = JSON.parse(body);
    } catch (_) {
      result = null;
      originalBody = body;
    }
    return new _ResponseWithStatus(status, result, originalBody);
  }
  static CreateFromResult(result, status = 200) {
    return new _ResponseWithStatus(status, result);
  }
};

// src/endpoints/base.ts
var CORE_PATH_URLS = [
  // /v{:digit}+/ ie. /v1/divisions
  /^\/v(\d)+\//
];
function isCoreUrl(pathname) {
  return CORE_PATH_URLS.findIndex(
    (x) => typeof x === "string" ? pathname.startsWith(x) : x.test(pathname)
  ) > -1;
}
var isTacticApiProxyEnabled = () => {
  return typeof window !== "undefined" && "__tacticApiProxy__" in window;
};
var _BaseEndpoints = class _BaseEndpoints {
  constructor(settings, organizationSlug, isIntegrations = false, id = "") {
    this.id = "base";
    this.pendingRequests = {};
    this.settings = settings;
    this.organizationSlug = organizationSlug;
    this.isIntegrations = isIntegrations;
    this.id = id;
    if (settings.legacyAuth && !settings.urlCore) {
      throw new Error("If legacyAuth is used, urlCore should be defined");
    }
  }
  getSlug() {
    return this.organizationSlug;
  }
  getBaseUrl() {
    return this.settings.url;
  }
  getAccessToken() {
    var _a, _b, _c;
    return (_c = (_b = (_a = this.settings) == null ? void 0 : _a.legacyAuth) == null ? void 0 : _b.access) != null ? _c : null;
  }
  createPeriod(start, duration, time_zone) {
    const startDate = new Date(start);
    const endDate = addMinutes(startDate, duration);
    const period = {
      start: this.createDateTimeWithTimeZone(startDate),
      end: this.createDateTimeWithTimeZone(endDate),
      time_zone
    };
    return period;
  }
  createDateTimeWithTimeZone(date) {
    return `${format(date, _BaseEndpoints.DATE_FORMAT)}T${format(date, _BaseEndpoints.TIME_FORMAT)}.000Z`;
  }
  formatGenericParams(params = {}) {
    const urlParams = new URLSearchParams();
    for (const [key, val] of Object.entries(params)) {
      if (Array.isArray(val)) {
        val.forEach((x) => {
          urlParams.append(key, x.toString());
        });
      } else if (typeof val === "boolean" && val) {
        urlParams.append(key, "");
      } else if (val) {
        urlParams.set(key, val.toString());
      }
    }
    return urlParams;
  }
  addGenericParamsToUrl(url, params = {}) {
    const formatted = this.formatGenericParams(params);
    const urlParams = formatted.toString();
    if (urlParams.toString() !== "") {
      return `${url}?${urlParams}`;
    }
    return url;
  }
  requestWithStatus(_0, _1) {
    return __async(this, arguments, function* (method, url, body = null, customSettings = {}) {
      if (isTacticApiProxyEnabled()) {
        return new Promise((resolve, reject) => {
          const requestId = `req_${Date.now()}_${Math.random()}`;
          if (!window.__tacticPendingRequests__) {
            window.__tacticPendingRequests__ = {};
          }
          window.__tacticPendingRequests__[requestId] = {
            resolve: (data) => {
              resolve(data);
              window.__tacticPendingRequests__[requestId] = null;
              delete window.__tacticPendingRequests__[requestId];
            },
            reject: (data) => {
              reject(data);
              window.__tacticPendingRequests__[requestId] = null;
              delete window.__tacticPendingRequests__[requestId];
            }
          };
          window.__tacticApiProxy__({
            requestId,
            method,
            url,
            body,
            api: this.id
          });
        });
      }
      const _a = customSettings, { legacyAuth } = _a, rest = __objRest(_a, ["legacyAuth"]);
      const settings = __spreadValues(__spreadValues({}, this.settings), rest);
      if (legacyAuth) {
        settings.legacyAuth = __spreadValues(__spreadValues({}, settings.legacyAuth), legacyAuth);
      }
      const headers = {
        "Content-Type": "application/json"
      };
      if (this.organizationSlug !== null) {
        headers["X-Tactic-Orgz"] = this.organizationSlug;
      }
      if (settings.corsBypass) {
        headers["X-Tactic-Cors-Bypass"] = settings.corsBypass;
      }
      if (settings.legacyAuth) {
        headers["Authorization"] = `Bearer ${settings.legacyAuth.access}`;
        if (settings.legacyAuth.impersonation !== null) {
          headers["X-Tactic-Impersonation"] = settings.legacyAuth.impersonation;
        }
      }
      if (settings.adminAuth) {
        if (settings.adminAuth.organizationId) {
          headers["X-Tactic-Organization-Id"] = settings.adminAuth.organizationId;
        }
        if (settings.adminAuth.userEmail) {
          headers["X-Tactic-User-Email"] = settings.adminAuth.userEmail;
        }
        if (settings.adminAuth.userId) {
          headers["X-Tactic-User-Id"] = settings.adminAuth.userId;
        }
      }
      if (settings.authHeader) {
        headers["Authorization"] = settings.authHeader;
      }
      const request = {
        headers,
        method,
        credentials: "include"
      };
      if (body !== null) {
        request.body = typeof body !== "string" ? JSON.stringify(body) : body;
      }
      const endpointUrl = this.buildUrl(url, settings);
      const log = settings.debug && (method !== "GET" || settings.debugGet);
      let logHeaders = {};
      if (settings.debugAuth) {
        logHeaders = request.headers;
      }
      if (log) {
        if (settings.debugOutput === "httpie") {
          logHttpie(endpointUrl, request, logHeaders);
        } else {
          console.log(`${request.method} ${endpointUrl} request:`, {
            headers: logHeaders,
            body: typeof request.body !== "undefined" ? request.body : null
          });
        }
      }
      let response;
      let responseWithStatus;
      try {
        response = yield fetch(endpointUrl, request);
        responseWithStatus = ResponseWithStatus.Create(
          response.status,
          yield response.text()
        );
        if (!response.ok && !settings.notThrowWithInvalidResponses) {
          if (settings.onError !== void 0 && settings.onError !== null && settings.onError) {
            settings.onError(
              response.statusText,
              response.status,
              responseWithStatus
            );
          }
          const error = new ApiClientError(response.statusText);
          error.response = responseWithStatus;
          throw error;
        }
      } catch (error) {
        if (log) {
          console.error(`${request.method} ${endpointUrl} error:`, error);
        }
        if (
          // we don't want to send the error to the handler again
          !(error instanceof ApiClientError) && settings.onError !== void 0 && settings.onError !== null && settings.onError
        ) {
          settings.onError(error);
        }
        throw error;
      }
      return responseWithStatus;
    });
  }
  request(method, url, body = null, withStatus) {
    return __async(this, null, function* () {
      const response = yield this.requestWithStatus(
        method,
        url,
        body
      );
      return withStatus ? { status: response.status, json: response.result } : response.result;
    });
  }
  buildUrl(url, settings) {
    if (settings.legacyAuth || settings.adminAuth) {
      const base = isCoreUrl(url) ? settings.urlCore : settings.url;
      return `${base}${url}`;
    }
    if (this.isIntegrations) {
      return `${settings.url}/api/integrations${url}`;
    }
    return `${settings.url}/api${url}`;
  }
};
_BaseEndpoints.MAXIMUM_LIMIT = 2e3;
_BaseEndpoints.DATE_FORMAT = "yyyy-MM-dd";
_BaseEndpoints.TIME_FORMAT = "HH:mm:ss";
var BaseEndpoints = _BaseEndpoints;
var BasePublicEndpoints = class extends BaseEndpoints {
  constructor(settings) {
    super(settings, null, void 0, "public");
  }
};
var BaseUserEndpoints = class extends BaseEndpoints {
  constructor(settings) {
    super(settings, null, void 0, "users");
  }
};
var BaseSettingsEndpoints = class extends BaseEndpoints {
  constructor(settings, organizationSlug) {
    super(settings, organizationSlug, void 0, "settings");
  }
  get(url) {
    return this.requestWithStatus("GET", url);
  }
  update(url, body) {
    return this.requestWithStatus("PUT", url, body);
  }
  delete(url) {
    return this.requestWithStatus("DELETE", url);
  }
};
var BaseOrganizationEndpoints = class _BaseOrganizationEndpoints extends BaseEndpoints {
  constructor(settings, organizationSlug) {
    super(settings, organizationSlug, void 0, "organizations");
  }
  formatTree(tree, formatter) {
    const elements = [];
    for (const node of tree) {
      const children = [];
      if (node.children.length > 0) {
        for (const innerNode of node.children) {
          if (innerNode.children.length == 0) {
            children.push(formatter(innerNode, null));
          }
        }
      }
      if (children.length > 0) {
        elements.push(formatter(node, children));
      } else {
        elements.push(formatter(node, null));
      }
    }
    return elements;
  }
  getUrl(url) {
    const organizationSlug = this.getSlug();
    let domain = this.settings.domain;
    if (domain.startsWith("https://")) {
      domain = this.settings.domain.slice(8, domain.length);
    }
    return `${this.settings.protocol}://${organizationSlug}.${domain}/${url}`;
  }
  paginatedEndpointUrl(url, pagination) {
    if (!pagination) {
      return url;
    }
    return url + (url.indexOf("?") >= 0 ? "&" : "?") + "limit=" + (pagination.limit ? pagination.limit : _BaseOrganizationEndpoints.MAXIMUM_LIMIT) + (pagination.cursor !== null ? `&cursor=${encodeURIComponent(pagination.cursor)}` : "");
  }
};
var BaseIntegrationEndpoints = class extends BaseEndpoints {
  constructor(settings, organizationSlug) {
    super(settings, organizationSlug, true, "integrations");
  }
};
var BaseExternalsEndpoints = class extends BaseEndpoints {
  constructor(settings, organizationSlug) {
    super(settings, organizationSlug, false, "externals");
  }
};

// src/endpoints/activity.ts
var ACTIVITY_ENTITIES = [
  "resource",
  "schedule",
  "wifi_connection",
  "work_policy_use"
];
var ACTIVITY_ENTITIES_ACTIONS = {
  resource: ["add", "update"],
  schedule: ["add", "update"],
  wifi_connection: [
    "add",
    "delete",
    "update",
    "ping",
    "ping:session:add"
  ],
  work_policy_use: [
    "add",
    "delete",
    "respond:rejected",
    "respond:accepted"
  ]
};
var ActivityClient = class extends BaseOrganizationEndpoints {
  log(params) {
    return __async(this, null, function* () {
      const formatted = this.formatGenericParams(params);
      return this.requestWithStatus(
        "GET",
        `/actions?${formatted.toString()}`
      );
    });
  }
};

// src/endpoints/application.ts
var Application = class extends BaseOrganizationEndpoints {
  create(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        "/applications",
        body
      );
    });
  }
  update(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/applications/${id}`,
        body
      );
    });
  }
  delete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/applications/${id}`
      );
    });
  }
  get(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/applications/${id}`
      );
    });
  }
  all() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        "/applications"
      );
    });
  }
};

// src/types/core-integration-types/avigilon.types.ts
var AVIGILON_REGIONS = /* @__PURE__ */ ((AVIGILON_REGIONS2) => {
  AVIGILON_REGIONS2["US"] = "us";
  AVIGILON_REGIONS2["EU"] = "eu";
  return AVIGILON_REGIONS2;
})(AVIGILON_REGIONS || {});

// src/types/core-integration-types/core-integration.types.ts
var CoreIntegrationTypes = /* @__PURE__ */ ((CoreIntegrationTypes2) => {
  CoreIntegrationTypes2["avigilon"] = "avigilon";
  CoreIntegrationTypes2["microsoft"] = "microsoft";
  CoreIntegrationTypes2["google"] = "google";
  return CoreIntegrationTypes2;
})(CoreIntegrationTypes || {});

// src/endpoints/core-integrations.ts
var CORE_INTEGRATIONS_BASE_PATH = "/v1/integrations";
var CoreIntegrations = class extends BaseOrganizationEndpoints {
  create(type, payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `${CORE_INTEGRATIONS_BASE_PATH}/${type}`,
        payload
      );
    });
  }
  delete(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `${CORE_INTEGRATIONS_BASE_PATH}/${id}`
      );
    });
  }
  fetch(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `${CORE_INTEGRATIONS_BASE_PATH}/${id}`
      );
    });
  }
  update(id, payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `${CORE_INTEGRATIONS_BASE_PATH}/${id}`,
        payload
      );
    });
  }
  all() {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        CORE_INTEGRATIONS_BASE_PATH
      );
    });
  }
  isInstalled(type) {
    return __async(this, null, function* () {
      try {
        const allResponse = yield this.all();
        const { ok, result } = allResponse;
        if (!ok || !result) {
          return createErrorResult(
            "Error fetching all integrations",
            allResponse
          );
        }
        const integration = result.integrations.find((i) => i.type === type);
        if (!integration) {
          return createNotInstalledResult(type);
        }
        try {
          const fullIntegrationResponse = yield this.fetch(integration.id);
          if (!fullIntegrationResponse.ok) {
            return createErrorResult(
              "Error fetching full integration details",
              fullIntegrationResponse
            );
          }
          return {
            ok: true,
            isInstalled: true,
            fullIntegration: fullIntegrationResponse.result,
            id: integration.id
          };
        } catch (fetchError) {
          return createErrorResult(
            "Error fetching full integration details",
            fetchError
          );
        }
      } catch (allError) {
        return createErrorResult("Error fetching all integrations", allError);
      }
    });
  }
};
function createNotInstalledResult(type) {
  console.warn(`Integration not found: ${type}`);
  return {
    ok: true,
    isInstalled: false,
    fullIntegration: null,
    id: null
  };
}
function createErrorResult(message, error) {
  console.error(message, error);
  return {
    ok: false,
    isInstalled: false,
    fullIntegration: null,
    id: null
  };
}

// src/endpoints/avigilon.ts
var AVIGILON_ENTRIES_URL = "/v1/integrations/avigilon/entries";
var AvigilonClient = class _AvigilonClient extends CoreIntegrations {
  createAvigilonIntegration(payload) {
    return __async(this, null, function* () {
      return __superGet(_AvigilonClient.prototype, this, "create").call(this, "avigilon" /* avigilon */, payload);
    });
  }
  delete(id) {
    return __async(this, null, function* () {
      return __superGet(_AvigilonClient.prototype, this, "delete").call(this, id);
    });
  }
  updateAvigilonIntegration(id, payload) {
    return __async(this, null, function* () {
      return __superGet(_AvigilonClient.prototype, this, "update").call(this, id, payload);
    });
  }
  fetchAvigilonIntegration(id) {
    return __async(this, null, function* () {
      return __superGet(_AvigilonClient.prototype, this, "fetch").call(this, id);
    });
  }
  fetchOrganizations() {
    return __async(this, null, function* () {
      let res = null;
      try {
        res = __superGet(_AvigilonClient.prototype, this, "requestWithStatus").call(
          this,
          "GET",
          `${CORE_INTEGRATIONS_BASE_PATH}/avigilon/organizations`
        );
      } catch (e) {
        console.error(e);
        throw e;
      }
      return res;
    });
  }
  integrationIsInstalled() {
    return __async(this, null, function* () {
      return __superGet(_AvigilonClient.prototype, this, "isInstalled").call(
        this,
        "avigilon" /* avigilon */
      );
    });
  }
  fetchAvigilonExternalIds() {
    return __async(this, null, function* () {
      return __superGet(_AvigilonClient.prototype, this, "requestWithStatus").call(
        this,
        "GET",
        AVIGILON_ENTRIES_URL
      );
    });
  }
};

// src/endpoints/calendar.ts
var Calendar = class extends BaseOrganizationEndpoints {
  getOrganizationCalendar(authorization, organizationId, id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/organizations/${organizationId}/calendars/${id}`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  getCalendar(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus("GET", `/calendars/${id}`);
    });
  }
  getAuthorizationUrl(source, organizationId) {
    return `https://id.gettactic.com/enterprise/calendar/setup/${source}/${organizationId}`;
  }
  hasAuthorization(source) {
    return __async(this, null, function* () {
      const response = yield this.requestWithStatus(
        "GET",
        `/calendars/authorizations/has_valid?calendarSource=${source}`
      );
      return response.ok && response.result.has_authorization;
    });
  }
  getCalendarByResourceId(resourceId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/calendars/reference/${resourceId}`
      );
    });
  }
  fetchCalendarPending(authorization) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/calendars/pending`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  markCalendarProcessed(authorization, jobId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/calendars/pending/${jobId}`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  all(_0, _1, _2, _3) {
    return __async(this, arguments, function* (sources, types, integrationIds, includeAllResources, pagination = {
      cursor: null,
      limit: null
    }) {
      let url = "/calendars";
      const params = new URLSearchParams();
      if (sources !== null) {
        sources.forEach((e) => {
          params.append("calendarSource", e);
        });
      }
      if (types !== null) {
        types.forEach((e) => {
          params.append("calendarType", e);
        });
      }
      if (integrationIds !== null) {
        integrationIds.forEach((e) => {
          params.append("integrationId", e);
        });
      }
      if (includeAllResources) {
        params.append("include-all-resources", String(includeAllResources));
      }
      if (params.size > 0) {
        url += `?${params.toString()}`;
      }
      return this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl(url, pagination)
      );
    });
  }
  allSyncJobs(_0) {
    return __async(this, arguments, function* (calendarId, pagination = {
      cursor: null,
      limit: null
    }) {
      const url = `/calendars/${calendarId}/sync_jobs`;
      return this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl(url, pagination)
      );
    });
  }
  allForSync(authorization, organizationId, integrationIds, sources = null, types = null) {
    return __async(this, null, function* () {
      if (integrationIds.length === 0) {
        throw new Error("Missing integration IDs");
      }
      let url = `/calendars/${organizationId}/for_sync`;
      const params = new URLSearchParams();
      integrationIds.forEach((e) => {
        params.append("integrationId", e);
      });
      if (sources !== null) {
        sources.forEach((e) => {
          params.append("calendarSource", e);
        });
      }
      if (types !== null) {
        types.forEach((e) => {
          params.append("calendarType", e);
        });
      }
      url += `?${params.toString()}`;
      return this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl(url, {
          cursor: null,
          limit: `${integrationIds.length}`
        }),
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  createOrUpdateCalendar(id, body, slug = null) {
    return __async(this, null, function* () {
      const basePath = "/v1/calendars";
      return this.requestWithStatus(
        id !== null ? "PUT" : "POST",
        id !== null ? `${basePath}/${id}` : basePath,
        body
      );
    });
  }
  deauthorizeIntegration(integrationType) {
    return __async(this, null, function* () {
      if (integrationType !== "microsoft" /* microsoft */ && integrationType !== "google" /* google */) {
        throw new Error("Invalid integration type");
      }
      return this.requestWithStatus(
        "DELETE",
        `/v1/calendars/authorization/${integrationType}`
      );
    });
  }
  /**
   * @deprecated  Use createOrUpdateCalendar(body: CalendarCreateOrUpdateRequest)
   */
  createOrUpdate(organizationId, organizationSlug, source, type, referenceId, integrationId, isEnabled, isPullEnabled, isPushEnabled, id = null) {
    return this.createOrUpdateCalendar(id, {
      organization_id: organizationId,
      source,
      type,
      reference_id: referenceId,
      integration_id: integrationId,
      is_enabled: isEnabled,
      is_pull_enabled: isPullEnabled,
      is_push_enabled: isPushEnabled,
      sync_events: true,
      sync_leaves: false
    }, organizationSlug);
  }
  sync(authorization, organizationId, calendarId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        calendarId !== null ? `/organizations/${organizationId}/calendars/${calendarId}/sync` : `/organizations/${organizationId}/calendars/sync`,
        body,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  syncEventRequest(authorization, calendarId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/calendars/${calendarId}/events/requests/sync`,
        body,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  syncEventRequestGetForSyncing(authorization, organizationId = null) {
    return __async(this, null, function* () {
      const url = organizationId !== null ? `/calendars/events/requests/for_syncing?organization=${encodeURIComponent(organizationId)}` : `/calendars/events/requests/for_syncing`;
      return this.requestWithStatus("PUT", url, null, {
        authHeader: `Basic ${authorization}`
      });
    });
  }
  syncEvent(authorization, calendarId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/calendars/${calendarId}/events/sync`,
        body,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  syncEventCreation(authorization, calendarId, scheduleId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/calendars/${calendarId}/events/sync/schedules/${scheduleId}`,
        body,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  syncEventDeletion(authorization, calendarId, eventId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/calendars/${calendarId}/events/sync`,
        {
          event_id: eventId
        },
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  transform(authorization, organizationId, scheduleId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/calendars/${organizationId}/schedules/${scheduleId}/transform`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  fetchPending(authorization) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/calendars/schedules/updated/pending`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  markProcessed(authorization, organizationId, jobId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/calendars/${organizationId}/schedules/updated/${jobId}`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  syncLeave(authorization, calendarId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/calendars/${calendarId}/leave/sync`,
        body,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  createOrUpdateSyncJob(authorization, organizationId, calendarId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/${calendarId}/sync_jobs`,
        body,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  getSyncJobForSyncing(authorization, organizationId = null, calendarId = null, jobId = null, sources = null, types = null) {
    return __async(this, null, function* () {
      let url = organizationId !== null && calendarId !== null && jobId !== null ? `/organizations/${organizationId}/calendars/${calendarId}/sync_jobs/${jobId}/for_syncing` : organizationId !== null && calendarId !== null ? `/organizations/${organizationId}/calendars/${calendarId}/sync_jobs/for_syncing` : organizationId !== null ? `/organizations/${organizationId}/calendars/sync_jobs/for_syncing` : `/organizations/calendars/sync_jobs/for_syncing`;
      const params = new URLSearchParams();
      if (sources !== null) {
        sources.forEach((e) => {
          params.append("calendarSource", e);
        });
      }
      if (types !== null) {
        types.forEach((e) => {
          params.append("calendarType", e);
        });
      }
      url += `?${params.toString()}`;
      return this.requestWithStatus("PUT", url, null, {
        authHeader: `Basic ${authorization}`
      });
    });
  }
  markSyncJobAsSynced(authorization, organizationId, calendarId, jobId, syncToken, pageToken) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/${calendarId}/sync_jobs/${jobId}/synced`,
        { sync_token: syncToken, page_token: pageToken },
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markSyncJobAsFinished(authorization, organizationId, calendarId, jobId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/${calendarId}/sync_jobs/${jobId}/finished`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markSyncJobAsFailed(authorization, organizationId, calendarId, jobId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/${calendarId}/sync_jobs/${jobId}/failed`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  createOrUpdateAuthorization(authorization, organizationId, request) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/authorizations`,
        request,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  getAuthorizationForSyncing(authorization, organizationId, calendarSource, authorizationId = null) {
    return __async(this, null, function* () {
      const url = authorizationId !== null ? `/organizations/${organizationId}/calendars/authorizations/${authorizationId}/for_syncing?calendarSource=${encodeURIComponent(calendarSource)}` : `/organizations/${organizationId}/calendars/authorizations/for_syncing?calendarSource=${encodeURIComponent(calendarSource)}`;
      return this.requestWithStatus(
        "PUT",
        url,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markAuthorizationAsSynced(authorization, organizationId, authorizationId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/authorizations/${authorizationId}/synced`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markAuthorizationAsFailed(authorization, organizationId, authorizationId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/authorizations/${authorizationId}/failed`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  createOrUpdateAuthorizationIntent(authorization, organizationId, request) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/authorizations/intents`,
        request,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  getAuthorizationIntentForSyncing(authorization, organizationId, calendarSource) {
    return __async(this, null, function* () {
      let url = `/calendars/authorizations/intents/for_syncing?calendarSource=${encodeURIComponent(calendarSource)}`;
      if (organizationId !== null) {
        url += `&organization=${encodeURIComponent(organizationId)}`;
      }
      return this.requestWithStatus(
        "PUT",
        url,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markAuthorizationIntentAsChecked(authorization, organizationId, intentId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/authorizations/intents/${intentId}/checked`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  getListenerListening(authorization, organizationId, id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/organizations/${organizationId}/calendars/${id}/listeners/listening`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  createOrUpdateListener(authorization, organizationId, id, body, listenerId = null) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        listenerId !== null ? "PUT" : "POST",
        listenerId !== null ? `/organizations/${organizationId}/calendars/${id}/listeners/${listenerId}` : `/organizations/${organizationId}/calendars/${id}/listeners`,
        body,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markListenerAsStarted(authorization, organizationId, listenerId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/listeners/${listenerId}/started`,
        body,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  markListenerAsStopped(authorization, organizationId, listenerId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/listeners/${listenerId}/stopped`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  listenerNotified(authorization, organizationId, listenerId, token) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/listeners/${listenerId}/notified`,
        { token },
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  getForSyncCheck(authorization, organizationId = null, sources = null, types = null) {
    return __async(this, null, function* () {
      let url = organizationId !== null ? `/organizations/${organizationId}/calendars/for_sync_check` : `/calendars/for_sync_check`;
      const params = new URLSearchParams();
      if (sources !== null) {
        sources.forEach((e) => {
          params.append("calendarSource", e);
        });
      }
      if (types !== null) {
        types.forEach((e) => {
          params.append("calendarType", e);
        });
      }
      url += `?${params.toString()}`;
      return this.requestWithStatus("GET", url, null, {
        authHeader: `Basic ${authorization}`
      });
    });
  }
  markAsSyncChecked(authorization, organizationId, calendarId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/calendars/${calendarId}/sync_checked`,
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
};

// src/endpoints/divisions.ts
var BASE_PATH = "/v1/divisions";
var DivisionsClient = class extends BaseOrganizationEndpoints {
  create(payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", BASE_PATH, payload);
    });
  }
  delete(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus("DELETE", `${BASE_PATH}/${id}`);
    });
  }
  update(payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `${BASE_PATH}/${payload.id}`,
        payload
      );
    });
  }
  all(params) {
    return __async(this, null, function* () {
      const urlParams = this.formatGenericParams(params);
      return this.requestWithStatus(
        "GET",
        `${BASE_PATH}?${urlParams.toString()}`
      );
    });
  }
  withOffices(params, withFloors = false) {
    return __async(this, null, function* () {
      const urlParams = this.formatGenericParams(params);
      urlParams.set("return_type", "tree");
      if (withFloors) {
        urlParams.set("return_floors", "true");
      }
      return this.requestWithStatus(
        "GET",
        `${BASE_PATH}?${urlParams.toString()}`
      );
    });
  }
};

// src/endpoints/enterprises.ts
var Enterprises = class extends BaseOrganizationEndpoints {
  domains() {
    return __async(this, null, function* () {
      const response = yield this.requestWithStatus("GET", "/enterprise");
      return response;
    });
  }
  update_domains(domains) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("PUT", "/enterprise", {
        domains
      });
    });
  }
  /**
   * Generates and returns WorkOS links for both SSO and DSync setup
   */
  links() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        "/enterprise/links"
      );
    });
  }
  connections() {
    return __async(this, arguments, function* (pagination = {
      cursor: null,
      limit: null
    }) {
      const response = yield this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl("/enterprise/connections", pagination)
      );
      return response;
    });
  }
  directories() {
    return __async(this, arguments, function* (pagination = {
      cursor: null,
      limit: null
    }) {
      const response = yield this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl("/enterprise/directories", pagination)
      );
      return response;
    });
  }
};

// src/endpoints/externals.ts
var Externals = class extends BaseExternalsEndpoints {
  getExternalIds(object_id, object_type, type) {
    return __async(this, null, function* () {
      const params = new URLSearchParams({ object_id });
      if (object_type) {
        params.set("object_type", object_type);
      }
      if (type) {
        params.set("type", type);
      }
      const result = yield this.requestWithStatus(
        "GET",
        `/v1/externals?${params.toString()}`
      );
      return result;
    });
  }
  deleteExternalId(id) {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "DELETE",
        `/v1/externals/${id}`
      );
      return result;
    });
  }
  createExternalId(data) {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "POST",
        "/v1/externals",
        data
      );
      return result;
    });
  }
};

// src/endpoints/forms.ts
var Forms = class extends BaseOrganizationEndpoints {
  add(request) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", `/forms`, request);
    });
  }
  form(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/forms/${encodeURIComponent(id)}`
      );
    });
  }
};

// src/endpoints/health.ts
var Health = class extends BaseOrganizationEndpoints {
  scanVaccination(officeId, contents) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/offices/${officeId}/vaccinations/scan`,
        {
          contents
        }
      );
    });
  }
  scanTest(officeId, contents) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/offices/${officeId}/tests/scan`,
        { contents }
      );
    });
  }
  vaccines(officeId) {
    return __async(this, null, function* () {
      return officeId ? this.requestWithStatus(
        "GET",
        `/offices/${officeId}/vaccines`
      ) : this.requestWithStatus("GET", `/vaccines`);
    });
  }
  documents(options) {
    return __async(this, null, function* () {
      const {
        cursor = null,
        search = null,
        status = null,
        type = null,
        offices = null,
        limit = 50,
        users = []
      } = options;
      const qs = new URLSearchParams();
      if (cursor) {
        qs.set("cursor", cursor);
      }
      if (status) {
        qs.set("status", status);
      }
      if (search) {
        qs.set("search", search);
      }
      if (limit) {
        qs.set("limit", limit.toString());
      }
      if (type) {
        qs.set("document", type);
      }
      if (users && users.length > 0) {
        users.forEach((p) => qs.append("user", p));
      }
      if (offices && offices.length > 0) {
        offices.forEach((p) => qs.append("office", p));
      }
      const params = qs.toString();
      return this.requestWithStatus(
        "GET",
        `/documents?${params}`
      );
    });
  }
  getTestDocuments(userId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/tests?user=${userId}`
      );
    });
  }
  getVaccinationDocuments(userId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/vaccinations?user=${userId}`
      );
    });
  }
  getTestDocument(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus("GET", `/tests/${id}`);
    });
  }
  getVaccinationDocument(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/vaccinations/${id}`
      );
    });
  }
  addVaccinationDocument(officeId, vaccine) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/offices/${officeId}/vaccinations`,
        vaccine
      );
    });
  }
  addTestDocument(officeId, test) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/offices/${officeId}/tests`,
        test
      );
    });
  }
  rejectDocument(type, doc, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/${type}/${doc.id}/respond/rejected`,
        body
      );
    });
  }
  acceptDocument(type, doc, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/${type}/${doc.id}/respond/accepted`,
        body
      );
    });
  }
  changeUserHealth(user, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/users/${user.id}/health/status`,
        body
      );
    });
  }
  changeUserGroupHealth(user, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/users/${user.id}/health/group`,
        body
      );
    });
  }
};

// src/endpoints/hours.ts
import { format as format2 } from "date-fns";
var HoursClient = class extends BaseOrganizationEndpoints {
  all(officeId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/hours`
      );
    });
  }
  rules(officeId, resourceId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/hours?type=rule${resourceId ? `&resource=${encodeURIComponent(resourceId)}` : ""}`
      );
    });
  }
  weekdays(officeId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/hours?type=weekday`
      );
    });
  }
  holidays(officeId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/hours?type=holiday`
      );
    });
  }
  create(officeId, body, params) {
    return __async(this, null, function* () {
      const url = this.addGenericParamsToUrl(
        `/offices/${encodeURIComponent(officeId)}/hours`,
        params
      );
      return this.requestWithStatus("POST", url, body);
    });
  }
  createForResource(resourceId, body, params) {
    return __async(this, null, function* () {
      const url = this.addGenericParamsToUrl(
        `/resources/${encodeURIComponent(resourceId)}/hours`,
        params
      );
      return this.requestWithStatus("POST", url, body);
    });
  }
  updateWeekdays(officeId, body) {
    return __async(this, null, function* () {
      const data = [];
      Object.keys(body).forEach((day) => {
        const dayName = day;
        data.push(__spreadProps(__spreadValues({}, body[dayName]), {
          //day: dayName,
          start_time: format2(body[dayName].start_time, "HH:mm:ss"),
          end_time: format2(body[dayName].end_time, "HH:mm:ss")
        }));
      });
      return this.requestWithStatus(
        "PUT",
        `/offices/${encodeURIComponent(officeId)}/operational`,
        {
          days: data
        }
      );
    });
  }
  delete(officeId, hourId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/offices/${encodeURIComponent(officeId)}/hours/${encodeURIComponent(hourId.toString())}`
      );
    });
  }
  put(officeId, hourId, body, params) {
    return __async(this, null, function* () {
      const url = this.addGenericParamsToUrl(
        `/offices/${encodeURIComponent(officeId)}/hours/${encodeURIComponent(hourId.toString())}`,
        params
      );
      return this.requestWithStatus("PUT", url, body);
    });
  }
  get(officeId, hourId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/hours/${encodeURIComponent(hourId.toString())}`
      );
    });
  }
};

// src/endpoints/integrations.ts
var Integrations = class extends BaseIntegrationEndpoints {
  /**
   * Get all installed integrations for the user
   */
  getInstalledIntegrations() {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "GET",
        "/api/integrations/installed"
      );
      return result;
    });
  }
  /**
   * Get all installed admin integrations for the org
   */
  getInstalledAdminIntegrations() {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "GET",
        "/api/integrations/admin-installed"
      );
      return result;
    });
  }
  /**
   * Set up a third party integration
   * @param integrationType - Type of the integration we are setting up
   * @param body - information to store for the integration
   * @param isAdmin - Whether this is an admin integration. Example is microsoft-teams org setup
   * @returns
   */
  setupIntegration(integrationType, body, isAdmin = false) {
    return __async(this, null, function* () {
      let url = `/${integrationType}/setup`;
      if (isAdmin) {
        url += "?userType=admin";
      }
      const result = yield this.requestWithStatus("POST", url, body);
      return result;
    });
  }
  /**
   * Save Integration Options
   * @param integrationType - Type of the integration we are modifying
   * @param body - information to store for the integration
   * @param isAdmin - Whether this is an admin integration. Example is google app 2 way syncing
   * @returns
   */
  saveIntegrationOptions(integrationType, body, isAdmin = false) {
    return __async(this, null, function* () {
      let url = `/api/integrations/${isAdmin ? "admin-options" : "options"}`;
      const result = yield this.requestWithStatus("POST", url, {
        integrationType,
        options: body
      });
      return result;
    });
  }
  /**
   * Deauthorize an integration
   * @param integrationType - The type of integration, e.g. google or zoom
   * @param isAdmin - Whether this is an admin integration. Example is google 2 way sync admin
   */
  deauthorizeIntegration(integrationType, isAdmin = false) {
    return __async(this, null, function* () {
      let url = `/${integrationType}/deauthorize`;
      if (isAdmin) {
        url += "?userType=admin";
      }
      const result = yield this.requestWithStatus("DELETE", url, {});
      return result;
    });
  }
  /**
   * Get all installed integration settings for the user
   */
  getInstalledIntegrationSettings() {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "GET",
        "/api/integrations/settings"
      );
      return result;
    });
  }
  /**
   * Update installed integrations settings
   * @param settingsData - integrations and their updated settings
   */
  updateInstalledIntegrationSettings(settingsData) {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "PUT",
        "/api/integrations/settings",
        settingsData
      );
      return result;
    });
  }
  /**
   * Registers a device token for push notifications
   * @param body - Request containing the device information
   * @returns
   */
  registerDevice(body) {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "POST",
        `/api/devices/register`,
        body
      );
      return result;
    });
  }
  /**
   * Syncs resources with the freshwater system
   */
  syncFreshwaterResources() {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "POST",
        "/api/freshwater/sync",
        {}
      );
      return result;
    });
  }
};

// src/endpoints/invitations.ts
var Invitations = class extends BaseOrganizationEndpoints {
  /**
   * Returns all invitations that have been sent via an organization. Use this
   * to see if invitations have been accepted, rejected, revoked, or still pending.
   * Does NOT include invitation code
   */
  all() {
    return __async(this, arguments, function* (pagination = {
      cursor: null,
      limit: null
    }) {
      const response = yield this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl("/invitations", pagination)
      );
      return response;
    });
  }
  /**
   * Returns invitation details by invitation id
   */
  getById(invitationId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/invitations/${encodeURIComponent(invitationId)}`
      );
    });
  }
  /**
   * Revoke pending invitation
   */
  delete(invitationId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/invitations/${encodeURIComponent(invitationId)}`
      );
    });
  }
  /**
   * Sends an email invitation to a user to join a specific organization.
   * Role of "member" should be set by default. Optionally add team id's to
   * auto enroll user to specified teams upon acceptance of invitation.
   */
  add(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/invitations", body);
    });
  }
};

// src/entities/leave.ts
var ALL_LEAVE_POLICY_TYPES = [
  "bereavement",
  "custom",
  "holiday",
  "office",
  "ooo",
  "parental",
  "personal",
  "remote",
  "sick",
  "unpaid",
  "vacation"
];
var LeavePolicyTypeDisplay = /* @__PURE__ */ ((LeavePolicyTypeDisplay2) => {
  LeavePolicyTypeDisplay2["bereavement"] = "Bereavement";
  LeavePolicyTypeDisplay2["custom"] = "Custom";
  LeavePolicyTypeDisplay2["holiday"] = "Holiday";
  LeavePolicyTypeDisplay2["office"] = "Office";
  LeavePolicyTypeDisplay2["ooo"] = "OOO";
  LeavePolicyTypeDisplay2["parental"] = "Parental";
  LeavePolicyTypeDisplay2["personal"] = "Personal";
  LeavePolicyTypeDisplay2["remote"] = "Remote";
  LeavePolicyTypeDisplay2["sick"] = "Sick";
  LeavePolicyTypeDisplay2["unpaid"] = "Unpaid";
  LeavePolicyTypeDisplay2["vacation"] = "Vacation";
  return LeavePolicyTypeDisplay2;
})(LeavePolicyTypeDisplay || {});

// src/endpoints/leave.ts
var LeaveClient = class extends BaseOrganizationEndpoints {
  formatParams(params = {}) {
    return this.formatGenericParams(params);
  }
  createPolicy(payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/work_policies`,
        payload
      );
    });
  }
  deletePolicy(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/work_policies/${id}`
      );
    });
  }
  updatePolicy(payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/work_policies/${payload.id}`,
        payload
      );
    });
  }
  allPolicies(params) {
    return __async(this, null, function* () {
      const urlParams = this.formatParams(params);
      return this.requestWithStatus(
        "GET",
        `/work_policies?${urlParams.toString()}`
      );
    });
  }
  applicablePolicies(workPolicyType, options) {
    return __async(this, null, function* () {
      const urlParams = this.formatParams(__spreadValues({ workPolicyType }, options));
      return this.requestWithStatus("GET", `/work_policies/applicable/?${urlParams.toString()}`);
    });
  }
  allApplicablePolicies(params) {
    return __async(this, null, function* () {
      var _a;
      const askedTypes = (_a = params.type) != null ? _a : ALL_LEAVE_POLICY_TYPES;
      const policiesRes = askedTypes.map((type) => __async(this, null, function* () {
        try {
          const res = yield this.applicablePolicies(type, params);
          return res.result;
        } catch (e) {
          if (e instanceof ApiClientError && e.response.status === 404) {
            return [];
          }
          console.error("Error while fetching applicable policies", e);
          throw e;
        }
      }));
      const policies = yield Promise.all(policiesRes);
      return policies.flat().filter((x) => !!x);
    });
  }
  createRequest(payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/work_policies/uses`,
        payload
      );
    });
  }
  allRequests(params, managed = false) {
    return __async(this, null, function* () {
      const urlParams = this.formatParams(params);
      return this.requestWithStatus(
        "GET",
        `/work_policies/uses/${managed ? "managed/" : ""}?${urlParams.toString()}`
      );
    });
  }
  leaveRequest(id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/work_policies/uses/${id}`
      );
    });
  }
  respondRequests(payload) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/work_policies/uses/respond`,
        payload
      );
    });
  }
  deleteRequests(ids) {
    return __async(this, null, function* () {
      return Promise.all(
        ids.map(
          (id) => this.requestWithStatus(
            "DELETE",
            `/work_policies/uses/${id}`
          )
        )
      );
    });
  }
  conflicts(payload) {
    return __async(this, null, function* () {
      const urlParams = this.formatParams(payload);
      return this.requestWithStatus(
        "GET",
        `/work_policies/uses/matching?${urlParams}`
      );
    });
  }
};

// src/endpoints/organizations.ts
import * as signalR from "@microsoft/signalr";

// src/utils.ts
import { eachDayOfInterval, format as format3, parseISO } from "date-fns";
import { zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";
function formatOptions(actionResult) {
  let byId = {}, options = [];
  for (const element of actionResult.elements) {
    byId[element.id] = element;
    options.push({ value: element.id, label: element.name });
  }
  return __spreadProps(__spreadValues({}, actionResult), {
    byId,
    options
  });
}
function parseApiDateStr(dateStr, timeZone) {
  const parsedStr = dateStr.endsWith("Z") ? dateStr.slice(0, -1) : dateStr;
  const utcDate = zonedTimeToUtc(parseISO(parsedStr), timeZone);
  return utcToZonedTime(utcDate, timeZone);
}
function getDaysWithinTimespan(startTime, endTime, timeZone) {
  const startInTimeZone = parseApiDateStr(startTime, timeZone);
  const endInTimeZone = parseApiDateStr(endTime, timeZone);
  startInTimeZone.setHours(0, 0, 0, 0);
  if (endInTimeZone.getHours() === 0 && endInTimeZone.getMinutes() === 0 && endInTimeZone.getSeconds() === 0) {
    endInTimeZone.setDate(endInTimeZone.getDate() - 1);
  }
  endInTimeZone.setHours(0, 0, 0, 0);
  if (startInTimeZone.getTime() === endInTimeZone.getTime()) {
    return [format3(startInTimeZone, "yyyy-MM-dd")];
  }
  const days = eachDayOfInterval({
    start: startInTimeZone,
    end: endInTimeZone
  });
  const formattedDays = days.map((day) => format3(day, "yyyy-MM-dd"));
  return formattedDays;
}

// src/mocks/tags/tags.ts
var mockTags = [
  {
    id: "tag_3c4ffc2f-874f-46e5-bbe9-4c71b5458726",
    name: "Konklab",
    description: "Frozen stir-fry mix with chicken, veggies, and teriyaki sauce.",
    type: "amenity",
    category: "Monitors",
    created_at: "8/31/2024",
    updated_at: "11/24/2024"
  },
  {
    id: "tag_29ab6fc1-bbfd-4012-8271-b8462575bd7c",
    name: "Cookley",
    description: "Multifunctional smartwatch for fitness tracking.",
    type: "amenity",
    category: "Accessibility",
    created_at: "4/10/2025",
    updated_at: "4/18/2025"
  },
  {
    id: "tag_9c4e97df-a809-4ac6-90fa-f08588f3da8e",
    name: "Fix San",
    description: "Creamy yogurt blended with fresh pineapple and coconut pieces.",
    type: "amenity",
    category: "Furniture",
    created_at: "7/24/2024",
    updated_at: "5/5/2024"
  },
  {
    id: "tag_a27a89a5-0498-4754-a43d-28f40484c18a",
    name: "Sub-Ex",
    description: "Flavorful chicken sausage, low in fat and fully cooked.",
    type: "amenity",
    category: "Accessibility",
    created_at: "5/7/2024",
    updated_at: "6/17/2024"
  },
  {
    id: "tag_2ad305f2-adac-4963-8ba3-a0e0f443f31a",
    name: "Flowdesk",
    description: "Crunchy granola with maple flavor and almond pieces for breakfast.",
    type: "amenity",
    category: "Furniture",
    created_at: "11/29/2024",
    updated_at: "4/23/2025"
  },
  {
    id: "tag_3d0fec90-7f76-416b-ba13-6dc4ba6a98ee",
    name: "Holdlamis",
    description: "Convenient hooks that utilize door space for hanging items.",
    type: "amenity",
    category: "Furniture",
    created_at: "8/12/2024",
    updated_at: "8/20/2024"
  },
  {
    id: "tag_159768f6-2ec1-4867-a823-2a98e63290bb",
    name: "Quo Lux",
    description: "Classic chino shorts in a versatile color for summer adventures.",
    type: "amenity",
    category: "Connectivity",
    created_at: "10/22/2024",
    updated_at: "10/4/2024"
  },
  {
    id: "tag_a90eb234-39d4-488c-9073-c5885d7afc38",
    name: "Ronstring",
    description: "A pack of assorted nut and protein bars for a quick energy boost.",
    type: "amenity",
    category: "Furniture",
    created_at: "9/16/2024",
    updated_at: "7/15/2024"
  },
  {
    id: "tag_4f7fa5c6-0cdc-413f-8a3f-929eef0ade27",
    name: "Regrant",
    description: "Fresh zucchini, versatile for grilling or saut\xE9ing.",
    type: "amenity",
    category: "Accessibility",
    created_at: "10/31/2024",
    updated_at: "4/30/2024"
  },
  {
    id: "tag_dd6782a8-35eb-4c11-833b-6a7f16e77f3f",
    name: "Stringtough",
    description: "Versatile holder that can be used on desks, cars, and more.",
    type: "amenity",
    category: "Connectivity",
    created_at: "4/2/2025",
    updated_at: "7/31/2024"
  },
  {
    id: "tag_fcf7e85e-9374-4f6e-ae37-408d184db839",
    name: "Lotstring",
    description: "A hearty salad with lentils, veggies, and curry dressing.",
    type: "amenity",
    category: "Monitors",
    created_at: "6/21/2024",
    updated_at: "8/22/2024"
  },
  {
    id: "tag_2391c3e4-63c5-4a6c-81f9-1a14290a510d",
    name: "Biodex",
    description: "Convenient and low-carb alternative to traditional rice.",
    type: "amenity",
    category: "Accessibility",
    created_at: "6/10/2024",
    updated_at: "5/20/2024"
  },
  {
    id: "tag_1c1c7a09-9b86-4cf6-a49e-3ba33a78616c",
    name: "Prodder",
    description: "Cozy wool sweater to keep you warm on chilly days.",
    type: "amenity",
    category: "Furniture",
    created_at: "3/5/2025",
    updated_at: "11/5/2024"
  },
  {
    id: "tag_f5b7e845-f677-46e1-a352-201666b20102",
    name: "Stim",
    description: "Learning tablet with kid-friendly educational apps.",
    type: "amenity",
    category: "Accessibility",
    created_at: "10/8/2024",
    updated_at: "1/9/2025"
  },
  {
    id: "tag_58814cd9-81dd-4876-b9bf-7b66f90c4657",
    name: "Quo Lux",
    description: "Inflatable air mattress for convenient sleeping.",
    type: "amenity",
    category: "Furniture",
    created_at: "6/29/2024",
    updated_at: "7/25/2024"
  },
  {
    id: "tag_2880c627-e318-4a85-b720-8efc6a4d0de6",
    name: "Zamit",
    description: "Therapeutic weighted blanket for better sleep.",
    type: "amenity",
    category: "Connectivity",
    created_at: "6/30/2024",
    updated_at: "11/19/2024"
  },
  {
    id: "tag_86f30790-96f0-4a01-8c0b-f7d319908ac9",
    name: "Zathin",
    description: "Juicy and tender beef sirloin steak, grass-fed.",
    type: "amenity",
    category: "Accessibility",
    created_at: "2/13/2025",
    updated_at: "6/10/2024"
  },
  {
    id: "tag_391c85db-241c-4bbf-8844-e9e1afc1c228",
    name: "Matsoft",
    description: "Soft and pillowy gnocchi made from cauliflower, perfect with sauce.",
    type: "amenity",
    category: "Monitors",
    created_at: "4/27/2025",
    updated_at: "4/16/2025"
  },
  {
    id: "tag_13df629b-03b0-4955-9d5f-ace7dfdd4198",
    name: "Zamit",
    description: "Classic marinara sauce for pasta, pizza, or dipping.",
    type: "amenity",
    category: "Connectivity",
    created_at: "11/16/2024",
    updated_at: "10/24/2024"
  },
  {
    id: "tag_ac47f41f-f19b-435b-9add-f71743107c77",
    name: "Subin",
    description: "Insulated pitcher to keep beverages cold or hot.",
    type: "amenity",
    category: "Accessibility",
    created_at: "7/1/2024",
    updated_at: "10/22/2024"
  },
  {
    id: "tag_8e5986a3-0d1f-49e9-88d1-b95f9597ad54",
    name: "Ventosanzap",
    description: "Control appliances remotely using your smartphone.",
    type: "amenity",
    category: "Connectivity",
    created_at: "1/2/2025",
    updated_at: "3/24/2025"
  },
  {
    id: "tag_17cb19b7-c784-4b1d-aa84-ecdb704411c5",
    name: "Tres-Zap",
    description: "Convenient charging pad for wireless charging in vehicles.",
    type: "amenity",
    category: "Furniture",
    created_at: "9/9/2024",
    updated_at: "11/20/2024"
  },
  {
    id: "tag_34bec344-d5a1-46f0-a06e-4151eed7e3fa",
    name: "Cardguard",
    description: "Stylish desk set to keep your workspace tidy and organized.",
    type: "amenity",
    category: "Connectivity",
    created_at: "3/20/2025",
    updated_at: "8/5/2024"
  },
  {
    id: "tag_7ccf8a2d-24de-4e15-83f2-e712fcbbd601",
    name: "It",
    description: "Reusable gel ice pack for injuries and cooling.",
    type: "amenity",
    category: "Connectivity",
    created_at: "2/17/2025",
    updated_at: "4/29/2025"
  },
  {
    id: "tag_4a33af25-862d-4d88-9727-98d85fb0fc72",
    name: "Pannier",
    description: "Stylish wall art to enhance home decor.",
    type: "amenity",
    category: "Monitors",
    created_at: "3/13/2025",
    updated_at: "7/26/2024"
  },
  {
    id: "tag_1437cb2d-57bf-4628-af3d-da2cd6ff48b2",
    name: "Stringtough",
    description: "Heavy-duty scissors for crafting and office use.",
    type: "amenity",
    category: "Accessibility",
    created_at: "2/3/2025",
    updated_at: "4/8/2025"
  },
  {
    id: "tag_beb45418-6b22-494b-bc9c-8fbf67f8362e",
    name: "Regrant",
    description: "Wi-Fi enabled thermostat that learns your habits.",
    type: "amenity",
    category: "Furniture",
    created_at: "5/10/2024",
    updated_at: "9/23/2024"
  },
  {
    id: "tag_f9f137d9-eb79-4a15-b574-14beb68c5892",
    name: "Zontrax",
    description: "Relaxing paint kit with pre-printed canvas for painting.",
    type: "amenity",
    category: "Accessibility",
    created_at: "6/22/2024",
    updated_at: "6/22/2024"
  },
  {
    id: "tag_2ce31a6a-12d7-4a19-b5bb-60c2bfbe2432",
    name: "Zoolab",
    description: "Fluffy couscous that cooks in just minutes, perfect as a side.",
    type: "amenity",
    category: "Monitors",
    created_at: "2/24/2025",
    updated_at: "11/13/2024"
  },
  {
    id: "tag_e255eccc-1c97-463c-8d12-87c5f47b25da",
    name: "Asoka",
    description: "Stylish baskets for organizing various items in your home.",
    type: "amenity",
    category: "Furniture",
    created_at: "5/31/2024",
    updated_at: "8/30/2024"
  },
  {
    id: "tag_006c6a7d-9b33-4a0c-922e-1a2c79517d28",
    name: "Toughjoyfax",
    description: "Sweet blackberry compote, perfect for topping desserts.",
    type: "amenity",
    category: "Accessibility",
    created_at: "4/17/2025",
    updated_at: "5/10/2024"
  },
  {
    id: "tag_061ee53e-f367-47cf-b0df-5d8364b18d83",
    name: "Latlux",
    description: "Healthy granola made with oats and honey.",
    type: "amenity",
    category: "Accessibility",
    created_at: "8/7/2024",
    updated_at: "9/27/2024"
  },
  {
    id: "tag_38286183-ed76-4832-b6eb-dc5970ccfd30",
    name: "Asoka",
    description: "Set of reusable stainless steel straws for drinks.",
    type: "amenity",
    category: "Furniture",
    created_at: "8/31/2024",
    updated_at: "6/18/2024"
  },
  {
    id: "tag_371d4c32-d047-4364-adb3-d58f8dc292a9",
    name: "Fix San",
    description: "Variety pack of craft supplies for kids' projects.",
    type: "amenity",
    category: "Accessibility",
    created_at: "6/27/2024",
    updated_at: "4/11/2025"
  },
  {
    id: "tag_2863c3cb-1a03-4a52-bafd-4e7150bef98a",
    name: "Konklux",
    description: "Pitted black olives, perfect for salads and pizzas.",
    type: "amenity",
    category: "Accessibility",
    created_at: "3/21/2025",
    updated_at: "7/14/2024"
  },
  {
    id: "tag_2a720e44-4abf-4857-9e66-0c2500566f7b",
    name: "Prodder",
    description: "Crispy tortilla chips, perfect for dipping.",
    type: "amenity",
    category: "Accessibility",
    created_at: "12/15/2024",
    updated_at: "9/17/2024"
  },
  {
    id: "tag_26c813ef-0132-4a8c-8533-1b6957138189",
    name: "Overhold",
    description: "Intricate designs for adults to relax and unwind.",
    type: "amenity",
    category: "Accessibility",
    created_at: "8/25/2024",
    updated_at: "4/6/2025"
  },
  {
    id: "tag_67790337-295e-4fa0-bd19-0afdf51376ef",
    name: "Bitwolf",
    description: "Lightweight and portable picnic table for outdoor use.",
    type: "amenity",
    category: "Monitors",
    created_at: "5/14/2024",
    updated_at: "7/15/2024"
  },
  {
    id: "tag_fa67bcd5-c43f-4f7a-945d-5d9214795468",
    name: "Flexidy",
    description: "Crisp and delicious organic apples.",
    type: "amenity",
    category: "Accessibility",
    created_at: "3/25/2025",
    updated_at: "3/22/2025"
  },
  {
    id: "tag_7abf0f01-8231-4c8a-a94c-bc2e65ea89e7",
    name: "Tin",
    description: "Heavy-duty scissors for crafting and office use.",
    type: "amenity",
    category: "Connectivity",
    created_at: "9/17/2024",
    updated_at: "5/26/2024"
  },
  {
    id: "tag_71a411cb-84ec-4baf-bd02-e12587db8a2e",
    name: "Lotlux",
    description: "A spicy marinade perfect for chicken and fish.",
    type: "amenity",
    category: "Accessibility",
    created_at: "9/30/2024",
    updated_at: "9/25/2024"
  },
  {
    id: "tag_5881ce55-bec9-4d9c-a12a-a3bbdb315a67",
    name: "Sonsing",
    description: "A quick and easy fried rice mix with colorful veggies and savory seasoning.",
    type: "amenity",
    category: "Furniture",
    created_at: "9/26/2024",
    updated_at: "5/14/2024"
  },
  {
    id: "tag_29428235-0adf-438a-8e1a-beb4ab7798c7",
    name: "Stronghold",
    description: "Durable apron to keep clothes clean while cooking.",
    type: "amenity",
    category: "Monitors",
    created_at: "6/3/2024",
    updated_at: "10/18/2024"
  },
  {
    id: "tag_2bf8350e-f115-40ca-8d2f-9cb0e3163ada",
    name: "Opela",
    description: "A comfortable henley shirt made of soft cotton, perfect for casual outings.",
    type: "amenity",
    category: "Accessibility",
    created_at: "7/13/2024",
    updated_at: "11/19/2024"
  },
  {
    id: "tag_1c7b82f1-858d-44a1-a96f-637addee9ca0",
    name: "Bytecard",
    description: "Oven-roasted potatoes tossed in garlic and parmesan cheese seasoning.",
    type: "amenity",
    category: "Monitors",
    created_at: "11/21/2024",
    updated_at: "9/10/2024"
  },
  {
    id: "tag_a2105a17-4a64-4a82-b1da-b8fe4a84d465",
    name: "Tresom",
    description: "Love-themed molds for creating desserts and treats.",
    type: "amenity",
    category: "Furniture",
    created_at: "11/30/2024",
    updated_at: "6/12/2024"
  },
  {
    id: "tag_4a25259e-e81a-42c7-9ab6-53d01661a0a8",
    name: "Vagram",
    description: "Warm and stylish jacket for cold weather.",
    type: "amenity",
    category: "Furniture",
    created_at: "9/20/2024",
    updated_at: "1/8/2025"
  },
  {
    id: "tag_3a37f3df-205e-42d9-b6a1-1b050efde2b5",
    name: "Flowdesk",
    description: "Fun light that creates a disco atmosphere for parties.",
    type: "amenity",
    category: "Furniture",
    created_at: "6/23/2024",
    updated_at: "6/22/2024"
  },
  {
    id: "tag_d7a80879-f6a7-4de6-aefa-31cc47b6a7a3",
    name: "Alphazap",
    description: "Quick oatmeal with various flavors",
    type: "amenity",
    category: "Connectivity",
    created_at: "1/2/2025",
    updated_at: "9/22/2024"
  },
  {
    id: "tag_f784566a-2d5c-42f1-b026-9f94b39e65a8",
    name: "Lotlux",
    description: "Sweet blackberry compote, perfect for topping desserts.",
    type: "amenity",
    category: "Accessibility",
    created_at: "4/10/2025",
    updated_at: "10/6/2024"
  },
  {
    id: "tag_6328a2b8-bf60-4413-9063-7185109a143f",
    name: "Y-find",
    description: "Dimmable LED desk lamp with USB charging port.",
    type: "amenity",
    category: "Accessibility",
    created_at: "9/9/2024",
    updated_at: "4/18/2025"
  },
  {
    id: "tag_92a66488-ec27-47c6-bc77-c25b5e7993d1",
    name: "Flowdesk",
    description: "Crunchy granola with almonds and coconut.",
    type: "amenity",
    category: "Monitors",
    created_at: "1/24/2025",
    updated_at: "6/10/2024"
  },
  {
    id: "tag_1d9120a7-b360-4f44-9dbe-e87c95731a91",
    name: "Redhold",
    description: "Frozen mix for quick berry smoothies.",
    type: "amenity",
    category: "Accessibility",
    created_at: "9/1/2024",
    updated_at: "5/22/2024"
  },
  {
    id: "tag_44b85503-ce67-46cd-a8f1-7f8a65fc100a",
    name: "Tempsoft",
    description: "Delicious and hearty black beans, great for soups or salads.",
    type: "amenity",
    category: "Furniture",
    created_at: "5/6/2024",
    updated_at: "7/17/2024"
  },
  {
    id: "tag_7c87360d-2b9e-408f-9ed3-2309b9167442",
    name: "Kanlam",
    description: "Frozen salmon fillets marinated in teriyaki sauce, ready to grill or bake.",
    type: "amenity",
    category: "Connectivity",
    created_at: "2/21/2025",
    updated_at: "1/6/2025"
  },
  {
    id: "tag_a5af43f9-76ef-4eb1-82c2-08c5207702ad",
    name: "Keylex",
    description: "32GB USB flash drive with fast data transfer speeds.",
    type: "amenity",
    category: "Accessibility",
    created_at: "11/11/2024",
    updated_at: "11/21/2024"
  },
  {
    id: "tag_c2e1de43-0a3f-4e8a-8952-8625b0d344a8",
    name: "Bitchip",
    description: "Non-toxic traps for catching household pests safely.",
    type: "amenity",
    category: "Furniture",
    created_at: "2/5/2025",
    updated_at: "6/20/2024"
  },
  {
    id: "tag_651a1f91-c427-4978-ba07-e9632fca100f",
    name: "Viva",
    description: "Spicy salsa made with fresh ingredients.",
    type: "amenity",
    category: "Connectivity",
    created_at: "6/14/2024",
    updated_at: "7/15/2024"
  },
  {
    id: "tag_c9a2644f-448e-436e-a641-39ea1a646456",
    name: "Sonair",
    description: "Inflatable air mattress for convenient sleeping.",
    type: "amenity",
    category: "Furniture",
    created_at: "7/15/2024",
    updated_at: "6/6/2024"
  },
  {
    id: "tag_77c01a73-fab5-4cdc-b1f3-03e6dfd4b688",
    name: "Transcof",
    description: "Stylish digital journaling app for notes and organizing tasks.",
    type: "amenity",
    category: "Furniture",
    created_at: "2/15/2025",
    updated_at: "9/22/2024"
  },
  {
    id: "tag_241cfe16-193b-45a2-9d79-e5499ecd9ca5",
    name: "Sonair",
    description: "Low-carb zucchini noodles, perfect for a healthy alternative to pasta.",
    type: "amenity",
    category: "Furniture",
    created_at: "11/30/2024",
    updated_at: "4/18/2025"
  },
  {
    id: "tag_6558548a-a2a2-49f5-b384-47514e310906",
    name: "Redhold",
    description: "Practical cargo pants with lots of pockets for functionality.",
    type: "amenity",
    category: "Furniture",
    created_at: "5/11/2024",
    updated_at: "3/16/2025"
  },
  {
    id: "tag_c24b8877-ba77-4e2b-aec4-7a42253395e4",
    name: "Tres-Zap",
    description: "Infuser for brewing loose-leaf herbal teas easily.",
    type: "amenity",
    category: "Monitors",
    created_at: "2/3/2025",
    updated_at: "4/14/2025"
  },
  {
    id: "tag_a03f192f-63d0-445c-a024-ed98eb1a2ff5",
    name: "Temp",
    description: "A versatile black dress that can be styled for any occasion.",
    type: "amenity",
    category: "Accessibility",
    created_at: "5/13/2024",
    updated_at: "11/11/2024"
  },
  {
    id: "tag_3fb64750-3fd1-40cd-a69a-5b5b7914a0c8",
    name: "Konklux",
    description: "Chickpeas mixed with fresh vegetables and herbs, a nutritious snack or salad.",
    type: "amenity",
    category: "Furniture",
    created_at: "4/18/2025",
    updated_at: "3/22/2025"
  },
  {
    id: "tag_f6af7e89-610b-4103-8bea-ef937f6b7ea2",
    name: "Zoolab",
    description: "An elegant jumpsuit that can be dressed up or down.",
    type: "amenity",
    category: "Furniture",
    created_at: "2/5/2025",
    updated_at: "6/29/2024"
  },
  {
    id: "tag_e7f428e4-a7bc-40bf-bf72-ecd6901ada57",
    name: "Bitchip",
    description: "Natural pink salt, perfect for seasoning.",
    type: "amenity",
    category: "Furniture",
    created_at: "2/7/2025",
    updated_at: "6/27/2024"
  },
  {
    id: "tag_b708cefd-8788-4d6c-9288-c3da45784d63",
    name: "Wrapsafe",
    description: "Comfortable slim fit chinos for a polished look.",
    type: "amenity",
    category: "Connectivity",
    created_at: "12/7/2024",
    updated_at: "4/22/2025"
  },
  {
    id: "tag_efc103ca-af4f-46e8-9ffc-5193a99611c8",
    name: "Namfix",
    description: "A mix of brined Mediterranean olives for snacking.",
    type: "amenity",
    category: "Accessibility",
    created_at: "3/11/2025",
    updated_at: "7/30/2024"
  },
  {
    id: "tag_08c311e0-ea78-4a06-acd0-91af7daa72ec",
    name: "Zathin",
    description: "Savory hash made with sweet potatoes and kale, a perfect side dish.",
    type: "amenity",
    category: "Connectivity",
    created_at: "11/14/2024",
    updated_at: "3/18/2025"
  },
  {
    id: "tag_30cfa83d-b42d-42ec-b0e7-e910c6d68ff2",
    name: "Rank",
    description: "Supportive yoga wheel for deep stretching and balance.",
    type: "amenity",
    category: "Connectivity",
    created_at: "10/14/2024",
    updated_at: "9/2/2024"
  },
  {
    id: "tag_5884a24b-ddeb-4bc9-8336-ce84843d4fdd",
    name: "Opela",
    description: "Healthy, crunchy kale chips, a nutritious snack.",
    type: "amenity",
    category: "Monitors",
    created_at: "8/18/2024",
    updated_at: "8/15/2024"
  },
  {
    id: "tag_72aff623-9af3-4753-9ef9-db7389e656bd",
    name: "Konklux",
    description: "Zesty seasoning great for tacos and grilling.",
    type: "amenity",
    category: "Monitors",
    created_at: "8/23/2024",
    updated_at: "2/23/2025"
  },
  {
    id: "tag_472b7f3b-a4b6-4d03-bb31-a901287e930a",
    name: "Zontrax",
    description: "Versatile air fryer that also roasts, bakes, and broils.",
    type: "amenity",
    category: "Connectivity",
    created_at: "3/8/2025",
    updated_at: "2/28/2025"
  },
  {
    id: "tag_e454384a-ee93-427a-a603-57b5bd5d5c3b",
    name: "Biodex",
    description: "A hearty mix of beans in a flavorful tomato broth.",
    type: "amenity",
    category: "Furniture",
    created_at: "8/31/2024",
    updated_at: "10/4/2024"
  },
  {
    id: "tag_bb048ef3-9a86-4444-85fe-0463651b0f31",
    name: "Alphazap",
    description: "Non-stick baking mat for easy cooking and cleanup.",
    type: "amenity",
    category: "Monitors",
    created_at: "8/8/2024",
    updated_at: "8/7/2024"
  },
  {
    id: "tag_411afbb6-e7f0-4bb3-b934-c1d66a77c7e8",
    name: "Bytecard",
    description: "Nutritious and hearty pasta made from whole wheat flour.",
    type: "amenity",
    category: "Connectivity",
    created_at: "4/20/2025",
    updated_at: "12/26/2024"
  },
  {
    id: "tag_7a90c381-8108-47c1-93a5-673b0154a4a8",
    name: "Asoka",
    description: "A mix of nuts roasted with spicy seasonings, perfect for snacking.",
    type: "amenity",
    category: "Connectivity",
    created_at: "8/16/2024",
    updated_at: "7/19/2024"
  },
  {
    id: "tag_ca53c247-7c22-4d1e-9e51-bcb95b8860a0",
    name: "Bytecard",
    description: "A frozen pizza topped with fresh mozzarella, tomatoes, and basil.",
    type: "amenity",
    category: "Furniture",
    created_at: "5/1/2024",
    updated_at: "5/13/2024"
  },
  {
    id: "tag_ecce47c5-f2a1-4a0d-b245-e3f5ab559e54",
    name: "Otcom",
    description: "Fun and colorful wall decals for children's rooms.",
    type: "amenity",
    category: "Connectivity",
    created_at: "4/15/2025",
    updated_at: "7/21/2024"
  },
  {
    id: "tag_4f7423ef-d650-4952-8030-ae11b79fea70",
    name: "Tempsoft",
    description: "Healthy energy bites made with oats and natural sweeteners.",
    type: "amenity",
    category: "Connectivity",
    created_at: "8/7/2024",
    updated_at: "3/12/2025"
  },
  {
    id: "tag_e8c982a5-19cb-4536-b2e8-14cee974c946",
    name: "Trippledex",
    description: "Programmable pet feeder for scheduled meals.",
    type: "amenity",
    category: "Connectivity",
    created_at: "11/23/2024",
    updated_at: "5/9/2024"
  },
  {
    id: "tag_7dfe0a58-3216-4c68-aef7-43ff99974fce",
    name: "Temp",
    description: "Colorful veggie chips made from beets, carrots, and sweet potatoes.",
    type: "amenity",
    category: "Furniture",
    created_at: "1/20/2025",
    updated_at: "9/23/2024"
  },
  {
    id: "tag_657de3a6-fca9-44b3-aa36-6eaefccd45c1",
    name: "Veribet",
    description: "Compact trash can for keeping your car clean.",
    type: "amenity",
    category: "Furniture",
    created_at: "11/14/2024",
    updated_at: "4/9/2025"
  },
  {
    id: "tag_06ea6c73-e27c-400c-b840-33dba39fd51f",
    name: "Wrapsafe",
    description: "Sturdy camera tripod for professional photography.",
    type: "amenity",
    category: "Furniture",
    created_at: "1/3/2025",
    updated_at: "9/15/2024"
  },
  {
    id: "tag_6f793c94-8a65-4392-9554-d9456993bc4b",
    name: "Fixflex",
    description: "Convenient and low-carb alternative to traditional rice.",
    type: "amenity",
    category: "Furniture",
    created_at: "12/28/2024",
    updated_at: "5/11/2024"
  },
  {
    id: "tag_53334b77-86d3-48ec-9fc2-6c293ef58ea3",
    name: "Treeflex",
    description: "Stylish and functional backpack for school or trips.",
    type: "amenity",
    category: "Accessibility",
    created_at: "10/12/2024",
    updated_at: "8/31/2024"
  },
  {
    id: "tag_2578862c-d9a7-47b8-918d-5a36c454e4ca",
    name: "Temp",
    description: "Nutritious protein bar with cherry and almond flavor, great for on-the-go.",
    type: "amenity",
    category: "Furniture",
    created_at: "4/28/2025",
    updated_at: "8/24/2024"
  },
  {
    id: "tag_4ad8ea99-d8b8-4cff-a0ff-1e4126b33650",
    name: "Biodex",
    description: "A zesty marinade made with lemon juice and garlic, ideal for chicken or fish.",
    type: "amenity",
    category: "Monitors",
    created_at: "8/13/2024",
    updated_at: "6/27/2024"
  },
  {
    id: "tag_5547aae7-523b-411a-99af-ec1887febb09",
    name: "Subin",
    description: "Customizable window cover for light control and privacy.",
    type: "amenity",
    category: "Monitors",
    created_at: "9/16/2024",
    updated_at: "9/27/2024"
  },
  {
    id: "tag_169aba01-252e-4d84-abb7-ef02561bdda5",
    name: "Voltsillam",
    description: "Prevent water damage with drip trays for potted plants.",
    type: "amenity",
    category: "Connectivity",
    created_at: "5/13/2024",
    updated_at: "10/22/2024"
  },
  {
    id: "tag_797485b1-d831-4cc6-8a60-de778a620b99",
    name: "Subin",
    description: "Nutritious snack bar made with almond butter and protein.",
    type: "amenity",
    category: "Monitors",
    created_at: "1/23/2025",
    updated_at: "2/12/2025"
  },
  {
    id: "tag_cd133bbb-bc68-4b67-a388-603184e2c811",
    name: "Holdlamis",
    description: "Rich coconut milk, great for cooking and baking.",
    type: "amenity",
    category: "Monitors",
    created_at: "1/22/2025",
    updated_at: "6/26/2024"
  },
  {
    id: "tag_9d9cdab4-2792-43e0-87c2-347bf265d65d",
    name: "Cardify",
    description: "Spacious 2-person camping tent with waterproof cover.",
    type: "amenity",
    category: "Accessibility",
    created_at: "6/17/2024",
    updated_at: "12/28/2024"
  },
  {
    id: "tag_e1633c82-81fb-4162-ad77-423dd6487757",
    name: "Sonair",
    description: "Refreshing apple juice, 100% juice with no added sugar.",
    type: "amenity",
    category: "Furniture",
    created_at: "1/18/2025",
    updated_at: "9/9/2024"
  },
  {
    id: "tag_3eb08d51-6808-4162-ac30-ecd625b530cf",
    name: "Namfix",
    description: "A mix of nuts, pretzels, and crackers, seasoned just right for snacking.",
    type: "amenity",
    category: "Accessibility",
    created_at: "9/4/2024",
    updated_at: "2/23/2025"
  },
  {
    id: "tag_0a3b477f-6b5d-4cb0-8208-acb0a562b43e",
    name: "Cardguard",
    description: "Fine semolina flour, perfect for pasta and desserts.",
    type: "amenity",
    category: "Furniture",
    created_at: "6/16/2024",
    updated_at: "4/23/2025"
  },
  {
    id: "tag_875d4000-e29e-4e7a-abbf-0626cdca9372",
    name: "Redhold",
    description: "A tangy sauce that combines lemon zest and basil for a refreshing flavor.",
    type: "amenity",
    category: "Furniture",
    created_at: "5/7/2024",
    updated_at: "6/26/2024"
  },
  {
    id: "tag_ea2f45d5-91c1-4bd8-8df6-be35299a30d6",
    name: "Toughjoyfax",
    description: "Multi-functional tool for emergency situations in the car.",
    type: "amenity",
    category: "Accessibility",
    created_at: "11/28/2024",
    updated_at: "10/25/2024"
  },
  {
    id: "tag_03050cd2-e152-4672-a01f-e3227cbc2f2e",
    name: "It",
    description: "Ergonomic stand for laptops to improve posture while working.",
    type: "amenity",
    category: "Monitors",
    created_at: "4/6/2025",
    updated_at: "10/15/2024"
  },
  {
    id: "tag_7044a4bf-df2c-4407-b7f5-3df6d2d58152",
    name: "Bigtax",
    description: "Programmable pet feeder for scheduled meals.",
    type: "amenity",
    category: "Monitors",
    created_at: "11/21/2024",
    updated_at: "7/28/2024"
  },
  {
    id: "tag_5073089a-37ff-4a94-a871-8f5d5cdc49f2",
    name: "Cardguard",
    description: "Light and crispy rice cakes, a perfect low-calorie snack.",
    type: "amenity",
    category: "Connectivity",
    created_at: "8/31/2024",
    updated_at: "6/29/2024"
  },
  {
    id: "tag_b8cd6c84-fccc-4347-898e-abd664088c3a",
    name: "It",
    description: "Rich and creamy smoked Gouda cheese perfect for snacking.",
    type: "amenity",
    category: "Connectivity",
    created_at: "1/4/2025",
    updated_at: "6/27/2024"
  },
  {
    id: "tag_f087bce9-1513-481c-adcf-36f0a8cf12d1",
    name: "Bigtax",
    description: "A hearty salad with lentils, veggies, and curry dressing.",
    type: "amenity",
    category: "Connectivity",
    created_at: "4/9/2025",
    updated_at: "4/18/2025"
  },
  {
    id: "tag_821a03f7-b596-4a3c-8979-85569bcce6a8",
    name: "Opela",
    description: "Everything you need to make delicious spicy tuna rolls at home.",
    type: "amenity",
    category: "Connectivity",
    created_at: "9/9/2024",
    updated_at: "5/10/2024"
  },
  {
    id: "tag_1c58ca48-9007-45d3-8e26-14998f00e08a",
    name: "Bytecard",
    description: "Fruits dipped in rich chocolate, perfect for desserts.",
    type: "amenity",
    category: "Monitors",
    created_at: "12/13/2024",
    updated_at: "1/7/2025"
  },
  {
    id: "tag_798d919c-e252-44c4-991b-6fe9534ce072",
    name: "Transcof",
    description: "Create spiraled vegetable noodles easily for healthy meals.",
    type: "amenity",
    category: "Connectivity",
    created_at: "9/5/2024",
    updated_at: "2/16/2025"
  },
  {
    id: "tag_c246e907-9cf3-4485-8b8d-bf674451c6e6",
    name: "Konklux",
    description: "Sweet and tangy balsamic reduction for drizzling.",
    type: "amenity",
    category: "Connectivity",
    created_at: "9/25/2024",
    updated_at: "5/18/2024"
  },
  {
    id: "tag_65ae008b-5b0f-4a5f-a51e-8dfbb6c65a72",
    name: "Zoolab",
    description: "Sweet and spiced apple filling, perfect for pies.",
    type: "amenity",
    category: "Monitors",
    created_at: "1/27/2025",
    updated_at: "11/18/2024"
  },
  {
    id: "tag_659f663c-a662-4245-8daa-a84ed1268ce4",
    name: "Andalax",
    description: "Multi-level cat tree for play and scratching.",
    type: "amenity",
    category: "Furniture",
    created_at: "8/2/2024",
    updated_at: "1/20/2025"
  },
  {
    id: "tag_5e9cb9db-3856-4edb-94d6-3fcfb781e5ab",
    name: "Zathin",
    description: "Crispy baked radish chips, a healthy snack alternative.",
    type: "amenity",
    category: "Accessibility",
    created_at: "2/25/2025",
    updated_at: "5/3/2024"
  },
  {
    id: "tag_76a2699c-e3a7-4317-b97a-0f467961e439",
    name: "Alpha",
    description: "Stylish smartwatch with fitness tracking and notifications.",
    type: "amenity",
    category: "Furniture",
    created_at: "9/10/2024",
    updated_at: "12/5/2024"
  },
  {
    id: "tag_77bf100c-bcbc-4904-905a-6a08d30e0eb6",
    name: "Zathin",
    description: "Advanced wristband that tracks daily activities and sleep.",
    type: "amenity",
    category: "Furniture",
    created_at: "7/8/2024",
    updated_at: "4/18/2025"
  },
  {
    id: "tag_3dbe3aec-6ba5-4dd2-af0c-f3c9b2e12880",
    name: "Kanlam",
    description: "Roasted chickpeas seasoned for a crunchy snack.",
    type: "amenity",
    category: "Accessibility",
    created_at: "3/15/2025",
    updated_at: "3/23/2025"
  },
  {
    id: "tag_505505c9-4879-493c-a9b9-469e9e21f46b",
    name: "Rank",
    description: "Lightly salted rice cakes, perfect for a healthy snack.",
    type: "amenity",
    category: "Furniture",
    created_at: "9/3/2024",
    updated_at: "8/1/2024"
  },
  {
    id: "tag_fcb0dc15-6d41-4808-bec6-346298ade8e1",
    name: "Viva",
    description: "A mix of frozen roasted vegetables for an easy side dish.",
    type: "amenity",
    category: "Furniture",
    created_at: "10/21/2024",
    updated_at: "4/27/2025"
  },
  {
    id: "tag_f58ac51c-52d8-4442-99c8-669342c21df3",
    name: "Ronstring",
    description: "Moist brownie topped with sea salt and caramel drizzle.",
    type: "amenity",
    category: "Furniture",
    created_at: "10/8/2024",
    updated_at: "5/16/2024"
  },
  {
    id: "tag_9a393053-7b7a-41f1-9d34-f2862d668505",
    name: "Zoolab",
    description: "Creamy macaroni and cheese baked to perfection.",
    type: "amenity",
    category: "Monitors",
    created_at: "1/19/2025",
    updated_at: "9/20/2024"
  },
  {
    id: "tag_c6d2f990-10dd-4e13-b879-788dc42c66e8",
    name: "Home Ing",
    description: "Stylish desk set to keep your workspace tidy and organized.",
    type: "amenity",
    category: "Furniture",
    created_at: "10/12/2024",
    updated_at: "8/2/2024"
  },
  {
    id: "tag_d04e3976-fa82-4290-b437-f5543ad37e85",
    name: "Treeflex",
    description: "Continuous stream of fresh water for pets, promoting hydration.",
    type: "amenity",
    category: "Monitors",
    created_at: "12/25/2024",
    updated_at: "7/21/2024"
  },
  {
    id: "tag_20123c54-e058-4ea9-aba7-524ce114cd8f",
    name: "Sonair",
    description: "A stunning lace dress perfect for special occasions.",
    type: "amenity",
    category: "Furniture",
    created_at: "6/23/2024",
    updated_at: "11/25/2024"
  },
  {
    id: "tag_e91929df-26fb-4e2f-adb0-b17b6cc17e4e",
    name: "Y-find",
    description: "Crispy fries tossed in truffle oil and parmesan, a gourmet snack.",
    type: "amenity",
    category: "Furniture",
    created_at: "8/18/2024",
    updated_at: "7/10/2024"
  },
  {
    id: "tag_52aaf6ae-ea5e-4711-9d62-cf0e6f207aa4",
    name: "Matsoft",
    description: "Compact electronic drum kit for musicians of all levels.",
    type: "amenity",
    category: "Connectivity",
    created_at: "6/7/2024",
    updated_at: "1/30/2025"
  },
  {
    id: "tag_e6ea5681-e3c7-415b-870d-f2ad297e6278",
    name: "Veribet",
    description: "Protein-rich quinoa, a great alternative to rice.",
    type: "amenity",
    category: "Connectivity",
    created_at: "10/9/2024",
    updated_at: "10/27/2024"
  },
  {
    id: "tag_3ba341ce-9a2d-431f-95cd-3d50b510c45e",
    name: "Sonsing",
    description: "Magnetic puzzle assembly board for kids.",
    type: "amenity",
    category: "Monitors",
    created_at: "1/2/2025",
    updated_at: "11/1/2024"
  },
  {
    id: "tag_af609326-5302-4fc3-9276-e5da1940ad58",
    name: "Transcof",
    description: "A timeless baseball cap that adds a sporty touch to any outfit.",
    type: "amenity",
    category: "Connectivity",
    created_at: "7/5/2024",
    updated_at: "11/13/2024"
  },
  {
    id: "tag_94b463e4-02ab-42fb-aae4-fe6d515e888a",
    name: "Subin",
    description: "Durable scoop for perfectly shaped ice cream servings.",
    type: "amenity",
    category: "Furniture",
    created_at: "8/10/2024",
    updated_at: "3/2/2025"
  },
  {
    id: "tag_3a77b926-a435-43e4-994c-e08ea6e37c92",
    name: "Sub-Ex",
    description: "Sustainable bamboo utensils for cooking and serving.",
    type: "amenity",
    category: "Accessibility",
    created_at: "9/2/2024",
    updated_at: "6/18/2024"
  },
  {
    id: "tag_9ad49b18-4e0f-48d0-bb8a-c24f97775279",
    name: "Subin",
    description: "Bottle that tracks your water intake and reminds you to drink.",
    type: "amenity",
    category: "Monitors",
    created_at: "4/23/2025",
    updated_at: "11/18/2024"
  },
  {
    id: "tag_ba77f34a-d4da-4b82-a87d-447fcb867a64",
    name: "Zathin",
    description: "Non-contact thermometer for quick and easy temperature readings.",
    type: "amenity",
    category: "Furniture",
    created_at: "12/24/2024",
    updated_at: "12/11/2024"
  },
  {
    id: "tag_82dcf461-f232-4d00-a63b-feb9cf9aa658",
    name: "Zathin",
    description: "Creamy cheese with a spicy kick, perfect for sandwiches.",
    type: "amenity",
    category: "Accessibility",
    created_at: "1/2/2025",
    updated_at: "1/3/2025"
  },
  {
    id: "tag_d7cc3b7b-59f4-49c7-868a-25363c6acba4",
    name: "Daltfresh",
    description: "Heavy-duty rake with adjustable width for different gardening needs.",
    type: "amenity",
    category: "Accessibility",
    created_at: "4/20/2025",
    updated_at: "9/5/2024"
  },
  {
    id: "tag_7a2092b6-d673-457a-ab0a-6ccb8fa673cc",
    name: "Sonsing",
    description: "Convenient magnetic jars for easy spice storage.",
    type: "amenity",
    category: "Accessibility",
    created_at: "10/27/2024",
    updated_at: "1/15/2025"
  },
  {
    id: "tag_e2209949-7d5c-4acb-bba4-6f796d591134",
    name: "Alpha",
    description: "Variety pack of craft supplies for kids' projects.",
    type: "amenity",
    category: "Accessibility",
    created_at: "5/29/2024",
    updated_at: "2/16/2025"
  },
  {
    id: "tag_1601b696-c260-4d1c-af12-4a9b32db6b5e",
    name: "Alphazap",
    description: "Savory, roasted nuts seasoned with garlic and parmesan.",
    type: "amenity",
    category: "Monitors",
    created_at: "3/10/2025",
    updated_at: "4/5/2025"
  },
  {
    id: "tag_6302da2b-2535-4611-9718-9c9dd4778c3b",
    name: "Y-Solowarm",
    description: "Refreshing apple juice, 100% juice with no added sugar.",
    type: "amenity",
    category: "Connectivity",
    created_at: "7/21/2024",
    updated_at: "8/9/2024"
  },
  {
    id: "tag_92b2f40d-cdf2-43b7-8836-37f3bae4d1bc",
    name: "Stronghold",
    description: "Customizable window cover for light control and privacy.",
    type: "amenity",
    category: "Connectivity",
    created_at: "8/11/2024",
    updated_at: "4/23/2025"
  },
  {
    id: "tag_e9a9ff0a-78a3-4013-8134-7666c13dcbf9",
    name: "Stim",
    description: "Rechargeable screwdriver with multiple bits for DIY projects.",
    type: "amenity",
    category: "Connectivity",
    created_at: "1/21/2025",
    updated_at: "6/21/2024"
  },
  {
    id: "tag_5d731fe0-d98e-4951-9f5c-ba4108560b25",
    name: "Bamity",
    description: "Collapsible travel bowl for pets on the go.",
    type: "amenity",
    category: "Connectivity",
    created_at: "12/29/2024",
    updated_at: "12/27/2024"
  },
  {
    id: "tag_85e31c57-4382-4e36-b8c7-d4c22c867827",
    name: "Zoolab",
    description: "Essential attachments for pressure washing.",
    type: "amenity",
    category: "Connectivity",
    created_at: "4/21/2025",
    updated_at: "7/11/2024"
  },
  {
    id: "tag_5c333833-6bc9-422b-bc17-903e321bbd72",
    name: "Biodex",
    description: "Ready-to-drink shots made with fresh ginger and turmeric.",
    type: "amenity",
    category: "Connectivity",
    created_at: "8/17/2024",
    updated_at: "12/17/2024"
  },
  {
    id: "tag_c759a128-1378-4180-b6b3-14cdcb41184b",
    name: "It",
    description: "Foldable table for working with laptops anywhere.",
    type: "amenity",
    category: "Accessibility",
    created_at: "5/13/2024",
    updated_at: "10/5/2024"
  },
  {
    id: "tag_35e12542-1b77-4870-a48f-f732c31d0e47",
    name: "Konklab",
    description: "Inspiring cookbook with healthy recipes.",
    type: "amenity",
    category: "Furniture",
    created_at: "11/5/2024",
    updated_at: "12/8/2024"
  },
  {
    id: "tag_71889228-ec2d-4807-8e8a-df862d084ca2",
    name: "Ronstring",
    description: "High-quality voice recorder for lectures and meetings.",
    type: "amenity",
    category: "Accessibility",
    created_at: "4/13/2025",
    updated_at: "12/24/2024"
  },
  {
    id: "tag_ea383d75-5785-4e89-95fc-fdb4d6d4e3d8",
    name: "Voltsillam",
    description: "Durable cover to protect your grill from the elements.",
    type: "amenity",
    category: "Monitors",
    created_at: "11/30/2024",
    updated_at: "4/20/2025"
  },
  {
    id: "tag_c9f4f4d2-06d1-43dc-8a0e-08a1c91c2acd",
    name: "Domainer",
    description: "Rich chocolate syrup for ice cream or beverages.",
    type: "amenity",
    category: "Connectivity",
    created_at: "3/26/2025",
    updated_at: "6/26/2024"
  },
  {
    id: "tag_0442ea1c-c52a-4060-9b84-d313ae9036eb",
    name: "Rank",
    description: "Easy-to-set up tent designed for campers and hikers.",
    type: "amenity",
    category: "Monitors",
    created_at: "9/22/2024",
    updated_at: "11/18/2024"
  },
  {
    id: "tag_ace4251b-3c3a-4e5e-8004-c3f90f5209cf",
    name: "Rank",
    description: "High-quality matcha for making traditional tea or lattes.",
    type: "amenity",
    category: "Accessibility",
    created_at: "8/7/2024",
    updated_at: "1/25/2025"
  },
  {
    id: "tag_b658c848-3847-4309-9b93-37dfa18f0559",
    name: "Lotlux",
    description: "Delicious and hearty black beans, great for soups or salads.",
    type: "amenity",
    category: "Monitors",
    created_at: "6/8/2024",
    updated_at: "3/18/2025"
  },
  {
    id: "tag_72cf1d30-8a34-4974-9d36-610ff8c5c65a",
    name: "Zoolab",
    description: "Gentle grooming gloves for shedding pets.",
    type: "amenity",
    category: "Accessibility",
    created_at: "1/17/2025",
    updated_at: "1/4/2025"
  },
  {
    id: "tag_3d9b3eca-3f97-4b00-ad2a-65aafb1aa0fb",
    name: "Cookley",
    description: "Classic V-neck sweater crafted from soft wool for warmth and style.",
    type: "amenity",
    category: "Accessibility",
    created_at: "6/26/2024",
    updated_at: "3/7/2025"
  },
  {
    id: "tag_8ea44b9b-bb87-4a49-80d2-8207414e23e7",
    name: "Prodder",
    description: "Fast and convenient air pump for inflating toys and furniture.",
    type: "amenity",
    category: "Accessibility",
    created_at: "1/1/2025",
    updated_at: "11/23/2024"
  },
  {
    id: "tag_23f2d2ce-1a7f-47e3-a668-82a6a39509bd",
    name: "Overhold",
    description: "Instant oats with a savory twist, such as herbs and spices.",
    type: "amenity",
    category: "Accessibility",
    created_at: "10/20/2024",
    updated_at: "8/17/2024"
  },
  {
    id: "tag_cf325571-7da8-4610-95db-862d5902f2f3",
    name: "Cardguard",
    description: "1080p wireless security camera with night vision.",
    type: "amenity",
    category: "Accessibility",
    created_at: "3/1/2025",
    updated_at: "7/18/2024"
  },
  {
    id: "tag_351b0539-2aa8-42a5-bcc1-b6c00fa7e7e0",
    name: "Bigtax",
    description: "Smooth soup made from carrots and ginger, great for cold days.",
    type: "amenity",
    category: "Furniture",
    created_at: "1/24/2025",
    updated_at: "10/3/2024"
  },
  {
    id: "tag_c34daa55-17e0-4d66-81d7-94c53b67473d",
    name: "Wrapsafe",
    description: "Marinated chicken thighs with smoked paprika for a smoky flavor.",
    type: "amenity",
    category: "Accessibility",
    created_at: "2/8/2025",
    updated_at: "4/8/2025"
  },
  {
    id: "tag_f8a44cf8-9b2b-45b0-823c-d2a30a81028a",
    name: "Tresom",
    description: "Sweetened powder for refreshing lemonade.",
    type: "amenity",
    category: "Accessibility",
    created_at: "5/24/2024",
    updated_at: "3/2/2025"
  },
  {
    id: "tag_60f6ca27-f8a6-4a44-a627-7ede3313fc2d",
    name: "Tres-Zap",
    description: "Soft and delicious garlic-infused flatbread, perfect for dipping.",
    type: "amenity",
    category: "Furniture",
    created_at: "7/22/2024",
    updated_at: "4/15/2025"
  },
  {
    id: "tag_189c7571-e588-4845-b0ff-ab28df64bb14",
    name: "Greenlam",
    description: "Classic cereal made with whole grains and honey.",
    type: "amenity",
    category: "Connectivity",
    created_at: "5/16/2024",
    updated_at: "2/11/2025"
  },
  {
    id: "tag_1590fb8f-e3d4-4532-b1d0-04e2d671f314",
    name: "Bamity",
    description: "Regulate water temperature for safe and comfortable showers.",
    type: "amenity",
    category: "Accessibility",
    created_at: "7/9/2024",
    updated_at: "9/7/2024"
  },
  {
    id: "tag_b5cc6209-2856-4caa-8b32-58a76523bc8f",
    name: "Redhold",
    description: "No-bake energy bites made with peanut butter and oats.",
    type: "amenity",
    category: "Connectivity",
    created_at: "4/20/2025",
    updated_at: "12/24/2024"
  },
  {
    id: "tag_ad6750c3-88a0-4ecb-bb0b-a766346c4ac5",
    name: "Latlux",
    description: "USB hub for expanding ports on computers and laptops.",
    type: "amenity",
    category: "Monitors",
    created_at: "3/25/2025",
    updated_at: "4/2/2025"
  },
  {
    id: "tag_36b41d45-6d3a-4967-8c29-e1f3941a4481",
    name: "Holdlamis",
    description: "Fresh zucchini, versatile for grilling or saut\xE9ing.",
    type: "amenity",
    category: "Connectivity",
    created_at: "9/30/2024",
    updated_at: "1/24/2025"
  },
  {
    id: "tag_beb800f2-17dd-428e-8e54-df7898ebec0a",
    name: "Hatity",
    description: "Healthy fruit snacks, made with real fruit.",
    type: "amenity",
    category: "Monitors",
    created_at: "1/24/2025",
    updated_at: "7/27/2024"
  },
  {
    id: "tag_4b7e53be-7c9e-4080-9a4e-60b43af451cc",
    name: "Konklux",
    description: "A warm and sustainable wool scarf for chilly days.",
    type: "amenity",
    category: "Accessibility",
    created_at: "9/8/2024",
    updated_at: "4/17/2025"
  },
  {
    id: "tag_38f51840-e073-47a9-87da-4c3238c5cffa",
    name: "Keylex",
    description: "Lightweight and portable picnic table for outdoor use.",
    type: "amenity",
    category: "Monitors",
    created_at: "5/24/2024",
    updated_at: "12/25/2024"
  },
  {
    id: "tag_d9efd78e-f0c0-4be3-9a94-2904645d65b1",
    name: "Flexidy",
    description: "Freshly roasted coffee beans with rich flavor.",
    type: "amenity",
    category: "Furniture",
    created_at: "1/26/2025",
    updated_at: "11/3/2024"
  },
  {
    id: "tag_24b58dea-eecc-4e3a-9355-cf833b778038",
    name: "Y-Solowarm",
    description: "Reusable microfiber cloths for environmentally friendly cleaning.",
    type: "amenity",
    category: "Connectivity",
    created_at: "9/28/2024",
    updated_at: "3/26/2025"
  },
  {
    id: "tag_707be885-b7f4-4333-ac08-d821c1f6ce8b",
    name: "Flexidy",
    description: "Battery-operated blender for smoothies on the go.",
    type: "amenity",
    category: "Accessibility",
    created_at: "5/15/2024",
    updated_at: "1/22/2025"
  },
  {
    id: "tag_16684341-6b65-4eb7-acc2-fa4f7b56bfe3",
    name: "Tin",
    description: "Easily opens jar lids and bottle caps with one touch.",
    type: "amenity",
    category: "Connectivity",
    created_at: "4/21/2025",
    updated_at: "10/29/2024"
  },
  {
    id: "tag_e0c95239-3a6f-4125-9bf6-62c0bd7bec21",
    name: "Bigtax",
    description: "Frozen cauliflower rice blended with mixed vegetables and seasonings.",
    type: "amenity",
    category: "Connectivity",
    created_at: "8/14/2024",
    updated_at: "7/10/2024"
  },
  {
    id: "tag_b8a146e5-6b70-441e-a5bb-f684cb099c9b",
    name: "Fix San",
    description: "Sweet and chewy dried mango slices, perfect for snacking.",
    type: "amenity",
    category: "Accessibility",
    created_at: "10/26/2024",
    updated_at: "1/9/2025"
  },
  {
    id: "tag_4c91b263-70df-4c36-a0d4-556178081dbe",
    name: "Job",
    description: "Water-resistant blanket for picnics and outdoor events.",
    type: "amenity",
    category: "Furniture",
    created_at: "7/9/2024",
    updated_at: "5/22/2024"
  },
  {
    id: "tag_da509c94-cfd7-4e82-921d-0d2d569da0db",
    name: "Pannier",
    description: "Floral and refreshing herbal tea, great hot or iced.",
    type: "amenity",
    category: "Furniture",
    created_at: "6/26/2024",
    updated_at: "3/31/2025"
  },
  {
    id: "tag_99fe6642-7c79-43ef-9410-e8719e5447b8",
    name: "Mat Lam Tam",
    description: "Complete set of cooking utensils made from bamboo.",
    type: "amenity",
    category: "Connectivity",
    created_at: "12/3/2024",
    updated_at: "9/4/2024"
  },
  {
    id: "tag_84e7bb41-9771-4b2b-a7ec-e01f7a0193ef",
    name: "Stringtough",
    description: "Wi-Fi camera with motion detection for home security.",
    type: "amenity",
    category: "Connectivity",
    created_at: "5/31/2024",
    updated_at: "12/23/2024"
  },
  {
    id: "tag_0fb1a2f4-2b58-4987-902a-766bc3657bbb",
    name: "Otcom",
    description: "Layers of pasta, veggies, and cheese baked to perfection.",
    type: "amenity",
    category: "Furniture",
    created_at: "11/25/2024",
    updated_at: "7/24/2024"
  },
  {
    id: "tag_2bd16e14-1fa0-47cf-aec8-1adccf17294a",
    name: "Viva",
    description: "Rugged phone case for drop protection.",
    type: "amenity",
    category: "Accessibility",
    created_at: "9/13/2024",
    updated_at: "9/23/2024"
  },
  {
    id: "tag_aa993468-b445-47c8-a60d-0e4c7a5f489c",
    name: "Voyatouch",
    description: "Protective gaiters to keep dirt and debris out of shoes during hikes.",
    type: "amenity",
    category: "Monitors",
    created_at: "5/19/2024",
    updated_at: "4/8/2025"
  },
  {
    id: "tag_0018d9da-1201-44e6-96dd-97fb56670332",
    name: "Treeflex",
    description: "A classic denim jacket that never goes out of style.",
    type: "amenity",
    category: "Accessibility",
    created_at: "3/15/2025",
    updated_at: "9/10/2024"
  },
  {
    id: "tag_829fcd00-f16a-4b2d-a62b-9b90a865b854",
    name: "Bitwolf",
    description: "Flavored aioli made with roasted garlic",
    type: "amenity",
    category: "Monitors",
    created_at: "4/6/2025",
    updated_at: "1/23/2025"
  },
  {
    id: "tag_97e3bb4b-1aa9-4598-a5e1-f839418520a9",
    name: "Greenlam",
    description: "A calming blanket that provides gentle pressure for relaxation.",
    type: "amenity",
    category: "Furniture",
    created_at: "5/20/2024",
    updated_at: "6/15/2024"
  },
  {
    id: "tag_58be793f-a8dd-4a6b-8b94-b7ea096207f6",
    name: "Vagram",
    description: "Refreshing coconut water, perfect for hydration.",
    type: "amenity",
    category: "Accessibility",
    created_at: "6/4/2024",
    updated_at: "8/8/2024"
  },
  {
    id: "tag_4cc4bfbc-af77-4f14-af58-da1b6630683f",
    name: "Y-find",
    description: "A mix of wild rice with herbs and spices, ready to serve.",
    type: "amenity",
    category: "Connectivity",
    created_at: "12/24/2024",
    updated_at: "11/26/2024"
  },
  {
    id: "tag_7a15f312-4298-4717-8add-e13aa4be7a0f",
    name: "Hatity",
    description: "Protects surfaces while baking or cooking with hot items.",
    type: "amenity",
    category: "Accessibility",
    created_at: "10/15/2024",
    updated_at: "6/27/2024"
  },
  {
    id: "tag_b74f819a-27ca-436c-a4c2-92512a55cba4",
    name: "Y-Solowarm",
    description: "Fluffy biscuits made without gluten",
    type: "amenity",
    category: "Monitors",
    created_at: "4/20/2025",
    updated_at: "2/20/2025"
  },
  {
    id: "tag_d9f9cfe8-a604-4628-bc15-f2da3bfb0d81",
    name: "Bitchip",
    description: "Gluten-free pancake mix made with almond flour.",
    type: "amenity",
    category: "Accessibility",
    created_at: "5/12/2024",
    updated_at: "10/22/2024"
  },
  {
    id: "tag_e7c9d0df-8206-4bd5-a4e8-de4f59df1205",
    name: "Trippledex",
    description: "Eco-friendly bamboo holder for toothbrushes.",
    type: "amenity",
    category: "Accessibility",
    created_at: "1/19/2025",
    updated_at: "7/19/2024"
  },
  {
    id: "tag_1830c0dc-70fa-4390-884b-985ed4e5bb29",
    name: "Matsoft",
    description: "Training tool for reinforcing commands and behavior in dogs.",
    type: "amenity",
    category: "Accessibility",
    created_at: "10/10/2024",
    updated_at: "4/13/2025"
  },
  {
    id: "tag_f7500ad8-94a2-4791-9bbb-289dc7cab05a",
    name: "Namfix",
    description: "Automatically cooks eggs to your desired level.",
    type: "amenity",
    category: "Furniture",
    created_at: "7/19/2024",
    updated_at: "3/31/2025"
  },
  {
    id: "tag_c7727eb4-b936-4299-a4ec-99036be459d5",
    name: "Home Ing",
    description: "Stylish and modern holder for storing wine bottles on walls.",
    type: "amenity",
    category: "Furniture",
    created_at: "5/26/2024",
    updated_at: "4/25/2025"
  },
  {
    id: "tag_50f1c45e-4a14-4990-9ab4-6abc9c8a2e2f",
    name: "Fintone",
    description: "Creamy ice cream made with real vanilla beans, perfect for desserts.",
    type: "amenity",
    category: "Furniture",
    created_at: "3/7/2025",
    updated_at: "5/13/2024"
  },
  {
    id: "tag_c2e2ef61-afb0-4944-a156-27f6628f35a7",
    name: "Quo Lux",
    description: "Natural mineral salt with a subtle flavor, ideal for cooking and seasoning.",
    type: "amenity",
    category: "Monitors",
    created_at: "7/7/2024",
    updated_at: "11/21/2024"
  },
  {
    id: "tag_11159052-1229-48d9-a5dc-c2cec40bb5ea",
    name: "Ronstring",
    description: "64GB SD memory card for cameras and devices.",
    type: "amenity",
    category: "Furniture",
    created_at: "3/1/2025",
    updated_at: "3/23/2025"
  },
  {
    id: "tag_7e526e47-5503-4124-8d35-55eab5b8f021",
    name: "Biodex",
    description: "Comfortable carrier for small pets during travel.",
    type: "amenity",
    category: "Furniture",
    created_at: "3/31/2025",
    updated_at: "8/10/2024"
  },
  {
    id: "tag_6b741395-8a0e-4cbc-80c3-ea7656689d89",
    name: "Kanlam",
    description: "Small fridge designed to keep skincare products cool and fresh.",
    type: "amenity",
    category: "Accessibility",
    created_at: "3/7/2025",
    updated_at: "8/11/2024"
  },
  {
    id: "tag_26cbf592-06ed-47e9-8f3c-08fe66a83023",
    name: "Ronstring",
    description: "Electric rice cooker with multiple cooking settings for perfect rice.",
    type: "amenity",
    category: "Furniture",
    created_at: "3/24/2025",
    updated_at: "12/16/2024"
  },
  {
    id: "tag_ffd67421-119b-4233-8671-e9710888c043",
    name: "Temp",
    description: "Nutrient-rich broccoli, easy to add to any meal.",
    type: "amenity",
    category: "Furniture",
    created_at: "11/10/2024",
    updated_at: "2/24/2025"
  },
  {
    id: "tag_7ba08d36-7342-4f7e-83d5-6436094b5dfe",
    name: "Sonair",
    description: "Compact, waterproof blanket for picnics and events.",
    type: "amenity",
    category: "Accessibility",
    created_at: "8/6/2024",
    updated_at: "6/2/2024"
  },
  {
    id: "tag_5e4fceac-31bf-4a4a-b3d3-f6d39648668d",
    name: "Zoolab",
    description: "Eco-friendly bamboo toothbrush for sustainable living.",
    type: "amenity",
    category: "Accessibility",
    created_at: "9/8/2024",
    updated_at: "2/3/2025"
  }
];

// src/mocks/tags/tag-resources.ts
var mockTagResources = [
  {
    resource_id: "reso_c0ca50d4-1b18-f5b7-015f-d69f8c8da33c",
    tag_id: "tag_9c4e97df-a809-4ac6-90fa-f08588f3da8e",
    description: "Wi-Fi at reception",
    photo_url: "https://tinyurl.com/4rm5hpdd"
  },
  {
    resource_id: "reso_4059c462-8cad-1fcb-7f29-17793c53894d",
    tag_id: "tag_9c4e97df-a809-4ac6-90fa-f08588f3da8e",
    description: "Wi-Fi at reception",
    photo_url: "https://tinyurl.com/4rm5hpdd"
  },
  {
    resource_id: "reso_6de1f24c-1919-931c-0814-7c42ac1c06f1",
    tag_id: "tag_9c4e97df-a809-4ac6-90fa-f08588f3da8e",
    description: "Wi-Fi at reception",
    photo_url: "https://tinyurl.com/4rm5hpdd"
  },
  {
    resource_id: "reso_ab9be9f0-681a-5a53-c2f1-01f5bf74ee6b",
    tag_id: "tag_9c4e97df-a809-4ac6-90fa-f08588f3da8e",
    description: "Wi-Fi at reception",
    photo_url: "https://tinyurl.com/4rm5hpdd"
  },
  {
    resource_id: "reso_35e9ff18-da67-9154-2da5-9206ac0f5103",
    tag_id: "tag_36b41d45-6d3a-4967-8c29-e1f3941a4481",
    description: "Wi-Fi at reception",
    photo_url: "https://tinyurl.com/4rm5hpdd"
  },
  {
    resource_id: "reso_e59bd2ff-39b8-0454-13e0-983e7178b48a",
    tag_id: "tag_36b41d45-6d3a-4967-8c29-e1f3941a4481",
    description: "Wi-Fi at reception",
    photo_url: "https://tinyurl.com/4rm5hpdd"
  },
  {
    resource_id: "reso_fccb0856-eda0-fe46-8e24-61de9235df29",
    tag_id: "tag_36b41d45-6d3a-4967-8c29-e1f3941a4481",
    description: "Wi-Fi at reception",
    photo_url: "https://tinyurl.com/4rm5hpdd"
  },
  {
    resource_id: "reso_c0ca50d4-1b18-f5b7-015f-d69f8c8da33c",
    tag_id: "tag_1c58ca48-9007-45d3-8e26-14998f00e08a",
    description: "Wi-Fi at reception",
    photo_url: "https://tinyurl.com/4rm5hpdd"
  },
  {
    resource_id: "reso_13edb374-c367-cefc-8071-38a2443624bd",
    tag_id: "tag_1c58ca48-9007-45d3-8e26-14998f00e08a",
    description: "Wi-Fi at reception",
    photo_url: "https://tinyurl.com/4rm5hpdd"
  },
  {
    resource_id: "reso_301e5137-8afd-4a54-af3b-aaa2e0eb64ea",
    tag_id: "tag_1c58ca48-9007-45d3-8e26-14998f00e08a",
    description: "Wi-Fi at reception",
    photo_url: "https://tinyurl.com/4rm5hpdd"
  },
  {
    resource_id: "reso_c1d1940d-d3e6-7444-411c-caed297874e2",
    tag_id: "tag_1c58ca48-9007-45d3-8e26-14998f00e08a",
    description: "Wi-Fi at reception",
    photo_url: "https://tinyurl.com/4rm5hpdd"
  },
  {
    resource_id: "reso_ff2854bf-220e-478b-9768-d3db5d29e07f",
    tag_id: "tag_1c58ca48-9007-45d3-8e26-14998f00e08a",
    description: "Wi-Fi at reception",
    photo_url: "https://tinyurl.com/4rm5hpdd"
  }
];

// src/mocks/tags/categories.ts
var MOCK_TAG_CATEGORIES = [
  {
    id: "Monitors",
    name: "Monitors",
    description: "Monitors"
  },
  {
    id: "Furniture",
    name: "Furniture",
    description: "Furniture"
  },
  {
    id: "Connectivity",
    name: "Connectivity",
    description: "Connectivity"
  },
  {
    id: "Accessibility",
    name: "Accessibility",
    description: "Accessibility"
  }
];

// src/mocks/tags.ts
var mockTags2 = [];
var mockTagResources2 = [];
var LOCAL_STORAGE_TAGS_KEY = "mockTags";
var LOCAL_STORAGE_RESOURCES_KEY = "mockTagResources";
function saveToStorage() {
  localStorage == null ? void 0 : localStorage.setItem(LOCAL_STORAGE_TAGS_KEY, JSON.stringify(mockTags2));
  localStorage == null ? void 0 : localStorage.setItem(
    LOCAL_STORAGE_RESOURCES_KEY,
    JSON.stringify(mockTagResources2)
  );
}
function loadFromStorage() {
  const tags = localStorage == null ? void 0 : localStorage.getItem(LOCAL_STORAGE_TAGS_KEY);
  const resources = localStorage == null ? void 0 : localStorage.getItem(LOCAL_STORAGE_RESOURCES_KEY);
  mockTags2 = tags ? JSON.parse(tags) : mockTags;
  mockTagResources2 = resources ? JSON.parse(resources) : mockTagResources;
}
function generateId() {
  return Math.random().toString(36).substring(2, 10);
}
var mockTagApi = {
  getTags(filters) {
    loadFromStorage();
    let results = mockTags2;
    if (filters == null ? void 0 : filters.id) {
      results = results.filter((tag) => tag.id === filters.id);
    }
    if (filters == null ? void 0 : filters.type) {
      results = results.filter((tag) => tag.type === filters.type);
    }
    return { tags: results };
  },
  getTag(id) {
    loadFromStorage();
    return mockTags2.find((tag) => tag.id === id);
  },
  createTag(tag) {
    loadFromStorage();
    const newTag = {
      id: generateId(),
      name: tag.name || "",
      description: tag.description || "",
      category: tag.category || "",
      type: tag.type || "amenity",
      created_at: (/* @__PURE__ */ new Date()).toISOString(),
      updated_at: (/* @__PURE__ */ new Date()).toISOString()
    };
    mockTags2.push(newTag);
    saveToStorage();
    return newTag;
  },
  updateTag(id, data) {
    loadFromStorage();
    const index = mockTags2.findIndex((t) => t.id === id);
    if (index === -1) return void 0;
    const updatedTag = __spreadProps(__spreadValues(__spreadValues({}, mockTags2[index]), data), {
      updated_at: (/* @__PURE__ */ new Date()).toISOString()
    });
    mockTags2[index] = updatedTag;
    saveToStorage();
    return updatedTag;
  },
  deleteTag(id) {
    loadFromStorage();
    const initialLength = mockTags2.length;
    mockTags2 = mockTags2.filter((t) => t.id !== id);
    saveToStorage();
    return { success: mockTags2.length < initialLength };
  },
  getCategories() {
    loadFromStorage();
    return { categories: MOCK_TAG_CATEGORIES };
  },
  getResourceTags(resourceId) {
    loadFromStorage();
    const tagIds = mockTagResources2.filter((r) => r.resource_id === resourceId).map((r) => r.tag_id);
    const tags = mockTags2.filter((t) => tagIds.includes(t.id));
    return { tags };
  },
  addTagToResource(resourceId, payload) {
    loadFromStorage();
    const resources = Array.isArray(payload) ? payload : [payload];
    for (const res of resources) {
      mockTagResources2.push(__spreadProps(__spreadValues({}, res), {
        resource_id: resourceId,
        tag_id: res.tag_id,
        description: res.description || "",
        photo_url: res.photo_url || ""
      }));
    }
    saveToStorage();
    return this.getResourceTags(resourceId);
  },
  updateResourceTag(resourceId, tagId, updates) {
    loadFromStorage();
    const index = mockTagResources2.findIndex(
      (r) => r.resource_id === resourceId && r.tag_id === tagId
    );
    if (index !== -1) {
      mockTagResources2[index] = __spreadValues(__spreadValues({}, mockTagResources2[index]), updates);
    }
    saveToStorage();
    return this.getResourceTags(resourceId);
  },
  deleteResourceTag(resourceId, tagId) {
    loadFromStorage();
    mockTagResources2 = mockTagResources2.filter(
      (r) => !(r.resource_id === resourceId && r.tag_id === tagId)
    );
    saveToStorage();
    return this.getResourceTags(resourceId);
  }
};
var mockTagsToResources = (resources) => {
  loadFromStorage();
  return resources.map((resource) => {
    const tags = mockTagResources2.filter((r) => r.resource_id === resource.id).map((r) => mockTags2.find((t) => t.id === r.tag_id)).filter(Boolean);
    return __spreadProps(__spreadValues({}, resource), {
      tags
    });
  });
};

// src/utils/objectToFiltersQuery.ts
function objectToFiltersQuery(obj) {
  if (!obj) return "";
  const params = new URLSearchParams();
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (value === void 0 || value === null || value === "" || Array.isArray(value) && value.length === 0) {
      return;
    }
    if (Array.isArray(value)) {
      params.append(key, value.join(","));
    } else {
      params.append(key, String(value));
    }
  });
  const queryString = params.toString();
  return queryString ? `?${queryString}` : "";
}

// src/endpoints/tags.ts
var ENABLE_TAGS_MOCK = false;
var Tags = class extends BaseOrganizationEndpoints {
  getTags(filters) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/v1/tags${objectToFiltersQuery(filters)}`
      );
    });
  }
  getTag(pageFilters) {
    return __async(this, null, function* () {
      if (!pageFilters.id) throw new Error("Tag ID is required");
      if (ENABLE_TAGS_MOCK) {
        return mockTagApi.getTag(pageFilters.id);
      }
      return yield this.requestWithStatus(
        "GET",
        `/v1/tags/${pageFilters.id}`
      );
    });
  }
  createTag(tag) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", "/v1/tags", tag);
    });
  }
  updateTag(idTag, tag) {
    return __async(this, null, function* () {
      if (ENABLE_TAGS_MOCK) {
        return mockTagApi.updateTag(idTag, tag);
      }
      return this.requestWithStatus("PUT", `/v1/tags/${idTag}`, tag);
    });
  }
  deleteTag(idTag) {
    return __async(this, null, function* () {
      if (ENABLE_TAGS_MOCK) {
        return mockTagApi.deleteTag(idTag);
      }
      return this.requestWithStatus(
        "DELETE",
        `/v1/tags/${idTag}`
      );
    });
  }
  getCategories() {
    return __async(this, null, function* () {
      if (ENABLE_TAGS_MOCK) {
        return mockTagApi.getCategories();
      }
      return this.requestWithStatus(
        "GET",
        "/v1/tags/categories"
      );
    });
  }
  getResourceTags(idResource) {
    return __async(this, null, function* () {
      if (ENABLE_TAGS_MOCK) {
        return mockTagApi.getResourceTags(idResource);
      }
      return this.requestWithStatus(
        "GET",
        `/v1/resources/${idResource}/tags`
      );
    });
  }
  addTagToResource(idResource, resourceTag) {
    return __async(this, null, function* () {
      if (ENABLE_TAGS_MOCK) {
        return mockTagApi.addTagToResource(idResource, resourceTag);
      }
      if (Array.isArray(resourceTag)) {
        return this.requestWithStatus(
          "POST",
          `/v1/resources/${idResource}/tags/batch`,
          { tags: resourceTag }
        );
      }
      return this.requestWithStatus(
        "POST",
        `/v1/resources/${idResource}/tags`,
        resourceTag
      );
    });
  }
  updateResourceTag(idResource, idTag, resourceTag) {
    return __async(this, null, function* () {
      if (ENABLE_TAGS_MOCK) {
        return mockTagApi.updateResourceTag(idResource, idTag, resourceTag);
      }
      return this.requestWithStatus(
        "PUT",
        `/v1/resources/${idResource}/tags/${idTag}`,
        resourceTag
      );
    });
  }
  deleteResourceTag(idResource, idTag) {
    return __async(this, null, function* () {
      if (ENABLE_TAGS_MOCK) {
        return mockTagApi.deleteResourceTag(idResource, idTag);
      }
      return this.requestWithStatus(
        "DELETE",
        `/v1/resources/${idResource}/tags/${idTag}`
      );
    });
  }
};

// ../helpers/src/objects/objectToQueryString.ts
function objectToQueryString(params) {
  const query = Object.entries(params).filter(
    ([_, value]) => value !== void 0 && value !== null && value !== ""
  ).map(
    ([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
  ).join("&");
  return query ? `?${query}` : "";
}

// src/endpoints/organizations.ts
var Organizations = class _Organizations extends BaseOrganizationEndpoints {
  static resourceFormatter(node, formattedChildren) {
    if (formattedChildren !== null) {
      let totalAvailableSlots = 0, totalInnerSlots = 0, totalReservedSlots = 0;
      for (const element of formattedChildren) {
        totalAvailableSlots += element.available_slots;
        totalInnerSlots += element.total_slots;
        totalReservedSlots += element.reserved_slots;
      }
      return __spreadProps(__spreadValues({}, node.resource), {
        available_slots: totalAvailableSlots,
        reserved_slots: totalReservedSlots,
        total_slots: totalInnerSlots,
        options: formattedChildren
      });
    }
    return __spreadValues({}, node.resource);
  }
  get(slug) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/organizations/${encodeURIComponent(slug)}`
      );
    });
  }
  getById(authorization, id) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/id/organizations/${id}`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  /**
   * Primary endpoint for returning the current authenticated user, within the context of the current org
   */
  getOrgMe() {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/user`
      );
    });
  }
  isDeskBookingEnabled(organization) {
    return organization.desk_bookings_enabled;
  }
  isParkingBookingEnabled(organization) {
    return organization.parking_bookings_enabled;
  }
  isMeetingRoomBookingEnabled(organization) {
    return organization.meeting_room_bookings_enabled;
  }
  /**
   * Updated the organization's logo with the provided image URL
   */
  updateIcon(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("PUT", "/organizations/logo", body);
    });
  }
  updateQuestionnaireSettings(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        "/organizations/questionnaire/settings",
        body
      );
    });
  }
  updateGeneralSettings(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        "/organizations/general/settings",
        body
      );
    });
  }
  join() {
    return __async(this, null, function* () {
      const response = yield this.requestWithStatus("GET", "/invitations/join");
      return __spreadProps(__spreadValues({}, response), {
        result: {
          enabled: response.result ? response.result.enabled : false,
          url: response.result && response.result.enabled ? this.getJoinUrl(response.result.join) : null
        }
      });
    });
  }
  joinEnable(body) {
    return __async(this, null, function* () {
      const response = yield this.requestWithStatus("PUT", "/invitations/join", body);
      return __spreadProps(__spreadValues({}, response), {
        result: {
          enabled: response.result ? response.result.enabled : false,
          url: response.result && response.result.enabled ? this.getJoinUrl(response.result.join) : null
        }
      });
    });
  }
  /**
   * Creates the authenticatedUser object for the currently
   * authenticated user.
   */
  me(user, organization, organizations, offices, designSystemVersion) {
    var _a, _b;
    const slug = this.getSlug();
    const authenticatedUser = {
      user,
      slug,
      redirect: {
        setup: false,
        login: false,
        subdomain: null,
        url: null
      },
      permissions: {
        all: [],
        impersonate: false,
        schedule_others: false,
        schedule_others_managed: false,
        schedule_respond: false,
        settings: false,
        enterprise: false
      },
      organizations: organizations ? organizations.elements : [],
      organization,
      offices: offices ? offices : null,
      officeId: offices && offices.officeId ? offices.officeId : null,
      defaultAreaId: (_b = (_a = user == null ? void 0 : user.organization_user) == null ? void 0 : _a.default_area_id) != null ? _b : null,
      designSystemVersion
    };
    const defaultOfficeNotDeleted = offices ? offices.offices.some(
      (office) => office.id === user.organization_user.default_office_id
    ) : false;
    const validDefaultOfficeId = offices && defaultOfficeNotDeleted ? user.organization_user.default_office_id : offices == null ? void 0 : offices.offices[0].id;
    if (authenticatedUser.offices) {
      authenticatedUser.offices.officeId = validDefaultOfficeId != null ? validDefaultOfficeId : null;
    }
    const permissions = user.organization_user ? user.organization_user.permissions : [];
    authenticatedUser.permissions = {
      all: permissions,
      impersonate: permissions.includes("admin:impersonate"),
      schedule_others: permissions.includes("schedule:others:add"),
      schedule_others_managed: permissions.includes(
        "schedule:others:managed:add"
      ),
      schedule_respond: permissions.includes("schedule:respond"),
      settings: permissions.includes("office:add"),
      enterprise: permissions.includes("organization:enterprise")
    };
    return authenticatedUser;
  }
  updateMe(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("PUT", "/user", body);
    });
  }
  getUserByEmail(authorization, organizationId, email) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/organizations/${organizationId}/users/${email}`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  updateUserPhoto(authorization, organizationId, userId, url) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/organizations/${organizationId}/users/${userId}/photo`,
        {
          profile_photo_url: url
        },
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
  restrictions(_0) {
    return __async(this, arguments, function* (officeId, resourceIds = [], dates, duration = null) {
      const params = new URLSearchParams();
      dates.forEach((x) => {
        params.append("date", x);
        if (duration) {
          params.append("duration", duration.toString());
        }
      });
      resourceIds.forEach((resId) => params.append("resource", resId));
      return yield this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/restrictions?${params.toString()}`
      );
    });
  }
  /**
   * Updates the user's profile image with the provided image
   */
  updatePhoto(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("PUT", "/user/logo", body);
    });
  }
  /**
   * Update a users's default office, within the context of the organization
   */
  updateDefaultOffice(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("PUT", "/user/offices/default", body);
    });
  }
  resetPassword(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("DELETE", "/user/password", body);
    });
  }
  /**
   * Update the organization's settings
   */
  update(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("PUT", "/organizations", body);
    });
  }
  usersPaginated(filters, managed = false) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/users${managed ? "/managed" : ""}?${filters.toString()}`
      );
    });
  }
  usersWithOptions(_0, _1) {
    return __async(this, arguments, function* (query, roles, pagination = {
      cursor: null,
      limit: null
    }, managed = false) {
      const res = yield this.users(query, roles, pagination, managed);
      if (res.ok && res.result) {
        const formatted = formatOptions(
          res.result
        );
        return __spreadProps(__spreadValues({}, res), { result: formatted });
      }
      return res;
    });
  }
  organizationUsers(authorization, organizationId, roles, pagination) {
    return __async(this, null, function* () {
      const params = new URLSearchParams();
      if (roles) {
        roles.forEach((role) => params.append("role", role));
      }
      const parmsString = params.toString();
      return this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl(
          `/organizations/${organizationId}/users`,
          pagination
        ) + (parmsString ? `&${parmsString}` : ""),
        null,
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  users(_0, _1) {
    return __async(this, arguments, function* (query, roles, pagination = {
      cursor: null,
      limit: null
    }, managed = false) {
      var _a, _b;
      const result = {
        letters: {},
        cursor: null,
        elements: []
      };
      const params = new URLSearchParams();
      if (query) {
        params.set("query", query);
      }
      if (roles) {
        roles.forEach((role) => params.append("role", role));
      }
      const parmsString = params.toString();
      const response = yield this.requestWithStatus(
        "GET",
        this.paginatedEndpointUrl(
          `${this.settings.adminAuth ? "/integrations" : ""}/users` + (managed ? "/managed" : ""),
          pagination
        ) + (parmsString ? `&${parmsString}` : "")
      );
      if (!response.ok) {
        return response;
      }
      result.cursor = ((_a = response.result) == null ? void 0 : _a.cursor) || null;
      result.elements = ((_b = response.result) == null ? void 0 : _b.elements) || [];
      for (const element of result.elements) {
        const name = (element.name || element.email || "").trim();
        if (name.length === 0) {
          continue;
        }
        const letter = name.slice(name.lastIndexOf(" ") + 1)[0].toUpperCase();
        if (typeof result.letters[letter] === "undefined") {
          result.letters[letter] = [];
        }
        result.letters[letter].push(element);
      }
      return __spreadProps(__spreadValues({}, response), { result });
    });
  }
  /**
   * @deprecated use teams.forUser()
   */
  userTeamList(userId, showHidden = false) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/users/${encodeURIComponent(userId)}/teams${showHidden ? "?hidden" : ""}`
      );
    });
  }
  usersById(ids) {
    return __async(this, null, function* () {
      const all = ids.map(
        (id) => this.requestWithStatus(
          "GET",
          `/users/${encodeURIComponent(id)}`
        )
      );
      const results = yield Promise.all(all);
      return results.filter((x) => x.ok).map((x) => x.result);
    });
  }
  user(id, showHidden = false) {
    return __async(this, null, function* () {
      const promises = yield Promise.all([
        this.requestWithStatus(
          "GET",
          `/users/${encodeURIComponent(id)}`
        ),
        this.requestWithStatus(
          "GET",
          `/users/${encodeURIComponent(id)}/colleagues`
        ),
        this.userTeamList(id, showHidden)
      ]);
      promises.forEach((prom, i) => {
        if (!prom.ok) {
          throw new Error(
            `Organizations.user(${id}): Impossible to complete request #${i} - ${JSON.stringify(prom.result)}`
          );
        }
      });
      const [user, colleagues, teams] = promises.map((x) => x.result);
      return {
        user,
        colleagues,
        teams
      };
    });
  }
  userColleagues(id) {
    return this.requestWithStatus(
      "GET",
      `/users/${encodeURIComponent(id)}/colleagues`
    );
  }
  userUpdate(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/users/${encodeURIComponent(id)}`,
        body
      );
    });
  }
  userDelete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/users/${encodeURIComponent(id)}`
      );
    });
  }
  /**
   * Gets all of an organizations offices
   */
  offices() {
    return __async(this, null, function* () {
      const noAdminEndpoint = "/v1/offices";
      const adminEndpoint = "/integrations/offices";
      const response = yield this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? adminEndpoint : noAdminEndpoint}?limit=` + BaseOrganizationEndpoints.MAXIMUM_LIMIT
      );
      if (!response.ok) {
        return response;
      }
      return __spreadProps(__spreadValues({}, response), {
        result: response && response.result && response.result.elements && response.result.elements.length > 0 ? yield this.formatOffices(response.result) : null
      });
    });
  }
  /**
   * Returns the details of a single office
   */
  office(id) {
    return __async(this, null, function* () {
      const office = yield this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/offices/${encodeURIComponent(id)}`
      );
      return office;
    });
  }
  officeAdd(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/offices", body);
    });
  }
  officeUpdate(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/offices/${encodeURIComponent(id)}`,
        body
      );
    });
  }
  officeDelete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/offices/${encodeURIComponent(id)}`
      );
    });
  }
  updateOfficeReservationSettings(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/offices/${encodeURIComponent(id)}/reservation/settings`,
        body
      );
    });
  }
  /**
   * @deprecated use teams.all()
   */
  teams(showHidden = false) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/teams${showHidden ? "?hidden" : ""}`
      );
    });
  }
  /**
   * @deprecated use teams.all()
   */
  teamsWithOptions(showHidden = false) {
    return __async(this, null, function* () {
      const res = yield this.teams(showHidden);
      if (res.ok && res.result) {
        return __spreadProps(__spreadValues({}, res), {
          result: formatOptions(res.result)
        });
      }
      return res;
    });
  }
  /*
   * Returns all users asigned to a specific team
   *
   * @param id The id of the team
   * @param query text search on ????? TODO: Figure out what TEXT_SEARCH_CONFIGURATION applies
   * @returns
   *
   * @deprecated
   */
  teamUsers(id, query = null) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/teams/${encodeURIComponent(id)}/users${query ? `?query=${encodeURIComponent(query)}` : ""}`
      );
    });
  }
  /**
   * @deprecated use teams.add()
   */
  teamAdd(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/teams", body);
    });
  }
  /**
   * @deprecated use teams.update()
   */
  teamUpdate(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/teams/${encodeURIComponent(id)}`,
        body
      );
    });
  }
  /**
   * @deprecated use teams.delete()
   */
  teamDelete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/teams/${encodeURIComponent(id)}`
      );
    });
  }
  /**
   * @deprecated use teams.addMember()
   */
  teamAddUser(teamId, userId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        `/teams/${encodeURIComponent(teamId)}/users/${userId}`
      );
    });
  }
  /**
   * @deprecated use teams.removeMember()
   */
  teamDeleteUser(teamId, userId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/teams/${encodeURIComponent(teamId)}/users/${userId}`
      );
    });
  }
  resources(officeId) {
    return __async(this, null, function* () {
      const resources = yield this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(officeId)}/resources?limit=${BaseOrganizationEndpoints.MAXIMUM_LIMIT}`
      );
      if (!resources.ok || !resources.result) {
        return resources;
      }
      const result = this.resourceList(resources.result);
      return __spreadProps(__spreadValues({}, resources), { result });
    });
  }
  schedulable(_0, _1) {
    return __async(this, arguments, function* (officeId, types, parentId = null, date = null, duration = null, query = null, limit = BaseOrganizationEndpoints.MAXIMUM_LIMIT, hierarchy = false, manage = false, organizer = null) {
      const resources = yield this.resourcesAll(
        officeId,
        types,
        parentId,
        "schedulable",
        false,
        date,
        query,
        duration,
        limit,
        hierarchy,
        manage,
        organizer
      );
      if (!resources.ok || !resources.result) {
        return resources;
      }
      return __spreadProps(__spreadValues({}, resources), { result: this.resourceList(resources.result) });
    });
  }
  resourcesAll(_0, _1) {
    return __async(this, arguments, function* (officeId, types, parentId = null, filter = null, extended = true, date = null, query = null, duration = null, limit = BaseOrganizationEndpoints.MAXIMUM_LIMIT, hierarchy = false, manage = false, organizerId = null) {
      var _a;
      if (types.length == 0) {
        throw new Error("At least one type is required");
      }
      const params = new URLSearchParams();
      if (hierarchy) {
        params.append("hierarchy", "1");
      }
      if (manage) {
        params.append("manage", "1");
      }
      if (organizerId) {
        params.append("organizer", organizerId);
      }
      for (const type of types) {
        params.append("type", type);
      }
      if (parentId !== null) {
        params.append("parent", parentId);
      }
      const dates = typeof date === "string" ? [date] : date;
      if (dates !== null) {
        dates.forEach((x) => {
          params.append("date", x);
          if (duration) {
            params.append("duration", duration.toString());
          }
        });
      }
      if (query !== null) {
        params.append("query", query);
      }
      params.set("limit", limit.toString());
      const resources = yield this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/offices/${encodeURIComponent(officeId)}/resources${filter ? `/${encodeURIComponent(filter)}` : ""}?${params.toString()}`
      );
      if (!extended) {
        return resources;
      }
      if (!resources.ok || !resources.result) {
        return resources;
      }
      if (ENABLE_TAGS_MOCK) {
        resources.result.elements = mockTagsToResources(
          resources.result.elements
        );
      }
      const byId = {}, options = [];
      for (const element of ((_a = resources.result) == null ? void 0 : _a.elements) || []) {
        byId[element.id] = element;
        options.push({ value: element.id, label: element.name });
      }
      const result = __spreadProps(__spreadValues({}, resources.result), {
        byId,
        options
      });
      return __spreadProps(__spreadValues({}, resources), { result });
    });
  }
  resourceGet(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/resources/${encodeURIComponent(id)}`
      );
    });
  }
  /**
   * @deprecated Makes not sense to use a body of type string use `resourcePost`
   */
  resourceAdd(officeId, type, body) {
    return __async(this, null, function* () {
      const request = this.getResourceEntity(type, body);
      return yield this.requestWithStatus(
        "POST",
        `/offices/${encodeURIComponent(officeId)}/resources`,
        JSON.stringify(request)
      );
    });
  }
  /**
   * @deprecated Makes not sense to use a body of type string use `resourcePut`
   */
  resourceUpdate(id, body) {
    return __async(this, null, function* () {
      const request = this.getResourceEntity(null, body);
      return yield this.requestWithStatus(
        "PUT",
        `/resources/${encodeURIComponent(id)}`,
        JSON.stringify(request)
      );
    });
  }
  resourcePut(id, request) {
    return __async(this, null, function* () {
      const body = this.prepareRequest(request);
      return this.requestWithStatus(
        "PUT",
        `/resources/${encodeURIComponent(id)}`,
        body
      );
    });
  }
  resourcePost(officeId, request) {
    return __async(this, null, function* () {
      const body = this.prepareRequest(request);
      return this.requestWithStatus(
        "POST",
        `/offices/${encodeURIComponent(officeId)}/resources`,
        body
      );
    });
  }
  batchResourcePost(resources) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", "/v1/resources/batch", {
        resources: resources.map((resource) => {
          const data = this.prepareRequest(resource);
          data.office_id = resource.office_id || "";
          return data;
        })
      });
    });
  }
  batchResourcePut(resources) {
    return __async(this, null, function* () {
      return this.requestWithStatus("PUT", "/v1/resources/batch", {
        resources: resources.map((resource) => {
          return __spreadProps(__spreadValues({}, resource), { office_id: resource.office_id });
        })
      });
    });
  }
  batchResourceDelete(ids) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        "/v1/resources/batch",
        {
          resource_ids: ids.map((id) => {
            return id;
          })
        }
      );
    });
  }
  integrationsResourcePost(admin, officeId, request) {
    return __async(this, null, function* () {
      const body = this.prepareRequest(request);
      const response = yield this.requestWithStatus(
        "POST",
        `/integrations/offices/${encodeURIComponent(officeId)}/resources`,
        body
      );
      if (!response.ok) {
        return response;
      }
      return response;
    });
  }
  resourceMediaDelete(resourceId, mediaId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/resources/${encodeURIComponent(resourceId)}/media/${mediaId}`
      );
    });
  }
  resourceMedia(resourceId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/resources/${encodeURIComponent(resourceId)}/media`
      );
    });
  }
  resourceMediaUpload(resourceId, file, replaceAll = false, onProgress) {
    return __async(this, null, function* () {
      var _a, _b;
      const uploadUri = yield this.resourceCreateMediaUri(resourceId);
      if (!uploadUri.ok || !uploadUri.result) {
        throw new Error("Could not get upload uri");
      }
      const upload = yield this.resourceMediaUploadToProvider(
        uploadUri.result,
        file,
        onProgress
      );
      if (!upload.success) {
        throw new Error("Could not upload file");
      }
      const uri = yield this.resourceMediaUri(resourceId, uploadUri.result.id);
      return this.resourceMediaAttachToResource(
        resourceId,
        (_b = (_a = uri.result) == null ? void 0 : _a.uri) != null ? _b : "",
        uploadUri.result.id,
        replaceAll
      );
    });
  }
  resourceMediaAttachToResource(resourceId, uri, uploadId, replaceAll = false) {
    return __async(this, null, function* () {
      if (replaceAll) {
        const resource = yield this.resourceGet(resourceId);
        if (!resource.ok || !resource.result) {
          throw new Error("Could not get resource");
        }
        return this.requestWithStatus(
          "PUT",
          `/resources/${encodeURIComponent(resourceId)}`,
          __spreadProps(__spreadValues({}, resource.result), {
            medias_patch: false,
            medias: [
              {
                upload_id: uploadId,
                type: "image",
                uri
              }
            ]
          })
        );
      }
      return this.requestWithStatus(
        "POST",
        `/resources/${encodeURIComponent(resourceId)}/media`,
        {
          type: "image",
          uri,
          upload_id: uploadId
        }
      );
    });
  }
  resourceCreateMediaUri(resourceId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/resources/${encodeURIComponent(resourceId)}/media/upload/image`
      );
    });
  }
  resourceMediaUri(resourceId, uploadId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/resources/${encodeURIComponent(resourceId)}/media/upload/image/${encodeURIComponent(uploadId)}`
      );
    });
  }
  resourceMediaUploadToProvider(url, file, onProgress) {
    return __async(this, null, function* () {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const formData = new FormData();
        formData.append("file", file);
        xhr.open("POST", url.uri, true);
        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable && onProgress) {
            onProgress(event.loaded / event.total * 100);
          }
        };
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            try {
              const json = JSON.parse(xhr.responseText);
              resolve(json);
            } catch (err) {
              reject(new Error("Invalid JSON response"));
            }
          } else {
            reject(
              new Error(
                `Upload failed with status ${xhr.status}: ${xhr.responseText}`
              )
            );
          }
        };
        xhr.onerror = () => {
          reject(new Error("Network error during upload"));
        };
        xhr.send(formData);
      });
    });
  }
  prepareRequest(request) {
    var _a, _b, _c;
    const type = request.type;
    if (!type) {
      throw new Error("No resource type");
    }
    const isArea = type == "area";
    const isOpen = typeof request.is_open !== "undefined" && request.is_open;
    const totalSlots = (_a = request.total_slots) != null ? _a : 1;
    const maximumSlotsPerUser = (_b = request.maximum_slots_per_user) != null ? _b : 1;
    const medias = (_c = request.medias) != null ? _c : [];
    return {
      type,
      name: request.name,
      description: request.description,
      map_url: request.map_url,
      label: request.label,
      parent_id: request.parent_id,
      total_slots: !isArea ? totalSlots : 0,
      maximum_slots_per_user: !isArea ? maximumSlotsPerUser : 0,
      is_available: request.is_available,
      is_open: isOpen,
      is_approvable: request.is_approvable,
      weight: request.weight,
      medias,
      map_data: request.map_data
    };
  }
  resourceManagerPermissionsAll(userId, filter) {
    return __async(this, null, function* () {
      const params = new URLSearchParams();
      params.append("type", "area");
      params.append("type", "desk");
      params.append("type", "workspace");
      params.append("type", "meeting_room");
      return this.requestWithStatus(
        "GET",
        `/users/${userId}/resources/managed?${params.toString()}`
      );
    });
  }
  resourceManagerPermissionsAdd(request) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", `/resources/managers`, request);
    });
  }
  resourceManagerPermissionsDelete(res, userId) {
    return __async(this, null, function* () {
      if (!res.manage) {
        throw new Error(`Delete can't be called without manage.`);
      }
      return yield this.requestWithStatus(
        "DELETE",
        `/resources/${encodeURIComponent(res.id)}/managers/${encodeURIComponent(res.manage.permission_id)}/user/${userId}`
      );
    });
  }
  resourceDelete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/v1/resources/${encodeURIComponent(id)}`
      );
    });
  }
  resourceScheduledPermissions(id, filter) {
    return __async(this, null, function* () {
      return this.resourceScheduledPermissionsAll([id], filter);
    });
  }
  resourceScheduledPermissionsAll(ids, filter) {
    return __async(this, null, function* () {
      const params = new URLSearchParams();
      ids.forEach((id) => params.append("resource", id));
      if (filter && filter.hierarchy) {
        params.append("hierarchy", "true");
      }
      if (filter && filter.includePast) {
        params.append("includePast", "true");
      }
      return this.requestWithStatus(
        "GET",
        `/resources/permissions?${params.toString()}`
      );
    });
  }
  resourceScheduledPermissionsAdd(request) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        `/resources/permissions`,
        request
      );
    });
  }
  getResourceAdditionalAccess(resourceId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/v1/resources_additional_access?resource_id=${resourceId}`
      );
    });
  }
  setResourceAdditionalAccessOptions(resourceId, options) {
    return __async(this, null, function* () {
      const existingOptions = yield this.getResourceAdditionalAccess(resourceId);
      const existingOption = (existingOptions.result || []).find(
        (option) => option.resource_id === resourceId
      );
      const additionalAccessData = __spreadProps(__spreadValues({}, options), {
        resource_id: resourceId
      });
      return this.requestWithStatus(
        existingOption ? "PUT" : "POST",
        `/v1/resources_additional_access${existingOption ? `/${existingOption.id}` : ""}`,
        additionalAccessData
      );
    });
  }
  resourceScheduledPermissionsUpdate(request, resourceId, permissionId, teamId, userId) {
    return __async(this, null, function* () {
      const permissionType = teamId ? `team/${teamId}` : `user/${userId}`;
      return yield this.requestWithStatus(
        "PUT",
        `/resources/${encodeURIComponent(resourceId)}/permissions/${encodeURIComponent(permissionId)}/${permissionType}`,
        request
      );
    });
  }
  resourceScheduledPermissionsDelete(permission) {
    return __async(this, null, function* () {
      let permissionType = "";
      if (permission.team) {
        permissionType = `team/${permission.team.id}`;
      } else if (permission.user) {
        permissionType = `user/${permission.user.id}`;
      }
      return yield this.requestWithStatus(
        "DELETE",
        `/resources/${encodeURIComponent(permission.resource_id)}/permissions/${encodeURIComponent(
          permission.id
        )}/${permissionType}`
      );
    });
  }
  newsAdd(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/news", body);
    });
  }
  news(office_id = null) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        (office_id !== null ? `/offices/${encodeURIComponent(office_id)}/news` : "/news") + "?limit=" + BaseOrganizationEndpoints.MAXIMUM_LIMIT
      );
    });
  }
  getNews(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        "/news/" + encodeURIComponent(id)
      );
    });
  }
  newsUpdate(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/news/${encodeURIComponent(id)}`,
        body
      );
    });
  }
  newsDelete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/news/${encodeURIComponent(id)}`
      );
    });
  }
  questionAdd(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/questions", body);
    });
  }
  questions() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        "/questions?limit=" + BaseOrganizationEndpoints.MAXIMUM_LIMIT
      );
    });
  }
  question(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/questions/${encodeURIComponent(id)}`
      );
    });
  }
  questionUpdate(id, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/questions/${encodeURIComponent(id)}`,
        body
      );
    });
  }
  questionDelete(id) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/questions/${encodeURIComponent(id)}`
      );
    });
  }
  /**
   * Returns health questionnaire questions for the specified office.
   *
   * @param officeId The office id to get the health questionnaire for
   * @param questionnaireId Optional parameter get details about a specific questionnaire
   */
  questionnaire(officeId, questionnaireId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        questionnaireId ? `/questionnaires/${encodeURIComponent(questionnaireId)}` : `/offices/${encodeURIComponent(officeId)}/questionnaire`
      );
    });
  }
  /**
   * Responds to a health questionnaires questions, triggered by a reservation in an office that requires one.
   *
   * @param officeId The office ID to which the reservation belongs
   * @param body The full body of the request
   */
  questionnaireRespond(officeId, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/offices/${encodeURIComponent(officeId)}/questionnaire`,
        body
      );
    });
  }
  /**
   * @deprecated use schedules.checkin(res, schedule, slot)
   * @param id
   */
  checkin(id) {
    return __async(this, null, function* () {
      console.log("warn: [checkin] function is deprecated");
      return yield this.requestWithStatus(
        "POST",
        `/resources/${encodeURIComponent(id)}/presence`
      );
    });
  }
  assignTag(tagId, resourceId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/tags/${encodeURIComponent(tagId)}/assign/${encodeURIComponent(resourceId)}`
      );
    });
  }
  getAssignedResource(tagId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/tags/${encodeURIComponent(tagId)}`
      );
    });
  }
  generateOtp() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        "/codes"
      );
    });
  }
  uploadSignature(formId, signature) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/forms/${formId}/sign`,
        signature
      );
    });
  }
  notificationListen(listener) {
    return __async(this, null, function* () {
      const accessToken = this.getAccessToken();
      const slug = this.getSlug();
      if (accessToken === null || slug === null) {
        throw new Error("Missing access token or slug");
      }
      const url = this.getBaseUrl();
      const connection = new signalR.HubConnectionBuilder().withUrl(`${url}/hub/notifications`, {
        accessTokenFactory: () => accessToken,
        headers: {
          "X-Tactic-Orgz": slug
        }
      }).build();
      connection.on("added", (type, json) => {
        const data = json !== null ? JSON.parse(json) : null;
        listener(type, data);
      });
      return connection;
    });
  }
  formatOffices(offices, user) {
    const defaultOfficeNotDeleted = user ? offices.elements.some(
      (office2) => office2.id === user.organization_user.default_office_id
    ) : false;
    const officeId = user && defaultOfficeNotDeleted ? user.organization_user.default_office_id : offices.elements[0].id;
    let office = null, byId = {};
    for (const currentOffice of offices.elements) {
      byId[currentOffice.id] = currentOffice;
      if (office == null && currentOffice.id == officeId) {
        office = currentOffice;
      }
    }
    const result = {
      officeId,
      office,
      offices: offices.elements,
      byId
    };
    return result;
  }
  normalizeEntityCollection(collection) {
    return Array.isArray(collection) ? collection : Object.keys(collection).map((value) => ({ value }));
  }
  getResourceEntity(type, body) {
    const posted = JSON.parse(body);
    type = type !== null && type.indexOf(",") < 0 ? type : posted.type || null;
    if (!type) {
      throw new Error("No resource type");
    }
    const isArea = type == "area";
    const isApprovable = typeof posted.is_approvable !== "undefined" && posted.is_approvable == true;
    const isOpen = typeof posted.is_open !== "undefined" && posted.is_open;
    const teams = posted.teams ? this.normalizeEntityCollection(posted.teams) : [];
    const users = posted.users ? this.normalizeEntityCollection(posted.users) : [];
    const usersSettings = {};
    const teamsSettings = {};
    for (const option of users) {
      usersSettings[option.value] = isApprovable;
    }
    for (const option of teams) {
      teamsSettings[option.value] = isApprovable;
    }
    const totalSlots = posted.total_slots && Number.parseInt(posted.total_slots, 10) > 0 ? Number.parseInt(posted.total_slots, 10) : 1;
    const maximumSlotsPerUser = posted.maximum_slots_per_user && Number.parseInt(posted.maximum_slots_per_user, 10) > 0 ? Number.parseInt(posted.maximum_slots_per_user, 10) : 1;
    return {
      type,
      name: posted.name,
      map_url: posted.map_url,
      parent_id: posted.parent_id,
      total_slots: !isArea ? totalSlots : 0,
      maximum_slots_per_user: !isArea ? maximumSlotsPerUser : 0,
      is_available: posted.is_available,
      is_open: isOpen,
      is_approvable: isApprovable,
      teams: teamsSettings,
      users: usersSettings,
      weight: posted.weight
    };
  }
  resourceList(resources) {
    return resources !== null && resources.tree !== void 0 && resources.tree !== null ? this.formatTree(resources.tree, _Organizations.resourceFormatter) : [];
  }
  getJoinUrl(joinCode) {
    return this.getUrl(`signup?join=${encodeURIComponent(joinCode)}`);
  }
  getUploadUrl(options, file) {
    return __async(this, null, function* () {
      const queryParams = new URLSearchParams({
        type: options.type,
        format: options.format
      });
      return this.requestWithStatus(
        "POST",
        `/v1/uploads/images/url?${queryParams.toString()}`,
        file
      );
    });
  }
  getGanttOverviewEntities(officeId, filters) {
    return __async(this, null, function* () {
      var _a;
      return this.requestWithStatus(
        "GET",
        `/v1/dashboard/offices/${officeId}/gantt_overview${objectToQueryString(
          {
            start: filters.start.toISOString(),
            end: filters.end.toISOString(),
            limit: (_a = filters.limit) == null ? void 0 : _a.toString(),
            cursor: filters.cursor,
            floor_id: filters.floorId,
            resource_type: filters.resourceType
          }
        )}`
      );
    });
  }
};

// src/endpoints/pages.ts
var Pages = class extends BaseOrganizationEndpoints {
  getSections() {
    return __async(this, null, function* () {
      return this.requestWithStatus("GET", "/v1/sections");
    });
  }
  updateSection(id, section) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/v1/sections/${id}`,
        __spreadProps(__spreadValues({}, section), { id })
      );
    });
  }
  deleteSection(idSection) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/v1/sections/${idSection}`
      );
    });
  }
  deletePage(idPage) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/v1/pages/${idPage}`
      );
    });
  }
  createSection(section) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", "/v1/sections", section);
    });
  }
  getPages(filters) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        "/v1/pages" + objectToFiltersQuery(filters)
      );
    });
  }
  getPage(pageFilters) {
    return __async(this, null, function* () {
      if (!pageFilters.id) throw new Error("Page ID is required");
      return yield this.requestWithStatus(
        "GET",
        `/v1/pages/${pageFilters.id}`
      );
    });
  }
  createPage(post) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", "/v1/pages", post);
    });
  }
  updatePage(idPost, post) {
    return __async(this, null, function* () {
      return this.requestWithStatus("PUT", `/v1/pages/${idPost}`, post);
    });
  }
};

// src/endpoints/reports.ts
import { format as format4 } from "date-fns";
var _Reports = class _Reports extends BaseOrganizationEndpoints {
  usage(filter) {
    return __async(this, null, function* () {
      const requestUrl = _Reports.url("usage", filter);
      const result = yield this.requestWithStatus(
        "GET",
        requestUrl
      );
      return result;
    });
  }
  resources(filter, cursor = null) {
    return __async(this, null, function* () {
      const requestUrl = _Reports.url("resources", filter, cursor);
      const result = yield this.requestWithStatus(
        "GET",
        requestUrl
      );
      return result;
    });
  }
  reservations(filter, cursor = null) {
    return __async(this, null, function* () {
      const requestUrl = _Reports.url("reservations", filter, cursor);
      const result = yield this.requestWithStatus(
        "GET",
        requestUrl
      );
      return result;
    });
  }
  static url(report, filter, cursor = null) {
    var _a;
    const limit = (_a = filter.limit) != null ? _a : _Reports.DEFAULT_LIMIT;
    let url = `/reports/${report}?start=${encodeURIComponent(format4(filter.start, "yyyy-MM-dd"))}&end=${encodeURIComponent(format4(filter.end, "yyyy-MM-dd"))}`;
    if (filter.search !== null) {
      url += `&search=${encodeURIComponent(filter.search)}`;
    }
    for (const id of filter.officeIds) {
      url += `&office=${encodeURIComponent(id)}`;
    }
    for (const type of filter.resourceTypes) {
      url += `&type=${encodeURIComponent(type)}`;
    }
    if (cursor !== null) {
      url += `&cursor=${encodeURIComponent(cursor)}`;
    }
    if (limit && _Reports.REPORTS_WITH_LIMIT.includes(report)) {
      url += `&limit=${encodeURIComponent(limit)}`;
    }
    return url;
  }
};
_Reports.DEFAULT_LIMIT = 20;
_Reports.REPORTS_WITH_LIMIT = ["reservations", "resources"];
var Reports = _Reports;

// src/entities/hours.ts
var ALL_WEEK_DAYS = Object.freeze([
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
]);

// src/entities/presence.ts
var PRESENCE_STATUS_ACCEPTED = "accepted";
var PRESENCE_STATUS_PENDING = "pending";
var PRESENCE_STATUS_REJECTED = "rejected";
var PRESENCE_TYPE_IN_PERSON = "in_person";
var PRESENCE_TYPE_REMOTE = "remote";
var PRESENCE_TYPE_OOO = "out_of_office";

// src/endpoints/schedules.ts
var _Schedules = class _Schedules extends BaseOrganizationEndpoints {
  formatScheduleParams(params = {}) {
    const urlParams = this.formatGenericParams(params);
    if (!urlParams.has("weeks")) {
      urlParams.set("weeks", _Schedules.DEFAULT_NUMBER_OF_WEEKS.toString());
    }
    urlParams.set("fetchSimple", "1");
    return urlParams;
  }
  processFilter(requestUrl, filter) {
    if (filter.schedule_statuses) {
      for (const status of filter.schedule_statuses) {
        requestUrl += `&status=${encodeURIComponent(status)}`;
      }
    }
    if (filter.schedule_types) {
      for (const schedule_type of filter.schedule_types) {
        requestUrl += `&schedule_type=${encodeURIComponent(schedule_type)}`;
      }
    }
    if (filter.slot_types) {
      for (const slot_type of filter.slot_types) {
        if (slot_type)
          requestUrl += `&slot_type=${encodeURIComponent(slot_type)}`;
      }
    }
    if (filter.type) {
      for (const type of filter.type) {
        requestUrl += `&type=${encodeURIComponent(type)}`;
      }
    }
    if (filter.is_for_others) {
      requestUrl += "&isForOthers=true";
    }
    if (filter.tz) {
      requestUrl += `&tz=${encodeURIComponent(filter.tz)}`;
    }
    return requestUrl;
  }
  /** @deprecated use `all(...)` */
  schedules(_0, _1, _2) {
    return __async(this, arguments, function* (office_id, start, end, user_id = null, status_filter = ["accepted", "pending"]) {
      let requestUrl = `/offices/${encodeURIComponent(office_id)}/schedules?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`;
      for (const filter of status_filter) {
        requestUrl += `&presence=${encodeURIComponent(filter)}`;
      }
      for (const filter of status_filter) {
        requestUrl += `&status=${encodeURIComponent(filter)}`;
      }
      if (user_id !== null) {
        requestUrl += `&user=${encodeURIComponent(user_id)}`;
      }
      const result = yield this.requestWithStatus(
        "GET",
        requestUrl
      );
      return result;
    });
  }
  // Duplicate of organizations.questionnaire
  questionnaire(office_id) {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(office_id)}/questionnaire`
      );
      return result;
    });
  }
  news(office_id) {
    return __async(this, null, function* () {
      const result = yield this.requestWithStatus(
        "GET",
        `/offices/${encodeURIComponent(office_id)}/news`
      );
      return result;
    });
  }
  /** @deprecated Use `all(...)` instead */
  me(_0) {
    return __async(this, arguments, function* (office_id, time_zone = null, date = null, params = {}) {
      var _a, _b;
      const urlParams = new URLSearchParams();
      if (date) {
        urlParams.set("date", date);
      }
      urlParams.set(
        "weeks",
        ((_a = params.weeks) != null ? _a : _Schedules.DEFAULT_NUMBER_OF_WEEKS).toString()
      );
      if (params.limit) {
        urlParams.set("limit", params.limit.toString());
      }
      if (params.type !== null && params.type !== void 0) {
        for (let i = 0; i < ((_b = params.type) == null ? void 0 : _b.length); i++) {
          urlParams.append("type", params.type[i]);
        }
      }
      const result = yield this.requestWithStatus(
        "GET",
        `/offices/${office_id}/schedules/me?${urlParams.toString()}`
      );
      return result;
    });
  }
  all(filter, params) {
    return __async(this, null, function* () {
      const urlParams = this.formatScheduleParams(params);
      return this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/schedules/${filter}?${urlParams.toString()}`
      );
    });
  }
  allIndexed(filter, params) {
    return __async(this, null, function* () {
      var _a;
      const ret = yield this.all(filter, params);
      const uniqueUsers = {};
      const scheduleByUserByDay = {};
      const schedulesByDay = {};
      const result = ret.result;
      ((_a = result.elements) != null ? _a : []).forEach((x) => {
        const days = getDaysWithinTimespan(x.start, x.end, x.time_zone);
        days.forEach((day) => {
          var _a2, _b, _c;
          uniqueUsers[x.user.id] = x.user;
          schedulesByDay[day] = (_a2 = schedulesByDay[day]) != null ? _a2 : [];
          schedulesByDay[day].push(x);
          scheduleByUserByDay[x.user.id] = (_b = scheduleByUserByDay[x.user.id]) != null ? _b : {};
          scheduleByUserByDay[x.user.id][day] = (_c = scheduleByUserByDay[x.user.id][day]) != null ? _c : [];
          scheduleByUserByDay[x.user.id][day].push(x);
        });
      });
      return __spreadProps(__spreadValues({}, ret), {
        result: __spreadProps(__spreadValues({}, result), {
          dates: schedulesByDay,
          dates_user: scheduleByUserByDay,
          users: uniqueUsers
        })
      });
    });
  }
  allUsage(filter, params) {
    return __async(this, null, function* () {
      const urlParams = this.formatScheduleParams(params);
      return this.requestWithStatus(
        "GET",
        `/schedules/${filter}/usage?${urlParams.toString()}`
      );
    });
  }
  workingLocations() {
    return __async(this, arguments, function* (params = {}) {
      const urlParams = this.formatScheduleParams(params);
      return this.requestWithStatus(
        "GET",
        `/working_locations?${urlParams.toString()}`
      );
    });
  }
  workingLocationsDefaults(userId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/working_locations/${userId}`
      );
    });
  }
  updateWorkingLocationDefaults(locations) {
    return __async(this, null, function* () {
      const body = {
        locations
      };
      return this.requestWithStatus("POST", "/working_locations", body);
    });
  }
  updateWorkingLocationDay(location, day, date) {
    return __async(this, null, function* () {
      const dayIdx = ALL_WEEK_DAYS[day];
      const body = {
        locations: {
          [dayIdx]: location
        },
        start: `${date}T00:00:00Z`,
        end: `${date}T23:59:59Z`
      };
      return this.requestWithStatus("POST", "/working_locations", body);
    });
  }
  schedulesById(schedule_ids, office_id = null, filter) {
    return __async(this, null, function* () {
      let requestUrl = `/offices/${office_id}/schedules`;
      if (office_id == null) {
        requestUrl = `/schedules`;
      }
      for (let i = 0; i < schedule_ids.length; i++) {
        if (i === 0) {
          requestUrl += `?schedule=${encodeURIComponent(schedule_ids[i])}`;
        } else {
          requestUrl += `&schedule=${encodeURIComponent(schedule_ids[i])}`;
        }
      }
      if (filter) {
        requestUrl = this.processFilter(requestUrl, filter);
        console.log("filter url", requestUrl);
      }
      return this.requestWithStatus("GET", requestUrl, null);
    });
  }
  /**
   * [DEPRECATED]
   *
   * Shows whether a user has permission for schedule:respond. This should now be called by looking at
   * authenticatedUser.user.permissions.includes('schedule:respond')
   *
   */
  canApprove() {
    return __async(this, null, function* () {
      const user = yield this.request("GET", "/user");
      const canApprove = user && user.organization_user !== void 0 && user.organization_user.permissions.includes("schedule:respond");
      return canApprove;
    });
  }
  /** @deprecated Use `all(...)` instead */
  pending(_0) {
    return __async(this, arguments, function* (office_id, time_zone = null, date = null, params = {}) {
      var _a;
      if (!this.canApprove()) {
        throw new Error("User can't call pending");
      }
      const urlParams = new URLSearchParams();
      if (date) {
        urlParams.set("date", date);
      }
      urlParams.set(
        "weeks",
        ((_a = params.weeks) != null ? _a : _Schedules.DEFAULT_NUMBER_OF_WEEKS).toString()
      );
      if (params.limit) {
        urlParams.set("limit", params.limit.toString());
      }
      return this.requestWithStatus(
        "GET",
        `/offices/${office_id}/schedules/pending?${urlParams.toString()}`
      );
    });
  }
  /** @deprecated Use `all(...)` instead */
  usage(office_id, time_zone = null, date = null) {
    return __async(this, null, function* () {
      const weekDate = date !== null ? encodeURIComponent(date) : null;
      const response = yield this.requestWithStatus(
        "GET",
        `/offices/${office_id}/schedules/occupied/usage?weeks=${_Schedules.DEFAULT_NUMBER_OF_WEEKS}${weekDate !== null ? "&date=" + weekDate : ""}`
      );
      if (!response.ok || !response.result) {
        return response;
      }
      return __spreadProps(__spreadValues({}, response), { result: this.formatUsages(response.result) });
    });
  }
  /** @deprecated Use `allUsage(...)` instead */
  usageFull(office_id, time_zone = null, date = null) {
    return __async(this, null, function* () {
      const response = yield this.requestWithStatus(
        "GET",
        `/offices/${office_id}/schedules/occupied/usage?weeks=${_Schedules.DEFAULT_NUMBER_OF_WEEKS}${date !== null ? "&date=" + encodeURIComponent(date) : ""}`
      );
      return response;
    });
  }
  /** @deprecated Use `all(...)` instead */
  occupied(_0) {
    return __async(this, arguments, function* (office_id, time_zone = null, date = null, teams = [], resourceIds = [], limit = 1e3, types = []) {
      const weekDate = date !== null ? encodeURIComponent(date) : null;
      let query = `weeks=${_Schedules.DEFAULT_NUMBER_OF_WEEKS}${weekDate !== null ? "&date=" + weekDate : ""}`;
      for (const teamId of teams) {
        query += `&team=${encodeURIComponent(teamId)}`;
      }
      for (const resourceId of resourceIds) {
        query += `&resource=${encodeURIComponent(resourceId)}`;
      }
      for (const type of types) {
        query += `&type=${encodeURIComponent(type)}`;
      }
      query += `&limit=${limit}`;
      return yield this.requestWithStatus(
        "GET",
        `/offices/${office_id}/schedules/occupied?${query}`
      );
    });
  }
  /** @deprecated Use `all(...)` instead */
  scheduler(_0) {
    return __async(this, arguments, function* (office_id, time_zone = null, date = null, teams = [], resourceIds = [], limit = 1e3) {
      const weekDate = date !== null ? encodeURIComponent(date) : null;
      let query = `weeks=${_Schedules.DEFAULT_NUMBER_OF_WEEKS}${weekDate !== null ? "&date=" + weekDate : ""}`;
      for (const teamId of teams) {
        query += `&team=${encodeURIComponent(teamId)}`;
      }
      for (const resourceId of resourceIds) {
        query += `&resource=${encodeURIComponent(resourceId)}`;
      }
      query += `&limit=${limit}`;
      return yield this.requestWithStatus(
        "GET",
        `/offices/${office_id}/schedules/scheduler?${query}`
      );
    });
  }
  day(resource_id, time_zone = null, date = null) {
    return __async(this, null, function* () {
      const weekDate = date !== null ? encodeURIComponent(date) : null;
      const query = `weeks=${_Schedules.DEFAULT_NUMBER_OF_WEEKS}${weekDate !== null ? "&date=" + weekDate : ""}`;
      return yield this.requestWithStatus(
        "GET",
        `/resources/${resource_id}/schedules/day?${query}`,
        null
      );
    });
  }
  formatUsages(usageResult) {
    const usages = [];
    for (const date of Object.keys(usageResult.dates_type)) {
      const usagesByType = usageResult.dates_type[date];
      const hasDesks = typeof usagesByType.desk !== "undefined";
      const hasWorkspace = typeof usagesByType.workspace !== "undefined";
      const acceptedDesks = (hasDesks ? usagesByType.desk.accepted : 0) + (hasWorkspace ? usagesByType.workspace.accepted : 0);
      const freeDesks = (hasDesks ? usagesByType.desk.free : 0) + (hasWorkspace ? usagesByType.workspace.free : 0);
      const totalDesks = (hasDesks ? usagesByType.desk.total : 0) + (hasWorkspace ? usagesByType.workspace.total : 0);
      usages.push({
        date,
        day: date.substring(date.lastIndexOf("-") + 1),
        accepted: acceptedDesks,
        free: freeDesks,
        total: totalDesks,
        occupancy: totalDesks > 0 ? (100 * acceptedDesks / totalDesks).toFixed(0) : 0
      });
    }
    return {
      month: usageResult.months.start,
      usages,
      days: usageResult.days,
      weekDate: usageResult.week_date,
      previousWeekDate: usageResult.previous_week_date,
      nextWeekDate: usageResult.next_week_date
    };
  }
  respond(scheduleId, slotId, status) {
    return __async(this, null, function* () {
      const endpoint = slotId !== null ? `${this.settings.adminAuth ? "/integrations" : ""}/schedules/${encodeURIComponent(scheduleId)}/slots/${encodeURIComponent(
        slotId
      )}/respond/${encodeURIComponent(status)}` : `${this.settings.adminAuth ? "/integrations" : ""}/schedules/${encodeURIComponent(scheduleId)}/respond/${encodeURIComponent(status)}`;
      const result = yield this.requestWithStatus("PUT", endpoint);
      return __spreadProps(__spreadValues({}, result), { result: { scheduleId, slotId, status } });
    });
  }
  checkin(resourceId, scheduleId, slotId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        `${this.settings.adminAuth ? "/integrations" : ""}/resources/${encodeURIComponent(resourceId)}/presence/${encodeURIComponent(scheduleId)}/${encodeURIComponent(
          slotId
        )}`
      );
    });
  }
  checkout(resourceId, scheduleId, slotId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/resources/${encodeURIComponent(resourceId)}/presence/${encodeURIComponent(scheduleId)}/${encodeURIComponent(
          slotId
        )}`
      );
    });
  }
  delete(_0) {
    return __async(this, arguments, function* ({
      schedule,
      slot,
      recurring = false,
      slug = "",
      resourceId = ""
      // ? on slug is to accommodate mobile types before the slug was added
    }) {
      const body = recurring ? { recurring } : {};
      const newBasePath = getUrl({
        slug,
        officeId: void 0,
        method: "DELETE",
        resourceId
      });
      const oldBasePath = `${this.settings.adminAuth ? "/integrations" : ""}/schedules/`;
      const basePath = newBasePath || oldBasePath;
      const deletePath = slot ? `${basePath}${encodeURIComponent(schedule)}/slots/${encodeURIComponent(slot)}` : `${basePath}${encodeURIComponent(schedule)}`;
      return this.requestWithStatus("DELETE", deletePath, body);
    });
  }
  presence(scheduleId, slotId, presenceStatus, presenceType, skipIntegrationEvents) {
    return __async(this, null, function* () {
      let url = `/schedules/${encodeURIComponent(scheduleId)}/slots/${encodeURIComponent(
        slotId
      )}/presence/${encodeURIComponent(presenceStatus)}`;
      const data = {};
      if (skipIntegrationEvents) {
        url += "?skip-integration-events=true";
      }
      if (presenceStatus === PRESENCE_STATUS_ACCEPTED && presenceType) {
        data.presence_type = presenceType;
      }
      const response = yield this.requestWithStatus("PUT", url, data);
      return __spreadProps(__spreadValues({}, response), {
        result: { scheduleId, slotId, presenceStatus, presenceType }
      });
    });
  }
  create(officeId, request, isFromCalendar = false, slug = "") {
    const resId = request.schedule_slots[0].resource_id;
    const newUrl = getUrl({
      slug,
      officeId,
      method: "POST",
      resourceId: resId
    });
    let url = newUrl != null ? newUrl : `/offices/${encodeURIComponent(officeId)}/schedules`;
    if (isFromCalendar) {
      url += "?is-from-calendar=true";
    }
    console.log("THIS IS THE URL", url);
    return this.requestWithStatus("POST", url, request);
  }
  patch(scheduleId, request, isFromCalendar = false, orgSlug = "") {
    var _a, _b, _c;
    const resId = (_c = (_b = (_a = request.schedule_slots) == null ? void 0 : _a[0]) == null ? void 0 : _b.resource_id) != null ? _c : "";
    const newUrl = getUrl({
      slug: orgSlug,
      method: "PATCH",
      officeId: void 0,
      scheduleId,
      resourceId: resId
    });
    let url = newUrl || `/schedules/${encodeURIComponent(scheduleId)}`;
    if (isFromCalendar) {
      url += "?is-from-calendar=true";
    }
    return this.requestWithStatus("PATCH", url, request);
  }
  put(scheduleId, request, isFromCalendar = false, orgSlug = "") {
    var _a, _b, _c;
    const resId = (_c = (_b = (_a = request.schedule_slots) == null ? void 0 : _a[0]) == null ? void 0 : _b.resource_id) != null ? _c : "";
    const newUrl = getUrl({
      slug: orgSlug,
      officeId: void 0,
      method: "PATCH",
      scheduleId,
      resourceId: resId
    });
    let url = newUrl || `/schedules/${encodeURIComponent(orgSlug)}`;
    if (isFromCalendar) {
      url += "?is-from-calendar=true";
    }
    return this.requestWithStatus("PUT", url, request);
  }
  addToSchedule(officeId, scheduleId, request) {
    return this.requestWithStatus(
      "PUT",
      `/offices/${encodeURIComponent(officeId)}/schedules/${encodeURIComponent(scheduleId)}`,
      request
    );
  }
  createFromIntegrations(resourceId, request, isFromCalendar) {
    let url = `/resources/${encodeURIComponent(resourceId)}/schedules`;
    if (isFromCalendar) {
      url += "?is-from-calendar=true";
    }
    return this.requestWithStatus("POST", url, request);
  }
  createOrUpdateFromIntegrations(authorization, resourceId, request, isFromCalendar, scheduleId) {
    if (scheduleId === void 0) {
      scheduleId = null;
    }
    let url = `/integrations/resources/${encodeURIComponent(resourceId)}/schedules`;
    if (scheduleId !== null) {
      url += `/${scheduleId}`;
    }
    if (isFromCalendar) {
      url += "?is-from-calendar=true";
    }
    return this.requestWithStatus(
      scheduleId !== null ? "PUT" : "POST",
      url,
      request,
      {
        authHeader: `Basic ${authorization}`
      }
    );
  }
  /**
   * @deprecated
   */
  add(request) {
    return __async(this, null, function* () {
      const period = this.createPeriod(
        request.start,
        request.duration,
        request.time_zone
      );
      const scheduleRequest = {
        schedule_slots: [],
        time_zone: period.time_zone
      };
      request.users.forEach((userId) => {
        scheduleRequest.schedule_slots.push({
          resource_id: request.resource_id,
          user_id: userId,
          team_id: null,
          slots: 1,
          start: period.start,
          end: period.end,
          time_zone: period.time_zone
        });
      });
      request.teams.forEach((teamId) => {
        scheduleRequest.schedule_slots.push({
          resource_id: request.resource_id,
          user_id: null,
          team_id: teamId,
          slots: 1,
          start: period.start,
          end: period.end,
          time_zone: period.time_zone
        });
      });
      const response = yield this.create(request.office_id, scheduleRequest);
      if (!response.ok || response.result === null) {
        throw response;
      }
      return response.result;
    });
  }
  existsById(authorization, organizationId, scheduleId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/organizations/${organizationId}/schedules/${scheduleId}/exists`,
        null,
        {
          authHeader: `Basic ${authorization}`
        }
      );
    });
  }
};
_Schedules.DEFAULT_NUMBER_OF_WEEKS = 1;
var Schedules = _Schedules;
var getEndpointForMethod = {
  core: {
    POST: () => "/v1/schedules",
    PATCH: ({ scheduleId = "" }) => `/v1/schedules/${encodeURIComponent(scheduleId)}`,
    PUT: ({ scheduleId = "" }) => `/v1/schedules/${encodeURIComponent(scheduleId)}`,
    DELETE: ({ scheduleId = "" }) => `/v1/schedules/${encodeURIComponent(scheduleId)}`
  },
  api: {
    POST: ({ officeId = "" }) => `/offices/${encodeURIComponent(officeId)}/schedules`,
    PATCH: ({ scheduleId = "" }) => `/schedules/${encodeURIComponent(scheduleId)}`,
    PUT: ({ scheduleId = "" }) => `/schedules/${encodeURIComponent(scheduleId)}`,
    DELETE: ({ scheduleId = "" }) => `/schedules/${encodeURIComponent(scheduleId)}`
  }
};
var getUrl = ({
  slug,
  officeId,
  resourceId = "",
  method,
  scheduleId
}) => {
  return getEndpointForMethod.core[method]({
    officeId,
    scheduleId
  });
};

// src/endpoints/settings.ts
var SETTINGS_BASE_PATH = "/v1/settings";
var ORGANIZATION_SETTINGS_PATH = `${SETTINGS_BASE_PATH}/organizations`;
var OFFICE_SETTINGS_PATH = `${SETTINGS_BASE_PATH}/offices`;
var SettingsClient = class extends BaseSettingsEndpoints {
  getOrganizationSettings() {
    return __async(this, null, function* () {
      return this.get(`${ORGANIZATION_SETTINGS_PATH}`);
    });
  }
  getOfficeSettings(id) {
    return __async(this, null, function* () {
      return this.get(`${OFFICE_SETTINGS_PATH}/${id}`);
    });
  }
  updateOfficeSettings(id, settings) {
    return __async(this, null, function* () {
      return this.update(
        `${OFFICE_SETTINGS_PATH}/${id}`,
        settings
      );
    });
  }
  updateOrganizationSettings(settings) {
    return __async(this, null, function* () {
      return this.update(
        `${ORGANIZATION_SETTINGS_PATH}`,
        settings
      );
    });
  }
  updateOfficeDefaultReservationTime(id, settings) {
    return __async(this, null, function* () {
      return this.updateOfficeSettings(id, {
        reservation_default_time: settings
      });
    });
  }
  updateOrganizationDefaultReservationTime(settings) {
    return __async(this, null, function* () {
      return this.updateOrganizationSettings({
        reservation_default_time: settings
      });
    });
  }
  cancelCustomOfficeHours(id) {
    return __async(this, null, function* () {
      return this.delete(`${OFFICE_SETTINGS_PATH}/${id}`);
    });
  }
  cancelCustomOrganizationHours() {
    return __async(this, null, function* () {
      return this.delete(`${ORGANIZATION_SETTINGS_PATH}`);
    });
  }
};

// src/endpoints/signatures.ts
var Signatures = class extends BaseOrganizationEndpoints {
  signatures(filter) {
    return __async(this, null, function* () {
      let query = "";
      if (filter.signature_id) {
        query += `?signature=${encodeURIComponent(filter.signature_id)}`;
      } else if (filter.user_id) {
        query += `?user=${encodeURIComponent(filter.user_id)}`;
      } else if (filter.visit_id) {
        query += `?visit=${encodeURIComponent(filter.visit_id)}`;
      }
      return this.requestWithStatus(
        "GET",
        `/signatures${query}`
      );
    });
  }
};

// src/endpoints/signups.ts
var Signups = class extends BasePublicEndpoints {
  add(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/users", body);
    });
  }
  getPendingByCode(code) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/invitation/${encodeURIComponent(code)}`
      );
    });
  }
};

// src/endpoints/stations.ts
var Stations = class extends BaseOrganizationEndpoints {
  getStation(stationId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("GET", `/stations/${stationId}`);
    });
  }
  stationForms(officeId, stationId) {
    return __async(this, null, function* () {
      const slug = this.getSlug();
      if (slug === null) {
        return {
          result: {
            elements: [],
            cursor: null
          },
          status: 200,
          ok: true,
          authError: false,
          error: false,
          originalBody: ""
        };
      }
      return this.requestWithStatus(
        "GET",
        `/organizations/${slug}/offices/${officeId}/stations/${stationId}/forms?include-pdfs=true`
      );
    });
  }
  hasStations() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/stations/available`
      );
    });
  }
  registerGuest(officeId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/offices/${officeId}/visits`,
        body
      );
    });
  }
  updateGuest(visitId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/stations/visits/${visitId}`,
        body
      );
    });
  }
  checkinGuest(stationId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "POST",
        `/stations/${stationId}/visitors/presence`,
        body
      );
    });
  }
  guestCode(body) {
    return __async(this, null, function* () {
      return this.requestWithStatus("PUT", `/visits/code`, body);
    });
  }
  all(params) {
    return __async(this, null, function* () {
      const formatted = this.formatGenericParams(params);
      return this.requestWithStatus(
        "GET",
        `/stations?${formatted.toString()}`
      );
    });
  }
  stationVisits(params) {
    return __async(this, null, function* () {
      const formatted = this.formatGenericParams(params);
      return this.requestWithStatus(
        "GET",
        `/stations/visits?${formatted.toString()}`
      );
    });
  }
  getVisit(visitId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/stations/visits/${visitId}`
      );
    });
  }
  deleteStationVisit(visitId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/stations/visits/${visitId}`
      );
    });
  }
  update(stationId, body) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "PUT",
        `/stations/${stationId}`,
        body
      );
    });
  }
  delete(stationId) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "DELETE",
        `/stations/${stationId}`
      );
    });
  }
};

// src/endpoints/teams.ts
var RESOLVE_PATH = {
  directory: ``,
  group: `/groups`,
  management: `/management`
};
var TeamsClient = class extends BaseOrganizationEndpoints {
  add(req) {
    return __async(this, null, function* () {
      const path = `/teams${RESOLVE_PATH[req.type]}`;
      return this.requestWithStatus("POST", path, req);
    });
  }
  delete(_0) {
    return __async(this, arguments, function* ({ id, type }) {
      const path = `/teams${RESOLVE_PATH[type]}/${encodeURIComponent(id)}`;
      return this.requestWithStatus("DELETE", path);
    });
  }
  update(id, type, body) {
    return __async(this, null, function* () {
      const path = `/teams${RESOLVE_PATH[type]}/${encodeURIComponent(id)}`;
      return yield this.requestWithStatus("PUT", path, body);
    });
  }
  all(_0) {
    return __async(this, arguments, function* ({
      type,
      query,
      hidden
    }) {
      const path = `/teams${RESOLVE_PATH[type]}`;
      const urlSearchParams = new URLSearchParams();
      if (hidden) {
        urlSearchParams.append("hidden", "1");
      }
      if (query) {
        urlSearchParams.append("query", query);
      }
      const queryString = urlSearchParams.toString();
      return this.requestWithStatus(
        "GET",
        path + (queryString ? `?${queryString}` : "")
      );
    });
  }
  members(_0) {
    return __async(this, arguments, function* ({
      id,
      query = null,
      type
    }) {
      const path = `/teams${RESOLVE_PATH[type]}/${encodeURIComponent(id)}/users`;
      const urlSearchParams = new URLSearchParams();
      if (query) {
        urlSearchParams.set("query", query);
      }
      const queryString = urlSearchParams.toString();
      return this.requestWithStatus(
        "GET",
        path + (queryString ? `?${queryString}` : "")
      );
    });
  }
  addMember(_0) {
    return __async(this, arguments, function* ({
      teamId,
      userId,
      type
    }) {
      const path = `/teams${RESOLVE_PATH[type]}/${encodeURIComponent(teamId)}/users/${encodeURIComponent(userId)}`;
      return this.requestWithStatus("POST", path);
    });
  }
  removeMember(_0) {
    return __async(this, arguments, function* ({
      teamId,
      userId,
      type
    }) {
      const path = `/teams${RESOLVE_PATH[type]}/${encodeURIComponent(teamId)}/users/${encodeURIComponent(userId)}`;
      return this.requestWithStatus("DELETE", path);
    });
  }
  forUser(_0) {
    return __async(this, arguments, function* ({
      userId,
      type
    }) {
      const path = `/users/${encodeURIComponent(userId)}/teams${RESOLVE_PATH[type]}`;
      return this.requestWithStatus("GET", path);
    });
  }
  managed() {
    return __async(this, arguments, function* ({ query } = {}) {
      const urlSearchParams = new URLSearchParams();
      if (query) {
        urlSearchParams.set("query", query);
      }
      const queryString = urlSearchParams.toString();
      return this.requestWithStatus(
        "GET",
        `/users/managed` + (queryString ? `?${queryString}` : "")
      );
    });
  }
  managedWithOptions(args) {
    return __async(this, null, function* () {
      const res = yield this.managed(args);
      if (res.ok && res.result) {
        const formatted = formatOptions(
          res.result
        );
        return __spreadProps(__spreadValues({}, res), { result: formatted });
      }
      return res;
    });
  }
};

// src/endpoints/unauthenticated.ts
var Unauthenticated = class extends BaseOrganizationEndpoints {
  stationAdd(otp, type) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", `/stations`, {
        code: otp,
        type
      });
    });
  }
  countries() {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/countries`
      );
    });
  }
};

// src/endpoints/uploads.ts
var Uploads = class extends BaseUserEndpoints {
};

// src/entities/user_settings.ts
var UserPropertyType = /* @__PURE__ */ ((UserPropertyType2) => {
  UserPropertyType2["DirectoryCustom"] = "directory_custom";
  UserPropertyType2["DirectoryRaw"] = "directory_raw";
  UserPropertyType2["LastUsersFilter"] = "last_users_filter";
  UserPropertyType2["LastTeamsFilter"] = "last_teams_filter";
  UserPropertyType2["LastOfficesFilter"] = "last_offices_filter";
  UserPropertyType2["DesignSystemVersion"] = "design_system_version";
  return UserPropertyType2;
})(UserPropertyType || {});

// src/endpoints/user_settings.ts
var UserSettings = class extends BaseOrganizationEndpoints {
  createOrUpdate(type, value) {
    return __async(this, null, function* () {
      return this.requestWithStatus("POST", "/user/settings", {
        type,
        value
      });
    });
  }
  getByType(type) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/user/settings/${type}`
      );
    });
  }
  getAll() {
    return __async(this, null, function* () {
      return this.requestWithStatus("GET", "/user/settings");
    });
  }
  getDesignSystem() {
    return __async(this, null, function* () {
      const res = yield this.requestWithStatus(
        "GET",
        "/v1/settings/user"
      );
      const result = res.result;
      return result == null ? void 0 : result.settings.design_system_version;
    });
  }
  updateDesignSystem(value) {
    return __async(this, null, function* () {
      return this.requestWithStatus("PUT", "/v1/settings/user", {
        ["design_system_version" /* DesignSystemVersion */]: value
      });
    });
  }
};

// src/endpoints/users.ts
var Users = class extends BaseUserEndpoints {
  identity(authorization, userId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        `/identity`,
        { user: userId },
        { authHeader: `Basic ${authorization}` }
      );
    });
  }
  /**
   * Primary endpoint for returning the current authenticated user
   */
  me() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/user`
      );
    });
  }
  /**
   * Primary endpoint for returning the organizations to which an authenticated user belongs
   */
  organizations() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `${this.settings.adminAuth ? "/integrations" : ""}/organizations`
      );
    });
  }
  organizationAdd(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus("POST", "/organizations", body);
    });
  }
  organizationJoin(join) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/invitations/join/${encodeURIComponent(join)}`,
        {}
      );
    });
  }
  impersonate(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        `/users/${encodeURIComponent(body.email)}/impersonate`,
        {}
      );
    });
  }
};

// src/endpoints/wifi.ts
var Wifi = class extends BaseOrganizationEndpoints {
  /*
   * Returns all wifi connections in the organization
   */
  getWifiConnections() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        "/wifi_connections"
      );
    });
  }
  /*
   * Returns details for a single wifi connection in the organization
   */
  getWifiConnection(wifiConnectionId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        `/wifi_connections/${wifiConnectionId}`
      );
    });
  }
  /*
   * Updates an existing wifi connection in the organization
   */
  updateWifiConnection(wifiConnectionId, body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "PUT",
        `/wifi_connections/${wifiConnectionId}`,
        body
      );
    });
  }
  /*
   * Creates a wifi connection in the organization
   */
  createWifiConnection(body) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "POST",
        "/wifi_connections",
        body
      );
    });
  }
  /*
   * Deletes a wifi connection in the organization
   */
  deleteWifiConnection(wifiConnectionId) {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "DELETE",
        `/wifi_connections/${wifiConnectionId}`
      );
    });
  }
  getVersions() {
    return __async(this, null, function* () {
      return yield this.requestWithStatus(
        "GET",
        "/downloads/wifi"
      );
    });
  }
};

// src/endpoints/calendar-auth.ts
var CalendarAuth = class extends BaseOrganizationEndpoints {
  getAvailablePermissions(provider) {
    return __async(this, null, function* () {
      return this.requestWithStatus(
        "GET",
        `/v1/calendars/authorization/${provider}`
      );
    });
  }
  getMicrosoftPermissions() {
    return __async(this, null, function* () {
      return this.getAvailablePermissions("microsoft");
    });
  }
};

// src/client.ts
var Client = class {
  constructor(settings) {
    this.healthClient = null;
    this.leaveClient = null;
    this.activityClient = null;
    this.hoursClient = null;
    this.teamsClient = null;
    this.enterprisesClient = null;
    this.invitationsClient = null;
    this.integrationsClient = null;
    this.externalsClient = null;
    this.organizationsClient = null;
    this.reportsClient = null;
    this.formsClient = null;
    this.schedulesClient = null;
    this.divisionsClient = null;
    this.avigilonClient = null;
    this.coreIntegrationsClient = null;
    this.stationsClient = null;
    this.signupsClient = null;
    this.signaturesClient = null;
    this.wifiClient = null;
    this.usersClient = null;
    this.unauthenticatedClient = null;
    this.applicationClient = null;
    this.adminSchedulesClient = null;
    this.adminUsersClient = null;
    this.adminOrganizationsClient = null;
    this.adminLeaveClient = null;
    this.adminStationsClient = null;
    this.calendarClient = null;
    this.userSettingsClient = null;
    this.pagesClient = null;
    this.tagsClient = null;
    this.uploadsClient = null;
    this.settingsClient = null;
    this.calendarAuthClient = null;
    var _a;
    this.settings = settings;
    this.slug = (_a = settings.slug) != null ? _a : "";
  }
  get enterprises() {
    if (this.enterprisesClient === null) {
      this.checkAccess();
      this.enterprisesClient = new Enterprises(this.settings, this.slug);
    }
    return this.enterprisesClient;
  }
  get invitations() {
    if (this.invitationsClient === null) {
      this.checkAccess();
      this.invitationsClient = new Invitations(this.settings, this.slug);
    }
    return this.invitationsClient;
  }
  get organizations() {
    if (this.organizationsClient === null) {
      this.checkAccess();
      this.organizationsClient = new Organizations(this.settings, this.slug);
    }
    return this.organizationsClient;
  }
  get adminOrganizations() {
    if (this.adminOrganizationsClient === null) {
      this.adminOrganizationsClient = new Organizations(this.settings, null);
    }
    return this.adminOrganizationsClient;
  }
  get pages() {
    if (this.pagesClient === null) {
      this.checkAccess();
      this.pagesClient = new Pages(this.settings, this.slug);
    }
    return this.pagesClient;
  }
  get tags() {
    if (this.tagsClient === null) {
      this.checkAccess();
      this.tagsClient = new Tags(this.settings, this.slug);
    }
    return this.tagsClient;
  }
  get uploads() {
    if (this.uploadsClient === null) {
      this.checkAccess();
      this.uploadsClient = new Uploads(this.settings);
    }
    return this.uploadsClient;
  }
  get reports() {
    if (this.reportsClient === null) {
      this.checkAccess();
      this.reportsClient = new Reports(this.settings, this.slug);
    }
    return this.reportsClient;
  }
  get forms() {
    if (this.formsClient === null) {
      this.checkAccess();
      this.formsClient = new Forms(this.settings, this.slug);
    }
    return this.formsClient;
  }
  get integrations() {
    if (this.integrationsClient === null) {
      this.checkAccess();
      this.integrationsClient = new Integrations(this.settings, this.slug);
    }
    return this.integrationsClient;
  }
  get externals() {
    if (this.externalsClient === null) {
      this.checkAccess();
      this.externalsClient = new Externals(this.settings, this.slug);
    }
    return this.externalsClient;
  }
  get schedules() {
    if (this.schedulesClient === null) {
      this.checkAccess();
      this.schedulesClient = new Schedules(this.settings, this.slug);
    }
    return this.schedulesClient;
  }
  get stations() {
    if (this.stationsClient === null) {
      this.checkAccess();
      this.stationsClient = new Stations(this.settings, this.slug);
    }
    return this.stationsClient;
  }
  get adminStations() {
    if (this.adminStationsClient === null) {
      this.adminStationsClient = new Stations(this.settings, null);
    }
    return this.adminStationsClient;
  }
  get adminSchedules() {
    if (this.adminSchedulesClient === null) {
      this.adminSchedulesClient = new Schedules(this.settings, null);
    }
    return this.adminSchedulesClient;
  }
  get signatures() {
    if (this.signaturesClient === null) {
      this.checkAccess();
      this.signaturesClient = new Signatures(this.settings, this.slug);
    }
    return this.signaturesClient;
  }
  get signups() {
    if (this.signupsClient === null) {
      this.signupsClient = new Signups(this.settings);
    }
    return this.signupsClient;
  }
  get wifi() {
    if (this.wifiClient === null) {
      this.checkAccess();
      this.wifiClient = new Wifi(this.settings, this.slug);
    }
    return this.wifiClient;
  }
  get health() {
    if (this.healthClient === null) {
      this.checkAccess();
      this.healthClient = new Health(this.settings, this.slug);
    }
    return this.healthClient;
  }
  get leave() {
    if (this.leaveClient === null) {
      this.checkAccess();
      this.leaveClient = new LeaveClient(this.settings, this.slug);
    }
    return this.leaveClient;
  }
  get divisions() {
    if (this.divisionsClient === null) {
      this.checkAccess();
      this.divisionsClient = new DivisionsClient(this.settings, this.slug);
    }
    return this.divisionsClient;
  }
  get coreIntegrations() {
    if (this.coreIntegrationsClient === null) {
      this.checkAccess();
      this.coreIntegrationsClient = new CoreIntegrations(
        this.settings,
        this.slug
      );
    }
    return this.coreIntegrationsClient;
  }
  get avigilon() {
    if (this.avigilonClient === null) {
      this.checkAccess();
      this.avigilonClient = new AvigilonClient(this.settings, this.slug);
    }
    return this.avigilonClient;
  }
  get adminLeave() {
    if (this.adminLeaveClient === null) {
      this.adminLeaveClient = new LeaveClient(this.settings, null);
    }
    return this.adminLeaveClient;
  }
  get activity() {
    if (this.activityClient === null) {
      this.checkAccess();
      this.activityClient = new ActivityClient(this.settings, this.slug);
    }
    return this.activityClient;
  }
  get hours() {
    if (this.hoursClient === null) {
      this.checkAccess();
      this.hoursClient = new HoursClient(this.settings, this.slug);
    }
    return this.hoursClient;
  }
  get teams() {
    if (this.teamsClient === null) {
      this.checkAccess();
      this.teamsClient = new TeamsClient(this.settings, this.slug);
    }
    return this.teamsClient;
  }
  get users() {
    this.checkAccess(false);
    if (this.usersClient === null) {
      this.usersClient = new Users(this.settings);
    }
    return this.usersClient;
  }
  get adminUsers() {
    if (this.adminUsersClient === null) {
      this.adminUsersClient = new Users(this.settings);
    }
    return this.adminUsersClient;
  }
  get unauthenticated() {
    if (this.unauthenticatedClient === null) {
      this.unauthenticatedClient = new Unauthenticated(this.settings, null);
    }
    return this.unauthenticatedClient;
  }
  get application() {
    if (this.applicationClient === null) {
      this.checkAccess();
      this.applicationClient = new Application(this.settings, this.slug);
    }
    return this.applicationClient;
  }
  get calendar() {
    if (this.calendarClient === null) {
      this.calendarClient = new Calendar(this.settings, this.slug);
    }
    return this.calendarClient;
  }
  get calendarAuth() {
    if (this.calendarAuthClient === null) {
      this.calendarAuthClient = new CalendarAuth(this.settings, this.slug);
    }
    return this.calendarAuthClient;
  }
  get userSettings() {
    if (this.userSettingsClient === null) {
      this.userSettingsClient = new UserSettings(this.settings, this.slug);
    }
    return this.userSettingsClient;
  }
  checkAccess(withSlug = true) {
    if (withSlug && this.slug === null) {
      throw new Error("Missing slug");
    }
  }
  get orgOrOfficeSettings() {
    if (this.settingsClient === null) {
      this.settingsClient = new SettingsClient(this.settings, this.slug);
    }
    return this.settingsClient;
  }
};

// src/initApi.ts
var TacticApiClient = class _TacticApiClient {
  constructor(settings, embeddedSettings) {
    this.embeddedSettings = embeddedSettings;
    if (_TacticApiClient._instance) {
      throw new Error("Singleton cannot be instantiated more than once");
    }
    this.settings = settings;
    this.client = new Client(this.settings);
    this.user = null;
    _TacticApiClient._instance = this;
  }
  cookieExists() {
    return true;
  }
  setEmbeddedSettings() {
    this.settings = this.embeddedSettings;
    this.client = new Client(this.settings);
  }
  updateSlug(slug) {
    this.client = new Client(__spreadProps(__spreadValues({}, this.settings), { slug }));
  }
  updateUser(authenticatedUser) {
    this.user = authenticatedUser;
    if (!authenticatedUser.organization) {
      throw new Error("Organization is required");
    }
    const slug = authenticatedUser.organization.slug;
    this.client = new Client(__spreadProps(__spreadValues({}, this.settings), { slug }));
  }
  overrideConfig(settings, user) {
    this.settings = settings;
    this.client = new Client(this.settings);
    this.user = user;
  }
};
var initApi = (defaultSettings) => {
  const settings = __spreadValues({}, defaultSettings);
  if (settings.debugAuth && settings.debugAuthAccess) {
    settings.legacyAuth = {
      access: settings.debugAuthAccess,
      impersonation: null,
      idProvider: "Id"
    };
  }
  if (settings.unionDevAuth) {
    settings.authHeader = settings.unionDevAuth;
  }
  const embeddedSettings = {
    environment: settings.environment,
    slug: null,
    url: settings.url,
    debug: settings.debug,
    debugAuth: settings.debugAuth,
    debugGet: settings.debugGet,
    protocol: settings.protocol,
    domain: settings.domain,
    authHeader: settings.authHeader,
    corsBypass: settings.corsBypass,
    onError: (error, status) => {
      console.error("error handler:", error, status);
    }
  };
  const api = new TacticApiClient(settings, embeddedSettings);
  return { settings, embeddedSettings, api };
};

// src/defaults.ts
var DEFAULT_TACTIC_API_URL = "https://union.gettactic.com";
var DEFAULT_TACTIC_DEFAULT_PROTOCOL = "https";
var DEFAULT_TACTIC_DOMAIN_AND_PORT = "gettactic.com";
var DEFAULT_EXCLUDE_SENTRY_STATUS_CODES = [401, 403, 404];
var DEFAULT_TACTIC_AUTH_HEADER = "";

// src/entities/station.ts
var STATION_TYPE_VISITOR = "visitor";
var STATION_TYPE_ROOM = "room";

// src/entities/calendar.ts
var CalendarSource = /* @__PURE__ */ ((CalendarSource2) => {
  CalendarSource2["Google"] = "google";
  CalendarSource2["Microsoft"] = "microsoft";
  return CalendarSource2;
})(CalendarSource || {});
var CalendarType = /* @__PURE__ */ ((CalendarType2) => {
  CalendarType2["Resource"] = "resource";
  CalendarType2["User"] = "user";
  return CalendarType2;
})(CalendarType || {});

// src/integrations/google.ts
import { format as format5, parseISO as parseISO2 } from "date-fns";
import { utcToZonedTime as utcToZonedTime2, zonedTimeToUtc as zonedTimeToUtc2 } from "date-fns-tz";

// src/entities/visibility.ts
var VISIBILITY_PUBLIC = "public";
var VISIBILITY_PRIVATE = "private";
var VISIBILITY_CONFIDENTIAL = "confidential";

// src/integrations/google.ts
var _GoogleCalendarTransformer = class _GoogleCalendarTransformer {
  constructor() {
    this.settings = {
      removeNonHumanAttendees: true
    };
  }
  transform(calendarId, event, recurringEvent = null) {
    const scheduleRequest = this.createScheduleRequest(calendarId, event);
    const recurringScheduleRequest = recurringEvent ? this.createScheduleRequest(calendarId, recurringEvent) : null;
    if (recurringScheduleRequest !== null && recurringScheduleRequest.attendees.length === 0) {
      recurringScheduleRequest.attendees = [
        {
          email: scheduleRequest.organizer.email,
          name: scheduleRequest.organizer.name,
          presence_status: PRESENCE_STATUS_ACCEPTED,
          presence_type: null,
          user_id: null
        }
      ];
    }
    const request = {
      schedule: scheduleRequest,
      recurring_schedule: recurringScheduleRequest
    };
    return request;
  }
  transformBack(scheduleId, eventSource, calendar) {
    var _a, _b;
    const timeZone = eventSource.time_zone_id;
    const timeArgs = {
      start: {
        dateTime: eventSource.start_time ? _GoogleCalendarTransformer.getTimeWithoutZ(eventSource.start_time) : null,
        timeZone
      },
      end: {
        dateTime: eventSource.end_time ? _GoogleCalendarTransformer.getTimeWithoutZ(eventSource.end_time) : null,
        timeZone
      }
    };
    const participants = [];
    if (eventSource.attendees) {
      for (const attendee of eventSource.attendees) {
        participants.push({
          email: attendee.email,
          displayName: attendee.name,
          resource: false,
          responseStatus: _GoogleCalendarTransformer.PRESENCE_STATUS_MAP_REVERSED[attendee.presence_status]
        });
      }
    }
    if (eventSource.resource_attendees) {
      for (const attendee of eventSource.resource_attendees) {
        participants.push({
          email: attendee.email,
          displayName: attendee.name,
          resource: true,
          responseStatus: _GoogleCalendarTransformer.PRESENCE_STATUS_MAP_REVERSED[attendee.presence_status]
        });
      }
    }
    const metadata = _GoogleCalendarTransformer.generateMetadata(
      scheduleId,
      (_a = eventSource.calendar_event_integration_id) != null ? _a : null,
      calendar
    );
    const event = {
      summary: eventSource.title,
      location: eventSource.location,
      description: (_b = eventSource.description) != null ? _b : "",
      start: timeArgs.start,
      end: timeArgs.end,
      attendees: participants,
      reminders: {
        useDefault: true
        /*
            useDefault: false,
            overrides: [
              { method: 'email', 'minutes': 24 * 60 },
              { method: 'popup', 'minutes': 10 },
            ],
            */
      },
      transparency: "opaque",
      visibility: _GoogleCalendarTransformer.VISIBILITY_MAP_REVERSED[eventSource.visibility],
      extendedProperties: { private: metadata }
    };
    if (eventSource.recurring_rules !== null && eventSource.recurring_rules.length > 0) {
      event.recurrence = _GoogleCalendarTransformer.convertRRules(
        eventSource.recurring_rules,
        eventSource.recurring_end_time,
        timeZone
      );
    }
    return event;
  }
  createScheduleRequest(calendarId, event) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
    if (!event || !event.id || !event.start || !event.end || !event.creator || !event.creator.email) {
      throw new Error("Missing required event parameters");
    }
    const startTime = (_a = event.start.dateTime) != null ? _a : `${event.start.date}T00:00:00`, endTime = (_b = event.end.dateTime) != null ? _b : `${event.end.date}T00:00:00`, timeZone = (_c = event.start.timeZone) != null ? _c : "Etc/UTC";
    const creatorEmail = event.creator.email, creatorName = (_d = event.creator.displayName) != null ? _d : null, creatorIsNonHuman = creatorEmail.endsWith(
      _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_RESOURCE_EMAIL_SUFFIX
    ) || creatorEmail.endsWith(
      _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_GROUP_EMAIL_SUFFIX
    );
    const organizerEmail = event.organizer ? event.organizer.email : creatorEmail, organizerName = event.organizer ? event.organizer.displayName : creatorName, organizerIsNonHuman = organizerEmail.endsWith(
      _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_RESOURCE_EMAIL_SUFFIX
    ) || organizerEmail.endsWith(
      _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_GROUP_EMAIL_SUFFIX
    );
    const humanCreatorReplacesNonHumanOrganizer = this.settings.removeNonHumanAttendees && organizerIsNonHuman && !creatorIsNonHuman && creatorEmail != organizerEmail;
    let attendees = [];
    let attendeesByEmail = {};
    let resourceAttendees = [];
    for (const attendee of (_e = event.attendees) != null ? _e : []) {
      if (!attendee.email) {
        continue;
      }
      const attendeeEmail = attendee.email;
      const attendeeIsNonHumanResource = attendee.resource || attendeeEmail.endsWith(
        _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_RESOURCE_EMAIL_SUFFIX
      );
      if (attendeeIsNonHumanResource) {
        resourceAttendees.push({
          email: attendeeEmail,
          name: attendee.displayName ? attendee.displayName : null,
          presence_status: attendee.responseStatus ? _GoogleCalendarTransformer.PRESENCE_STATUS_MAP[attendee.responseStatus] : PRESENCE_STATUS_PENDING,
          presence_type: null,
          user_id: null
        });
      }
      if (this.settings.removeNonHumanAttendees && (attendeeIsNonHumanResource || attendeeEmail.endsWith(
        _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_GROUP_EMAIL_SUFFIX
      ))) {
        continue;
      }
      const attendeeRequest = {
        email: attendeeEmail,
        name: attendee.displayName ? attendee.displayName : null,
        presence_status: attendee.responseStatus ? _GoogleCalendarTransformer.PRESENCE_STATUS_MAP[attendee.responseStatus] : PRESENCE_STATUS_PENDING,
        presence_type: null,
        user_id: null
      };
      attendees.push(attendeeRequest);
      attendeesByEmail[attendeeRequest.email] = attendeeRequest;
    }
    if (attendees.length === 0) {
      if (humanCreatorReplacesNonHumanOrganizer) {
        attendees.push({
          email: creatorEmail,
          name: creatorName != null ? creatorName : null,
          presence_status: PRESENCE_STATUS_ACCEPTED,
          presence_type: null,
          user_id: null
        });
      } else if (!organizerEmail.endsWith(
        _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_GROUP_EMAIL_SUFFIX
      ) && !organizerEmail.endsWith(
        _GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_RESOURCE_EMAIL_SUFFIX
      )) {
        attendees.push({
          email: organizerEmail,
          name: organizerName != null ? organizerName : null,
          presence_status: PRESENCE_STATUS_ACCEPTED,
          presence_type: null,
          user_id: null
        });
      }
    }
    const scheduleId = _GoogleCalendarTransformer.tryGetScheduleId(
      calendarId,
      event
    );
    const scheduleRequest = {
      creator: (_f = attendeesByEmail[creatorEmail]) != null ? _f : {
        email: creatorEmail,
        name: creatorName != null ? creatorName : null,
        presence_status: null,
        presence_type: null,
        user_id: null
      },
      organizer: (_h = attendeesByEmail[humanCreatorReplacesNonHumanOrganizer ? creatorEmail : organizerEmail]) != null ? _h : {
        email: humanCreatorReplacesNonHumanOrganizer ? creatorEmail : organizerEmail,
        name: (_g = humanCreatorReplacesNonHumanOrganizer ? creatorName : organizerName) != null ? _g : null,
        presence_status: null,
        presence_type: null,
        user_id: null
      },
      attendees,
      start: _GoogleCalendarTransformer.convertGoogleTimeToTacticTime(
        startTime,
        timeZone
      ),
      original_start: event.originalStartTime && event.originalStartTime.dateTime ? _GoogleCalendarTransformer.convertGoogleTimeToTacticTime(
        event.originalStartTime.dateTime,
        timeZone
      ) : null,
      end: _GoogleCalendarTransformer.convertGoogleTimeToTacticTime(
        endTime,
        timeZone
      ),
      time_zone: timeZone,
      recurring: event.recurrence ? this.convertRRulesToRecurringTask(event) : null,
      title: (_i = event.summary) != null ? _i : null,
      description: (_j = event.description) != null ? _j : null,
      visibility: event.visibility ? _GoogleCalendarTransformer.VISIBILITY_MAP[event.visibility] : VISIBILITY_PUBLIC,
      integration: {
        schedule_id: !!scheduleId ? scheduleId : null,
        event_id: event.id,
        event_updated: event.updated,
        ical_id: event.iCalUID,
        url: (_k = event.htmlLink) != null ? _k : null,
        event,
        is_deleted: event.status === "cancelled",
        resource_attendees: resourceAttendees.length > 0 ? resourceAttendees : null
      }
    };
    return scheduleRequest;
  }
  static generateMetadata(scheduleId, eventId, calendar) {
    const metadata = { tacticEventId: eventId }, metadataCalendarId = calendar.id.replace(/\-/g, "_"), scheduleKey = `tactic_schedule_${metadataCalendarId}`;
    metadata["tacticEventId"] = eventId != null ? eventId : void 0;
    metadata["tacticScheduleId"] = scheduleId;
    metadata[scheduleKey] = scheduleId;
    return metadata;
  }
  static tryGetScheduleId(calendarId, event) {
    const metadata = !!event.extendedProperties && !!event.extendedProperties.private ? event.extendedProperties.private : null;
    if (metadata === null) {
      return null;
    }
    const metadataCalendarId = calendarId.replace(/\-/g, "_"), scheduleKey = `tactic_schedule_${metadataCalendarId}`;
    return scheduleKey in metadata ? metadata[scheduleKey] : "tacticScheduleId" in metadata ? metadata["tacticScheduleId"] : "scheduleId" in metadata ? metadata["scheduleId"] : null;
  }
  static tryGetEventId(calendarId, event) {
    const eventId = !!event.extendedProperties && !!event.extendedProperties.private ? event.extendedProperties.private["tacticEventId"] : null;
    return eventId;
  }
  // Taken from integrations@google-client.ts
  static convertGoogleTimeToTacticTime(time, timeZone) {
    if (!time.includes("T")) {
      return `${time}T00:00:00Z`;
    }
    const date = parseISO2(time);
    if (!timeZone) {
      return date.toISOString().split(".")[0] + "Z";
    }
    const utcDate = new Date(date.toUTCString());
    const zonedTime = utcToZonedTime2(utcDate, timeZone);
    return format5(zonedTime, "yyyy-MM-dd'T'HH:mm:ss'Z'");
  }
  // Inspired from integrations@google-client.ts
  convertRRulesToRecurringTask(event) {
    var _a, _b;
    const parsedRules = event.recurrence.reduce(
      (acc, rule) => {
        const splitRule = rule.split("RRULE:");
        if (splitRule.length > 1) {
          acc.push(splitRule[1]);
        }
        return acc;
      },
      []
    );
    const timeZone = (_a = event.start.timeZone) != null ? _a : "Etc/UTC";
    let start = event.originalStartTime && event.originalStartTime.dateTime ? event.originalStartTime.dateTime : (_b = event.start.dateTime) != null ? _b : `${event.start.date}T00:00:00`;
    let end = null;
    if (parsedRules.length > 0) {
      const match = parsedRules[0].match(/UNTIL=([^;]+)/);
      const until = match ? match[1] : null;
      if (until) {
        const parsedTime = parseISO2(until);
        const utcTime = utcToZonedTime2(parsedTime, "UTC");
        const startUtc = parseISO2(start);
        if (startUtc >= parsedTime && event.created) {
          start = format5(
            utcToZonedTime2(parseISO2(event.created), "UTC"),
            "yyyy-MM-dd'T'HH:mm:ss'Z'"
          );
        }
        end = format5(utcTime, "yyyy-MM-dd'T'HH:mm:ss'Z'");
      }
    }
    return {
      rrules: parsedRules,
      start: _GoogleCalendarTransformer.convertGoogleTimeToTacticTime(
        start,
        "UTC"
      ),
      end: end !== null ? _GoogleCalendarTransformer.convertGoogleTimeToTacticTime(end, "UTC") : null
    };
  }
  static getTimeWithoutZ(date) {
    return date.charAt(date.length - 1) === "Z" ? date.slice(0, -1) : date;
  }
  static convertRRules(rrules, end, timeZoneId) {
    let rules = rrules.map((rule) => "RRULE:" + rule);
    if (end !== null) {
      if (end.endsWith("Z")) {
        end = end.slice(0, -1);
        end = end.replace("T", " ");
      }
      const utcEnd = zonedTimeToUtc2(end, timeZoneId);
      rules = rules.map(
        (rule) => `${rule};UNTIL=${format5(utcEnd, "yyyyMMdd'T'HHmmss'Z'")}`
      );
    }
    return rules;
  }
};
_GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_RESOURCE_EMAIL_SUFFIX = "@resource.calendar.google.com";
_GoogleCalendarTransformer.NON_HUMAN_ATTENDEE_GROUP_EMAIL_SUFFIX = "@group.calendar.google.com";
_GoogleCalendarTransformer.PRESENCE_STATUS_MAP = {
  needsAction: PRESENCE_STATUS_PENDING,
  declined: PRESENCE_STATUS_REJECTED,
  tentative: PRESENCE_STATUS_ACCEPTED,
  accepted: PRESENCE_STATUS_ACCEPTED
};
_GoogleCalendarTransformer.PRESENCE_STATUS_MAP_REVERSED = {
  pending: "needsAction",
  rejected: "declined",
  accepted: "accepted"
};
_GoogleCalendarTransformer.VISIBILITY_MAP = {
  confidential: VISIBILITY_CONFIDENTIAL,
  default: VISIBILITY_PUBLIC,
  public: VISIBILITY_PUBLIC,
  private: VISIBILITY_PRIVATE
};
_GoogleCalendarTransformer.VISIBILITY_MAP_REVERSED = {
  confidential: "confidential",
  public: "public",
  private: "private"
};
var GoogleCalendarTransformer = _GoogleCalendarTransformer;

// src/integrations/microsoft.ts
import { parseISO as parseISO3 } from "date-fns";
import { findIana, findWindows } from "windows-iana";
var _MicrosoftCalendarTransformer = class _MicrosoftCalendarTransformer {
  constructor() {
    this.settings = {
      removeNonHumanAttendees: true
    };
  }
  transform(calendarId, event, recurringEvent = null) {
    let instanceEvent = null;
    if (recurringEvent !== null && event.id && event.seriesMasterId && event.type && "occurrence" === event.type && event.start && event.end && !("lastModifiedDateTime" in event)) {
      instanceEvent = __spreadValues(__spreadValues(__spreadValues({}, recurringEvent), { recurrence: null }), event);
    }
    const scheduleRequest = this.createScheduleRequest(
      calendarId,
      instanceEvent !== null ? instanceEvent : event,
      instanceEvent !== null ? event : null
    );
    let recurringScheduleRequest = recurringEvent ? this.createScheduleRequest(calendarId, recurringEvent, null) : null;
    if (recurringScheduleRequest !== null && recurringScheduleRequest.recurring === null) {
      recurringScheduleRequest = null;
    }
    if (recurringScheduleRequest !== null && recurringScheduleRequest.attendees.length === 0) {
      recurringScheduleRequest.attendees = [
        {
          email: scheduleRequest.organizer.email,
          name: scheduleRequest.organizer.name,
          presence_status: PRESENCE_STATUS_ACCEPTED,
          presence_type: null,
          user_id: null
        }
      ];
    }
    const request = {
      schedule: scheduleRequest,
      recurring_schedule: recurringScheduleRequest
    };
    return request;
  }
  transformBack(scheduleId, eventSource, calendar) {
    var _a;
    const start = _MicrosoftCalendarTransformer.getTimeWithoutZ(
      eventSource.start_time
    );
    const end = _MicrosoftCalendarTransformer.getTimeWithoutZ(
      eventSource.end_time
    );
    const timeZoneResult = _MicrosoftCalendarTransformer.convertTimeZone(
      eventSource.time_zone_id
    );
    if (timeZoneResult === null) {
      throw new Error(
        `Error while converting timezone ${eventSource.time_zone_id} to Microsoft's timezone`
      );
    }
    const timeZone = timeZoneResult[0];
    const participants = [];
    if (eventSource.attendees) {
      for (const attendee of eventSource.attendees) {
        participants.push({
          emailAddress: {
            name: attendee.name,
            address: attendee.email
          },
          status: {
            response: _MicrosoftCalendarTransformer.PRESENCE_STATUS_MAP_REVERSED[attendee.presence_status]
          }
        });
      }
    }
    if (eventSource.resource_attendees) {
      for (const attendee of eventSource.resource_attendees) {
        participants.push({
          emailAddress: {
            name: attendee.name,
            address: attendee.email
          },
          status: {
            response: _MicrosoftCalendarTransformer.PRESENCE_STATUS_MAP_REVERSED[attendee.presence_status]
          }
        });
      }
    }
    const eventId = eventSource.calendar_event_integration_id;
    const event = {
      start: {
        dateTime: start,
        timeZone
      },
      end: {
        dateTime: end,
        timeZone
      },
      organizer: {
        emailAddress: {
          name: eventSource.organizers[0].name,
          address: eventSource.organizers[0].email
        }
      },
      attendees: participants,
      sensitivity: _MicrosoftCalendarTransformer.VISIBILITY_MAP_REVERSED[eventSource.visibility],
      subject: eventSource.title,
      body: {
        contentType: "html",
        content: (_a = eventSource.description) != null ? _a : ""
      },
      location: {
        displayName: eventSource.location
      },
      showAs: "busy",
      responseRequested: false,
      isOrganizer: false,
      isAllDay: false,
      extensions: [
        _MicrosoftCalendarTransformer.generateMetadata(
          scheduleId,
          eventId,
          calendar
        )
      ]
    };
    return event;
  }
  transformRemovedOOO(event) {
    var _a, _b, _c;
    const policyType = "remote";
    const isDeleted = "@removed" in event;
    return {
      use: {
        policy_type: policyType,
        starts: (/* @__PURE__ */ new Date()).toISOString(),
        ends: (/* @__PURE__ */ new Date()).toISOString(),
        time_zone_id: "UTC",
        reason: (_a = event == null ? void 0 : event.subject) != null ? _a : null
      },
      integration: {
        event_id: event.id,
        event_updated: (/* @__PURE__ */ new Date()).toISOString(),
        ical_id: (_b = event.iCalUId) != null ? _b : event.id,
        url: (_c = event == null ? void 0 : event.webLink) != null ? _c : "removed-event",
        event,
        is_deleted: isDeleted
      }
    };
  }
  transformOOO(event) {
    var _a, _b, _c, _d, _e;
    if (!event.showAs || !_MicrosoftCalendarTransformer.SHOW_AS_OOOs.includes(event.showAs) || !event.start || !event.start.dateTime || !event.start.timeZone || event.start.timeZone !== "UTC" || !event.end || !event.end.dateTime || !event.end.timeZone || event.end.timeZone !== "UTC") {
      return null;
    }
    const lengthMinutes = (parseISO3(event.end.dateTime).getTime() - parseISO3(event.start.dateTime).getTime()) / (60 * 1e3);
    if (lengthMinutes < _MicrosoftCalendarTransformer.MINIMUM_OOO_EVENT_LENGTH_MINUTES) {
      return null;
    }
    if (event.showAs === "workingElsewhere" && !_MicrosoftCalendarTransformer.WORKING_ELSEWHERE_POLICY_TYPE_ENABLED.includes(((_a = event.subject) != null ? _a : "").trim().toLowerCase())) {
      return null;
    }
    const policyType = _MicrosoftCalendarTransformer.convertLeavePolicyType(
      (_b = event.categories) != null ? _b : [],
      (_c = event.subject) != null ? _c : null
    );
    if (policyType === null) {
      return null;
    }
    const isDeleted = "@removed" in event, startTimeUtc = _MicrosoftCalendarTransformer.convertMicrosoftTimeToTacticTime(
      event.start.dateTime
    ), endTimeUtc = _MicrosoftCalendarTransformer.convertMicrosoftTimeToTacticTime(
      event.end.dateTime
    );
    const leaveRequest = {
      use: {
        policy_type: policyType,
        starts: startTimeUtc,
        ends: endTimeUtc,
        time_zone_id: "UTC",
        reason: (_d = event.subject) != null ? _d : null
      },
      integration: {
        event_id: event.id,
        event_updated: _MicrosoftCalendarTransformer.convertMicrosoftTimeToTacticTime(
          event.lastModifiedDateTime
        ),
        ical_id: (_e = event.iCalUId) != null ? _e : event.id,
        // @TODO iCalUId is not defined in Event
        url: event.webLink,
        event,
        is_deleted: isDeleted
      }
    };
    return leaveRequest;
  }
  static generateMetadata(scheduleId, eventId, calendar) {
    const metadata = { tacticEventId: eventId }, metadataCalendarId = calendar.id.replace(/\-/g, "_"), scheduleKey = `tactic_schedule_${metadataCalendarId}`;
    metadata["tacticEventId"] = eventId != null ? eventId : "";
    metadata["tacticScheduleId"] = scheduleId;
    metadata[scheduleKey] = scheduleId;
    return __spreadValues({
      "@odata.type": "microsoft.graph.openTypeExtension",
      extensionName: _MicrosoftCalendarTransformer.EXTENSION_NAME
    }, metadata);
  }
  static tryGetScheduleId(calendarId, event) {
    const metadata = _MicrosoftCalendarTransformer.tryGetMetadata(event);
    if (metadata === null) {
      return null;
    }
    const metadataCalendarId = calendarId.replace(/\-/g, "_"), scheduleKey = `tactic_schedule_${metadataCalendarId}`;
    return scheduleKey in metadata ? metadata[scheduleKey] : "tacticScheduleId" in metadata ? metadata["tacticScheduleId"] : "scheduleId" in metadata ? metadata["scheduleId"] : null;
  }
  static tryGetEventId(calendarId, event) {
    const metadata = _MicrosoftCalendarTransformer.tryGetMetadata(event);
    return metadata !== null && "tacticEventId" in metadata ? metadata["tacticEventId"] : null;
  }
  static tryGetMetadata(event) {
    if (!!event.extensions && event.extensions.length > 0) {
      for (let i = 0, limiti = event.extensions.length; i < limiti; i++) {
        const extension = event.extensions[i];
        if (
          // @ts-expect-error Not defined in typescript type, but valid, see https://learn.microsoft.com/en-us/graph/api/opentypeextension-post-opentypeextension
          extension.extensionName === _MicrosoftCalendarTransformer.EXTENSION_NAME
        ) {
          const metadata = {};
          for (const key in extension) {
            if (key !== "extensionName" && key !== "@odata.type") {
              metadata[key] = extension[key];
            }
          }
          return metadata;
        }
      }
    }
    return null;
  }
  createScheduleRequest(calendarId, event, originalEvent) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    if (!event || !event.id || !event.start || !event.start.dateTime || !event.end || !event.end.dateTime || !event.organizer || !event.organizer.emailAddress || !event.organizer.emailAddress.address) {
      throw new Error("Missing required event parameters");
    }
    const organizerEmail = event.organizer.emailAddress.address.toLowerCase(), organizerName = (_a = event.organizer.emailAddress.name) != null ? _a : null;
    const attendees = [], humanAttendees = [];
    const attendeesByEmail = {};
    const resourceAttendees = [];
    let organizerIsNonHuman = false;
    for (const attendee of (_b = event.attendees) != null ? _b : []) {
      if (!attendee.emailAddress || !attendee.emailAddress.address || attendee.emailAddress.address.indexOf("@") === -1) {
        continue;
      }
      const attendeeEmail = attendee.emailAddress.address.toLowerCase(), attendeeName = (_c = attendee.emailAddress.name) != null ? _c : null;
      const attendeeIsNonHumanResource = "resource" === attendee.type || calendarId === attendeeEmail;
      if (attendeeIsNonHumanResource) {
        resourceAttendees.push({
          email: attendeeEmail,
          name: attendeeName,
          presence_status: PRESENCE_STATUS_ACCEPTED,
          presence_type: null,
          user_id: null
        });
      }
      if (attendeeIsNonHumanResource && organizerEmail === attendeeEmail) {
        organizerIsNonHuman = true;
      }
      if (this.settings.removeNonHumanAttendees && attendeeIsNonHumanResource) {
        continue;
      }
      const attendeeRequest = {
        email: attendeeEmail,
        name: attendeeName,
        presence_status: attendee.status && attendee.status.response ? _MicrosoftCalendarTransformer.PRESENCE_STATUS_MAP[attendee.status.response] : PRESENCE_STATUS_PENDING,
        presence_type: null,
        user_id: null
      };
      attendees.push(attendeeRequest);
      if (!attendeeIsNonHumanResource) {
        humanAttendees.push(attendeeRequest);
      }
      attendeesByEmail[attendeeRequest.email] = attendeeRequest;
    }
    if (resourceAttendees.length === 0 && !!event.locations && event.locations.length > 0) {
      for (const location of event.locations) {
        if (!!location.uniqueId && location.uniqueId.indexOf("@") >= 0 && !!location.locationType && location.locationType === "conferenceRoom") {
          resourceAttendees.push({
            email: location.uniqueId.toLowerCase(),
            name: !!location.displayName ? location.displayName : location.uniqueId,
            presence_status: PRESENCE_STATUS_ACCEPTED,
            presence_type: null,
            user_id: null
          });
        }
      }
    }
    if (!organizerIsNonHuman && organizerEmail.indexOf("@") === -1) {
      organizerIsNonHuman = true;
    }
    if (organizerIsNonHuman && humanAttendees.length === 0) {
      return null;
    }
    if (attendees.length === 0) {
      if (!organizerIsNonHuman) {
        attendeesByEmail[organizerEmail] = {
          email: organizerEmail,
          name: organizerName != null ? organizerName : null,
          presence_status: PRESENCE_STATUS_ACCEPTED,
          presence_type: null,
          user_id: null
        };
        attendees.push(attendeesByEmail[organizerEmail]);
      } else if (humanAttendees.length > 0) {
        attendees.push(humanAttendees[0]);
      }
    }
    const humanOrganizerEmail = organizerIsNonHuman ? humanAttendees[0].email : organizerEmail;
    if (!attendeesByEmail[humanOrganizerEmail]) {
      attendeesByEmail[humanOrganizerEmail] = {
        email: humanOrganizerEmail,
        name: null,
        presence_status: PRESENCE_STATUS_ACCEPTED,
        presence_type: null,
        user_id: null
      };
    }
    const startTime = _MicrosoftCalendarTransformer.convertMicrosoftTimeToTacticTime(
      event.start.dateTime
    ), endTime = _MicrosoftCalendarTransformer.convertMicrosoftTimeToTacticTime(
      event.end.dateTime
    ), timeZone = findIana(event.start.timeZone)[0];
    const isDeleted = "@removed" in event, recurringTask = event.recurrence ? _MicrosoftCalendarTransformer.convertPatternToRecurringTask(
      event.recurrence,
      timeZone,
      endTime
    ) : null;
    const scheduleId = _MicrosoftCalendarTransformer.tryGetScheduleId(
      calendarId,
      event
    );
    const scheduleRequest = {
      creator: attendeesByEmail[humanOrganizerEmail],
      organizer: attendeesByEmail[humanOrganizerEmail],
      attendees,
      start: startTime,
      original_start: startTime,
      end: endTime,
      time_zone: timeZone,
      recurring: recurringTask,
      title: (_d = event.subject) != null ? _d : null,
      description: (_f = (_e = event.body) == null ? void 0 : _e.content.trim()) != null ? _f : null,
      visibility: event.sensitivity ? _MicrosoftCalendarTransformer.VISIBILITY_MAP[event.sensitivity] : VISIBILITY_PUBLIC,
      integration: {
        schedule_id: scheduleId,
        event_id: event.id,
        event_updated: _MicrosoftCalendarTransformer.convertMicrosoftTimeToTacticTime(
          event.lastModifiedDateTime
        ),
        ical_id: null !== originalEvent ? (_g = originalEvent.iCalUId) != null ? _g : originalEvent.id : (_h = event.iCalUId) != null ? _h : event.id,
        // @TODO iCalUId is not defined in Event
        url: (_i = event.webLink) != null ? _i : null,
        event: originalEvent !== null ? originalEvent : event,
        is_deleted: isDeleted,
        resource_attendees: resourceAttendees
      }
    };
    return scheduleRequest;
  }
  static convertLeavePolicyType(categories, subject) {
    if (categories.length === 0 && (subject === null || subject.trim() === "")) {
      return null;
    }
    const subjectLower = subject !== null ? subject.trim().toLowerCase() : null;
    let leavePolicyType = null;
    if (subjectLower !== null && subjectLower in _MicrosoftCalendarTransformer.LEAVE_POLICY_TYPE_MAP) {
      leavePolicyType = _MicrosoftCalendarTransformer.LEAVE_POLICY_TYPE_MAP[subjectLower];
    } else if (categories.length > 0) {
      for (const category of categories) {
        const categoryLower = category.trim().toLowerCase();
        if (categoryLower in _MicrosoftCalendarTransformer.LEAVE_POLICY_TYPE_MAP) {
          leavePolicyType = _MicrosoftCalendarTransformer.LEAVE_POLICY_TYPE_MAP[categoryLower];
          break;
        }
      }
    } else {
      return "remote";
    }
    return leavePolicyType;
  }
  static convertMicrosoftTimeToTacticTime(time) {
    return time.substring(0, time.lastIndexOf(".")) + "Z";
  }
  static getTimeWithoutZ(date) {
    return date.charAt(date.length - 1) === "Z" ? date.slice(0, -1) : date;
  }
  static convertTimeZone(timeZoneId) {
    const timeZoneResult = findWindows(timeZoneId);
    if (timeZoneResult && timeZoneResult.length === 0) {
      return null;
    }
    return timeZoneResult;
  }
  /**
   * Converts a Microsoft recurrence pattern into an RRULE
   * Conversion based off of these pages:
   *     https://datatracker.ietf.org/doc/html/rfc5545
   *     https://github.com/microsoftgraph/microsoft-graph-docs/blob/main/concepts/outlook-schedule-recurring-events.md
   *     https://docs.microsoft.com/en-us/graph/api/resources/patternedrecurrence?view=graph-rest-1.0
   *
   * @param recurrence - Recurrence pattern from the Microsoft event
   * @returns An RRULE that contains the data specified in the recurrence pattern
   */
  static convertPatternToRecurringTask(recurrence, timeZone, scheduleEnd) {
    function convertDay(day) {
      return day.substring(0, 2).toUpperCase();
    }
    function convertDaysOfWeek(days, index) {
      return days.map((day) => `${index}${convertDay(day)}`).join(",");
    }
    if (recurrence == null || recurrence.pattern == null || !("type" in recurrence.pattern) || // Recurring with no occurrences
    !!recurrence.range && recurrence.range.numberOfOccurrences !== void 0 && !!recurrence.range.type && recurrence.range.type === "endDate" && !!recurrence.range.startDate && !!recurrence.range.endDate && recurrence.range.startDate === recurrence.range.endDate && recurrence.range.numberOfOccurrences === 0) {
      return null;
    }
    const rrule = {};
    switch (recurrence.pattern.type) {
      case "daily": {
        rrule["FREQ"] = "DAILY";
        rrule["INTERVAL"] = recurrence.pattern.interval;
        break;
      }
      case "weekly": {
        rrule["FREQ"] = "WEEKLY";
        rrule["INTERVAL"] = recurrence.pattern.interval;
        rrule["BYDAY"] = convertDaysOfWeek(recurrence.pattern.daysOfWeek, "");
        rrule["WKST"] = convertDay(recurrence.pattern.firstDayOfWeek);
        break;
      }
      case "absoluteMonthly": {
        rrule["FREQ"] = "MONTHLY";
        rrule["INTERVAL"] = recurrence.pattern.interval;
        rrule["BYMONTHDAY"] = recurrence.pattern.dayOfMonth;
        break;
      }
      case "relativeMonthly": {
        rrule["FREQ"] = "MONTHLY";
        rrule["INTERVAL"] = recurrence.pattern.interval;
        rrule["BYDAY"] = convertDaysOfWeek(
          recurrence.pattern.daysOfWeek,
          recurrence.pattern.index ? _MicrosoftCalendarTransformer.RRULE_SET_POS_MAP[recurrence.pattern.index] : ""
        );
        break;
      }
      case "absoluteYearly": {
        rrule["FREQ"] = "YEARLY";
        rrule["INTERVAL"] = recurrence.pattern.interval;
        rrule["BYMONTH"] = recurrence.pattern.month;
        rrule["BYMONTHDAY"] = recurrence.pattern.dayOfMonth;
        break;
      }
      case "relativeYearly": {
        rrule["FREQ"] = "YEARLY";
        rrule["INTERVAL"] = recurrence.pattern.interval;
        rrule["BYDAY"] = convertDaysOfWeek(
          recurrence.pattern.daysOfWeek,
          recurrence.pattern.index ? _MicrosoftCalendarTransformer.RRULE_SET_POS_MAP[recurrence.pattern.index] : ""
        );
        rrule["BYMONTH"] = recurrence.pattern.month;
        break;
      }
    }
    let recurrenceStart = null, recurrenceEnd = null;
    if (recurrence.range != null && "type" in recurrence.range) {
      switch (recurrence.range.type) {
        case "numbered": {
          rrule["COUNT"] = recurrence.range.numberOfOccurrences;
          break;
        }
        case "endDate": {
          const endTime = scheduleEnd.split("T")[1];
          rrule["UNTIL"] = `${recurrence.range.endDate.replace(/-/g, "")}T${endTime.replace(/:/g, "")}`;
          if (!!recurrence.range.startDate) {
            recurrenceStart = `${recurrence.range.startDate}T${endTime}`;
          }
          recurrenceEnd = `${recurrence.range.endDate}T${endTime}`;
          break;
        }
      }
    }
    const rruleString = [
      Object.keys(rrule).map((key) => `${key}=${rrule[key]}`).join(";")
    ];
    const task = { rrules: rruleString };
    if (recurrenceStart || recurrenceEnd) {
      task.start = recurrenceStart;
      task.end = recurrenceEnd;
      task.time_zone = timeZone;
    }
    return task;
  }
};
_MicrosoftCalendarTransformer.EXTENSION_NAME = "com.gettactic.calendar.sync";
_MicrosoftCalendarTransformer.SHOW_AS_OOOs = ["oof", "workingElsewhere"];
_MicrosoftCalendarTransformer.WORKING_ELSEWHERE_POLICY_TYPE_ENABLED = ["home office"];
_MicrosoftCalendarTransformer.MINIMUM_OOO_EVENT_LENGTH_MINUTES = 6 * 60;
_MicrosoftCalendarTransformer.LEAVE_POLICY_TYPE_MAP = {
  feiertag: "holiday",
  freizeit: "custom",
  holiday: "holiday",
  "home office": "remote",
  ooo: "ooo",
  "public holiday": "holiday",
  travel: "remote",
  urlaub: "vacation",
  vacation: "vacation"
};
_MicrosoftCalendarTransformer.PRESENCE_STATUS_MAP = {
  needsAction: PRESENCE_STATUS_PENDING,
  declined: PRESENCE_STATUS_REJECTED,
  organizer: PRESENCE_STATUS_ACCEPTED,
  tentative: PRESENCE_STATUS_ACCEPTED,
  tentativelyAccepted: PRESENCE_STATUS_ACCEPTED,
  accepted: PRESENCE_STATUS_ACCEPTED,
  notResponded: PRESENCE_STATUS_PENDING,
  none: PRESENCE_STATUS_ACCEPTED
};
_MicrosoftCalendarTransformer.PRESENCE_STATUS_MAP_REVERSED = {
  pending: "notResponded",
  rejected: "declined",
  accepted: "accepted"
};
_MicrosoftCalendarTransformer.VISIBILITY_MAP = {
  confidential: VISIBILITY_CONFIDENTIAL,
  default: VISIBILITY_PUBLIC,
  normal: VISIBILITY_PUBLIC,
  personal: VISIBILITY_PRIVATE,
  private: VISIBILITY_PRIVATE
};
_MicrosoftCalendarTransformer.VISIBILITY_MAP_REVERSED = {
  confidential: "confidential",
  public: "normal",
  private: "private"
};
_MicrosoftCalendarTransformer.RRULE_SET_POS_MAP = {
  first: "1",
  second: "2",
  third: "3",
  fourth: "4",
  last: "-1"
};
var MicrosoftCalendarTransformer = _MicrosoftCalendarTransformer;

// src/entities/user.ts
var UserRolesLabels = {
  owner: { label: "Admin", description: "" },
  member: { label: "Member", description: "" },
  scheduler: {
    label: "Scheduler",
    description: "Enables the user to create reservations on behalf of others"
  },
  resource_manager: {
    label: "Resource Manager",
    description: "Enable the user to manage workspaces in specific offices, floors, or zones"
  },
  team_manager: {
    label: "Team Manager",
    description: "Enable the user to manage other teams"
  },
  page_manager: {
    label: "Page Manager",
    description: "Enable the user to manage pages"
  }
};

// src/types/api-types.ts
var WL_PRESENCE_OFFICE = "office";
var WL_PRESENCE_REMOTE = "remote";
var WL_PRESENCE_OOO = "out_of_office";
var WL_NOT_AVAILABLE = "not_available";
var DATE_FORMAT_STYLE_YMD = "ymd";
var DATE_FORMAT_STYLE_DMY = "dmy";
var DATE_FORMAT_STYLE_MDY = "mdy";

// src/utils/resource-utils.ts
function isParking(res) {
  return ["parking_space", "parking_lot"].includes(res.type);
}

// src/utils/restriction-utils.ts
function sortRestrictions(restrictions, resId = null) {
  var _a, _b, _c;
  const weekDayRestrictions = [];
  const ruleRestrictions = /* @__PURE__ */ new Map();
  const officeHours = restrictions.filter(
    (x) => !!x.office_hour && x.error === "office_hours_not_available"
  );
  for (const day of ALL_WEEK_DAYS) {
    const dayRestriction = officeHours.find(
      (x) => {
        var _a2, _b2, _c2;
        return ((_a2 = x.office_hour) == null ? void 0 : _a2.type) === "weekday" && ((_c2 = (_b2 = x.office_hour) == null ? void 0 : _b2.days) == null ? void 0 : _c2.includes(day));
      }
    );
    if (dayRestriction) {
      weekDayRestrictions.push(dayRestriction);
    }
  }
  for (const restriction of officeHours) {
    if (((_a = restriction.office_hour) == null ? void 0 : _a.type) === "rule" && ((_b = restriction.office_hour) == null ? void 0 : _b.id)) {
      ruleRestrictions.set((_c = restriction.office_hour) == null ? void 0 : _c.id, restriction);
    }
  }
  return [
    ...weekDayRestrictions,
    ...Array.from(ruleRestrictions.values()),
    ...restrictions.filter(
      (x) => x.error !== "office_hours_not_available" && x.resource_id === resId
    )
  ];
}

// src/utils/schedule-utils.ts
function getScheduleResources(schedule) {
  const resourceMap = {};
  schedule.slots.forEach((slot) => {
    resourceMap[slot.resource.id] = slot.resource;
  });
  return resourceMap;
}

// src/entities/integrations/integration_type.ts
var IntegrationType = /* @__PURE__ */ ((IntegrationType2) => {
  IntegrationType2["GOOGLE"] = "google";
  IntegrationType2["GOOGLE_APP"] = "google-app";
  IntegrationType2["MICROSOFT"] = "microsoft";
  IntegrationType2["MICROSOFT_APP"] = "microsoft-app";
  IntegrationType2["ZOOM"] = "zoom";
  IntegrationType2["SLACK"] = "slack";
  IntegrationType2["MICROSOFT_TEAMS"] = "microsoft-teams";
  IntegrationType2["FRESHWATER"] = "freshwater";
  IntegrationType2["TACTIC_WIFI"] = "tactic-wifi";
  IntegrationType2["TACTIC_MOBILE"] = "tactic-mobile";
  return IntegrationType2;
})(IntegrationType || {});

// src/utils/datetime.ts
import { format as format6, parse, parseISO as parseISO4 } from "date-fns";
function cover24Hours(start, end) {
  return format6(start, "hh:mm aa") === "12:00 AM" && format6(end, "hh:mm aa") === "11:59 PM";
}
function parseTimeOnly(d) {
  return parse(d, "HH:mm:ss.SSS", /* @__PURE__ */ new Date());
}
function prettyTimeOnly(d) {
  return format6(parseTimeOnly(d), "hh:mm aa");
}
function parseDateOnlyString(date) {
  const localizeDate = date.replace("Z", "");
  return parseISO4(localizeDate);
}
function prettifyDateOnlyString(apiDate, showYear = false) {
  const parsed = parseDateOnlyString(apiDate);
  return format6(parsed, showYear ? "MMM d, yyyy" : "LLL d");
}
function prettifyDateOnlyStringTemplate(apiDate, template) {
  const parsed = parseDateOnlyString(apiDate);
  return format6(parsed, template);
}

// src/utils/defaultReservationTimeSettings.ts
var DEFAULT_TIME_SETTINGS = {
  start_hour: 9,
  start_minutes: 0,
  end_minutes: 0,
  end_hour: 17,
  meeting_room_duration: 1,
  desk_duration: 8
};
export {
  ACTIVITY_ENTITIES,
  ACTIVITY_ENTITIES_ACTIONS,
  ALL_LEAVE_POLICY_TYPES,
  ALL_WEEK_DAYS,
  AVIGILON_REGIONS,
  ApiClientError,
  AvigilonClient,
  CORE_INTEGRATIONS_BASE_PATH,
  CalendarAuth,
  CalendarSource,
  CalendarType,
  Client,
  CoreIntegrationTypes,
  CoreIntegrations,
  DATE_FORMAT_STYLE_DMY,
  DATE_FORMAT_STYLE_MDY,
  DATE_FORMAT_STYLE_YMD,
  DEFAULT_EXCLUDE_SENTRY_STATUS_CODES,
  DEFAULT_TACTIC_API_URL,
  DEFAULT_TACTIC_AUTH_HEADER,
  DEFAULT_TACTIC_DEFAULT_PROTOCOL,
  DEFAULT_TACTIC_DOMAIN_AND_PORT,
  DEFAULT_TIME_SETTINGS,
  Enterprises,
  Externals,
  Forms,
  GoogleCalendarTransformer,
  IntegrationType,
  Integrations,
  Invitations,
  LeavePolicyTypeDisplay,
  MicrosoftCalendarTransformer,
  Organizations,
  PRESENCE_STATUS_ACCEPTED,
  PRESENCE_STATUS_PENDING,
  PRESENCE_STATUS_REJECTED,
  PRESENCE_TYPE_IN_PERSON,
  PRESENCE_TYPE_OOO,
  PRESENCE_TYPE_REMOTE,
  Pages,
  Reports,
  ResponseWithStatus,
  STATION_TYPE_ROOM,
  STATION_TYPE_VISITOR,
  Schedules,
  Signups,
  TacticApiClient,
  Uploads,
  UserPropertyType,
  UserRolesLabels,
  Users,
  VISIBILITY_CONFIDENTIAL,
  VISIBILITY_PRIVATE,
  VISIBILITY_PUBLIC,
  WL_NOT_AVAILABLE,
  WL_PRESENCE_OFFICE,
  WL_PRESENCE_OOO,
  WL_PRESENCE_REMOTE,
  cover24Hours,
  formatOptions,
  getScheduleResources,
  initApi,
  isParking,
  parseDateOnlyString,
  parseTimeOnly,
  prettifyDateOnlyString,
  prettifyDateOnlyStringTemplate,
  prettyTimeOnly,
  sortRestrictions
};
//! TODO: REMOVE THIS VARIABLE, IS TO PREVENT TS CHECK ERRORS
//! TODO: REMOVE MOCK
//# sourceMappingURL=index.mjs.map